import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, Component, Input, NgModule, inject, ChangeDetectionStrategy, EventEmitter, Output, CUSTOM_ELEMENTS_SCHEMA, forwardRef, APP_INITIALIZER } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpBackend, HttpParams, HttpContextToken, HttpErrorResponse, HttpResponse, provideHttpClient, withInterceptors } from '@angular/common/http';
import * as i2 from '@ngx-translate/core';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { map, of, catchError, BehaviorSubject, first, take, lastValueFrom, tap, firstValueFrom, Observable } from 'rxjs';
import * as i1$1 from '@angular/router';
import { RouterLink, RouterModule, NavigationEnd } from '@angular/router';
import * as i3 from '@angular/common';
import { NgClass, CommonModule } from '@angular/common';
import { ItNotificationService, ItModalComponent, ItInputComponent, ItPaginationComponent, ItChipComponent, ItBreadcrumbComponent, ItBreadcrumbItemComponent, ItCardComponent, ItSelectComponent, provideDesignAngularKit, ItTooltipDirective } from 'design-angular-kit';
import * as i2$1 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import * as XLSX from 'xlsx';
import { tap as tap$1 } from 'rxjs/operators';

// Creazione dell'InjectionToken per l'ambiente
const _c0 = ["*"];
const _c1 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11) => ({
  primary: a0,
  secondary: a1,
  danger: a2,
  success: a3,
  "primary-outlined": a4,
  "secondary-outlined": a5,
  "danger-outlined": a6,
  "success-outlined": a7,
  large: a8,
  small: a9,
  mini: a10,
  disabled: a11
});
const _c2 = ".index[_ngcontent-%COMP%]{height:calc(100vh - 120px);width:100%!important}";
function AsideComponent_div_5_For_2_For_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 9);
    i0.ɵɵlistener("click", function AsideComponent_div_5_For_2_For_7_Conditional_0_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const sottomodulo_r5 = i0.ɵɵnextContext().$implicit;
      const modulo_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.goTo(modulo_r2, sottomodulo_r5));
    })("keydown", function AsideComponent_div_5_For_2_For_7_Conditional_0_Template_div_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const modulo_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleKeyDown($event, modulo_r2));
    });
    i0.ɵɵelementStart(2, "span", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const sottomodulo_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(sottomodulo_r5.name);
  }
}
function AsideComponent_div_5_For_2_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AsideComponent_div_5_For_2_For_7_Conditional_0_Template, 4, 1, "div", 5);
  }
  if (rf & 2) {
    const sottomodulo_r5 = ctx.$implicit;
    i0.ɵɵconditional(sottomodulo_r5.url !== null && sottomodulo_r5.url !== "" ? 0 : -1);
  }
}
function AsideComponent_div_5_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵlistener("click", function AsideComponent_div_5_For_2_Template_div_click_1_listener() {
      const modulo_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.goTo(modulo_r2));
    })("keydown", function AsideComponent_div_5_For_2_Template_div_keydown_1_listener($event) {
      const modulo_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleKeyDown($event, modulo_r2));
    });
    i0.ɵɵelementStart(2, "i", 7);
    i0.ɵɵtext(3, "inventory_2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
    i0.ɵɵrepeaterCreate(6, AsideComponent_div_5_For_2_For_7_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const modulo_r2 = ctx.$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(modulo_r2.name);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(modulo_r2.subModulesList);
  }
}
function AsideComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵrepeaterCreate(1, AsideComponent_div_5_For_2_Template, 8, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const moduli_r6 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(moduli_r6);
  }
}
const _c3 = a0 => ({
  "text-primary fw-semibold": a0
});
function HeaderComponent_Conditional_2_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "button", 16);
    i0.ɵɵlistener("click", function HeaderComponent_Conditional_2_div_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      i0.ɵɵnextContext(2);
      const leftModal_r3 = i0.ɵɵreference(11);
      return i0.ɵɵresetView(leftModal_r3 == null ? null : leftModal_r3.toggle());
    });
    i0.ɵɵelementStart(2, "i", 17);
    i0.ɵɵtext(3, "menu");
    i0.ɵɵelementEnd()()();
  }
}
function HeaderComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderComponent_Conditional_2_div_0_Template, 4, 0, "div", 15);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r3.login);
  }
}
function HeaderComponent_Conditional_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.selectedRole.description !== null && ctx_r3.selectedRole.description !== "" ? ctx_r3.selectedRole.description : ctx_r3.selectedRole.name, " ");
  }
}
function HeaderComponent_Conditional_9_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.email);
  }
}
function HeaderComponent_Conditional_9_div_22_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 41);
    i0.ɵɵtext(1, "check_circle");
    i0.ɵɵelementEnd();
  }
}
function HeaderComponent_Conditional_9_div_22_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 39)(1, "div", 40);
    i0.ɵɵtemplate(2, HeaderComponent_Conditional_9_div_22_For_2_Conditional_2_Template, 2, 0, "i", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 42);
    i0.ɵɵlistener("click", function HeaderComponent_Conditional_9_div_22_For_2_Template_button_click_3_listener() {
      const role_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.selectRole(role_r7));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const role_r7 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(role_r7.name == (ctx_r3.selectedRole == null ? null : ctx_r3.selectedRole.name) ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, role_r7.name == (ctx_r3.selectedRole == null ? null : ctx_r3.selectedRole.name)));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", role_r7.description !== null && role_r7.description !== "" ? role_r7.description : role_r7.name, " ");
  }
}
function HeaderComponent_Conditional_9_div_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵrepeaterCreate(1, HeaderComponent_Conditional_9_div_22_For_2_Template, 5, 5, "li", 39, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const roles_r8 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(roles_r8);
  }
}
function HeaderComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, HeaderComponent_Conditional_9_Conditional_1_Template, 2, 1, "span", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 20)(3, "button", 21)(4, "div", 22)(5, "div", 23)(6, "span", 24);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 25)(9, "span", 26);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 27)(12, "span", 28);
    i0.ɵɵtext(13, "Opzioni");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "i", 29);
    i0.ɵɵtext(15, "arrow_drop_down");
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(16, "ul", 30)(17, "li", 31);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, HeaderComponent_Conditional_9_Conditional_19_Template, 2, 1, "li", 31);
    i0.ɵɵelementStart(20, "li", 32);
    i0.ɵɵtext(21, "Cambia ruolo:");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, HeaderComponent_Conditional_9_div_22_Template, 3, 0, "div", 33);
    i0.ɵɵpipe(23, "async");
    i0.ɵɵelementStart(24, "li", 34)(25, "button", 35);
    i0.ɵɵlistener("click", function HeaderComponent_Conditional_9_Template_button_click_25_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.logoutService.logoutStatus());
    });
    i0.ɵɵelementStart(26, "i", 36);
    i0.ɵɵtext(27, "logout");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "span", 37);
    i0.ɵɵtext(29, "Esci");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.selectedRole ? 1 : -1);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r3.getInitials(ctx_r3.nameSurname));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.nameSurname);
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r3.nameSurname);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.email && ctx_r3.email !== "" ? 19 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(23, 6, ctx_r3.roles$));
  }
}
function HeaderComponent_div_18_For_2_For_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43)(1, "div", 47)(2, "span", 48);
    i0.ɵɵlistener("click", function HeaderComponent_div_18_For_2_For_7_Conditional_0_Template_span_click_2_listener() {
      i0.ɵɵrestoreView(_r11);
      const sottomodulo_r12 = i0.ɵɵnextContext().$implicit;
      const modulo_r10 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.goTo(modulo_r10, sottomodulo_r12));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const sottomodulo_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(sottomodulo_r12.name);
  }
}
function HeaderComponent_div_18_For_2_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderComponent_div_18_For_2_For_7_Conditional_0_Template, 4, 1, "div", 43);
  }
  if (rf & 2) {
    const sottomodulo_r12 = ctx.$implicit;
    i0.ɵɵconditional(sottomodulo_r12.url !== null && sottomodulo_r12.url !== "" ? 0 : -1);
  }
}
function HeaderComponent_div_18_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43)(1, "div", 44)(2, "i", 45);
    i0.ɵɵtext(3, "inventory_2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 46);
    i0.ɵɵlistener("click", function HeaderComponent_div_18_For_2_Template_span_click_4_listener() {
      const modulo_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.goTo(modulo_r10));
    });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
    i0.ɵɵrepeaterCreate(6, HeaderComponent_div_18_For_2_For_7_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const modulo_r10 = ctx.$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(modulo_r10.name);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(modulo_r10.subModulesList);
  }
}
function HeaderComponent_div_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵrepeaterCreate(1, HeaderComponent_div_18_For_2_Template, 8, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const modules_r13 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(modules_r13);
  }
}
function _forTrack0($index, $item) {
  return this.trackByFn;
}
function FilterModalComponent_For_8_Conditional_0_Template(rf, ctx) {}
function FilterModalComponent_For_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "it-input", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filtro_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", filtro_r1.nome)("placeholder", filtro_r1.nome)("label", filtro_r1.nome);
  }
}
function FilterModalComponent_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FilterModalComponent_For_8_Conditional_0_Template, 0, 0)(1, FilterModalComponent_For_8_Conditional_1_Template, 2, 3, "div", 9);
  }
  if (rf & 2) {
    const filtro_r1 = ctx.$implicit;
    i0.ɵɵconditional(filtro_r1.tipo == "check" ? 0 : 1);
  }
}
const _c4 = () => [10, 20, 30];
function TableComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "i", 9);
    i0.ɵɵtext(2, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 10);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r0.addPageSegments);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.addAction);
  }
}
function TableComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 11)(2, "i", 9);
    i0.ɵɵtext(3, "file_download");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 10);
    i0.ɵɵtext(5, "Esporta");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "ul", 12)(7, "li")(8, "a", 13);
    i0.ɵɵlistener("click", function TableComponent_Conditional_6_Template_a_click_8_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.exportToCSV());
    });
    i0.ɵɵtext(9, "Esporta in .csv");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "li")(11, "a", 13);
    i0.ɵɵlistener("click", function TableComponent_Conditional_6_Template_a_click_11_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.exportToExcel());
    });
    i0.ɵɵtext(12, "Esporta in .xlsx");
    i0.ɵɵelementEnd()()()();
  }
}
function TableComponent_Conditional_7_For_9_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "it-chip", 19);
    i0.ɵɵlistener("closeEvent", function TableComponent_Conditional_7_For_9_Conditional_0_Template_it_chip_closeEvent_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const filtro_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.filterRemove(filtro_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filtro_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("label", filtro_r4.nome + ": " + filtro_r4.valore)("showCloseButton", true);
  }
}
function TableComponent_Conditional_7_For_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableComponent_Conditional_7_For_9_Conditional_0_Template, 1, 2, "it-chip", 18);
  }
  if (rf & 2) {
    const filtro_r4 = ctx.$implicit;
    i0.ɵɵconditional(filtro_r4.valore !== "" ? 0 : -1);
  }
}
function TableComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 14)(2, "div", 15)(3, "i", 9);
    i0.ɵɵtext(4, "filter_alt");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 16);
    i0.ɵɵtext(6, "Filtra");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 17);
    i0.ɵɵrepeaterCreate(8, TableComponent_Conditional_7_For_9_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵrepeater(ctx_r0.filterList);
  }
}
function MultiButtonComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-button", 7);
    i0.ɵɵlistener("click", function MultiButtonComponent_Conditional_1_Template_app_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.buttonDo("save"));
    });
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵtext(2, "Salva");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "i", 8);
    i0.ɵɵtext(4, "save");
    i0.ɵɵelementEnd()();
  }
}
function MultiButtonComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-button", 2)(1, "span", 5);
    i0.ɵɵtext(2, "Salva");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "i", 9);
    i0.ɵɵtext(4, "save");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵproperty("disabled", "true");
  }
}
function MultiButtonComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-button", 10);
    i0.ɵɵlistener("click", function MultiButtonComponent_Conditional_3_Template_app_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.buttonDo("delete"));
    });
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵtext(2, "Elimina");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "i", 8);
    i0.ɵɵtext(4, "delete");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-bs-target", "#" + ctx_r1.deleteModal);
  }
}
function BreadcrumbComponent_it_breadcrumb_item_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "it-breadcrumb-item", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = ctx.$implicit;
    const last_r2 = ctx.last;
    i0.ɵɵproperty("href", breadcrumb_r1.url)("ariaCurrent", last_r2 ? "page" : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", breadcrumb_r1.label, " ");
  }
}
const _c5 = a0 => ({
  "font-size": a0
});
const _c6 = () => ({
  standalone: true
});
function CountrySelectComponent_div_1_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const country_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", country_r3.municipalityCode)("selected", country_r3.municipalityCode == ctx_r1.selectedValue);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", country_r3.municipalityName, " ");
  }
}
function CountrySelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "it-select", 2);
    i0.ɵɵtwoWayListener("ngModelChange", function CountrySelectComponent_div_1_Template_it_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedValue, $event) || (ctx_r1.selectedValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CountrySelectComponent_div_1_Template_it_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelectChange($event));
    });
    i0.ɵɵelementStart(2, "option", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CountrySelectComponent_div_1_option_4_Template, 2, 3, "option", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const countries_r4 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", ctx_r1.label);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedValue);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(7, _c6))("disabled", ctx_r1.isDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.placeholder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", countries_r4);
  }
}
function MunicipalitySelectComponent_div_1_div_1_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const municipality_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", municipality_r3.municipalityCode)("selected", municipality_r3.municipalityCode == ctx_r1.selectedValue);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.selectedProvince ? municipality_r3.municipalityName : municipality_r3.municipalityName + " (" + municipality_r3.province + ")", " ");
  }
}
function MunicipalitySelectComponent_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "it-select", 2);
    i0.ɵɵtwoWayListener("ngModelChange", function MunicipalitySelectComponent_div_1_div_1_Template_it_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedValue, $event) || (ctx_r1.selectedValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function MunicipalitySelectComponent_div_1_div_1_Template_it_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSelectChange($event));
    });
    i0.ɵɵelementStart(2, "option", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MunicipalitySelectComponent_div_1_div_1_option_4_Template, 2, 3, "option", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const municipalities_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("disabled", ctx_r1.disabled ? "true" : "false");
    i0.ɵɵproperty("label", ctx_r1.label);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedValue);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(8, _c6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", "")("selected", !ctx_r1.selectedValue || ctx_r1.selectedValue === "EE");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.placeholder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", municipalities_r4);
  }
}
function MunicipalitySelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MunicipalitySelectComponent_div_1_div_1_Template, 5, 9, "div", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const municipalities_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", municipalities_r4.length > 0);
  }
}
function MunicipalityInputComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " Il campo \xE8 obbligatorio. ");
    i0.ɵɵelementEnd();
  }
}
function MunicipalityInputComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (tmp_1_0 = ctx_r0.formGroup.get(ctx_r0.formControlName)) == null ? null : tmp_1_0.getError("invalidMunicipality"), " ");
  }
}
function MunicipalityInputComponent_div_5_div_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function MunicipalityInputComponent_div_5_div_1_button_1_Template_button_click_0_listener() {
      const municipality_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.selectMunicipality(municipality_r3));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const municipality_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", municipality_r3.municipalityName, " (", municipality_r3.province, ") ");
  }
}
function MunicipalityInputComponent_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, MunicipalityInputComponent_div_5_div_1_button_1_Template, 2, 2, "button", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filteredMunicipalities_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", filteredMunicipalities_r4);
  }
}
function MunicipalityInputComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MunicipalityInputComponent_div_5_div_1_Template, 2, 1, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filteredMunicipalities_r4 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", filteredMunicipalities_r4.length > 0 && ctx_r0.showDropdown);
  }
}
function ProvinceSelectComponent_div_1_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const province_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", province_r3.id)("selected", province_r3.id == ctx_r1.selectedValue);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", province_r3.name, " ");
  }
}
function ProvinceSelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "it-select", 2);
    i0.ɵɵlistener("ngModelChange", function ProvinceSelectComponent_div_1_Template_it_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelectChange($event));
    });
    i0.ɵɵelementStart(2, "option", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ProvinceSelectComponent_div_1_option_4_Template, 2, 3, "option", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const provinces_r4 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", ctx_r1.label)("ngModel", ctx_r1.selectedValue)("ngModelOptions", i0.ɵɵpureFunction0(7, _c6))("disabled", ctx_r1.isDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.placeholder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", provinces_r4);
  }
}
function EntitySelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "apss-select", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entities_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r1.getEntityOptions(entities_r1))("formControlName", ctx_r1.formControlName)("disabled", ctx_r1.disabled)("formGroup", ctx_r1.formGroup);
  }
}
function JobsSelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "apss-select", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const jobs_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r1.getJobOptions(jobs_r1))("formControlName", ctx_r1.formControlName)("disabled", ctx_r1.disabled)("formGroup", ctx_r1.formGroup);
  }
}
function ProfileSelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "apss-select", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const profiles_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r1.getProfileOptions(profiles_r1))("formControlName", ctx_r1.formControlName)("disabled", ctx_r1.disabled)("formGroup", ctx_r1.formGroup);
  }
}
function SitesSelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "apss-select", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const sites_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r1.getSiteOptions(sites_r1))("formControlName", ctx_r1.formControlName)("disabled", ctx_r1.disabled)("formGroup", ctx_r1.formGroup);
  }
}
function CountryComponent_div_0_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const country_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", country_r3.municipalityCode)("selected", country_r3.municipalityCode == ctx_r1.selectedCountry);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", country_r3.municipalityName, " ");
  }
}
function CountryComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "it-select", 1);
    i0.ɵɵtwoWayListener("ngModelChange", function CountryComponent_div_0_Template_it_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedCountry, $event) || (ctx_r1.selectedCountry = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CountryComponent_div_0_Template_it_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCountryChange($event));
    });
    i0.ɵɵelementStart(2, "option", 2);
    i0.ɵɵtext(3, "Seleziona un paese");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CountryComponent_div_0_option_4_Template, 2, 3, "option", 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const countries_r4 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedCountry);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(4, _c6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", countries_r4);
  }
}
function MunicipalityComponent_div_0_div_1_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const municipality_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", municipality_r3.municipalityCode)("selected", municipality_r3.municipalityCode == ctx_r1.selectedMunicipality);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", municipality_r3.municipalityName, " (", municipality_r3.province, ") ");
  }
}
function MunicipalityComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "it-select", 1);
    i0.ɵɵtwoWayListener("ngModelChange", function MunicipalityComponent_div_0_div_1_Template_it_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedPlace, $event) || (ctx_r1.selectedPlace = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function MunicipalityComponent_div_0_div_1_Template_it_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onMunicipalityChange($event));
    });
    i0.ɵɵelementStart(2, "option", 2);
    i0.ɵɵtext(3, "Seleziona un comune");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MunicipalityComponent_div_0_div_1_option_4_Template, 2, 4, "option", 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const municipalities_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedPlace);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(5, _c6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", "")("selected", ctx_r1.selectedPlace === "" || ctx_r1.selectedPlace === "EE");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", municipalities_r4);
  }
}
function MunicipalityComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MunicipalityComponent_div_0_div_1_Template, 5, 6, "div", 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const municipalities_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", municipalities_r4.length > 0);
  }
}
function NationalityComponent_div_0_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const country_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", country_r3.id)("selected", country_r3.id == ctx_r1.selectedNationality);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", country_r3.municipalityName, " ");
  }
}
function NationalityComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "it-select", 1);
    i0.ɵɵtwoWayListener("ngModelChange", function NationalityComponent_div_0_Template_it_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedNationality, $event) || (ctx_r1.selectedNationality = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function NationalityComponent_div_0_Template_it_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCountryChange($event));
    });
    i0.ɵɵelementStart(2, "option", 2);
    i0.ɵɵtext(3, "Seleziona una nazionalit\xE0");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NationalityComponent_div_0_option_4_Template, 2, 3, "option", 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const countries_r4 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedNationality);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(4, _c6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", countries_r4);
  }
}
function LocationComponent_div_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-nationality", 6);
    i0.ɵɵlistener("nationalityEmit", function LocationComponent_div_1_Conditional_1_Template_lib_nationality_nationalityEmit_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onNationalityChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectedNationality", (tmp_2_0 = ctx_r2.locationFormGroup.get("nationality")) == null ? null : tmp_2_0.value)("locationFormGroup", ctx_r2.locationFormGroup);
  }
}
function LocationComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, LocationComponent_div_1_Conditional_1_Template, 1, 2, "lib-nationality", 3);
    i0.ɵɵelementStart(2, "lib-country", 4);
    i0.ɵɵlistener("countriesEmit", function LocationComponent_div_1_Template_lib_country_countriesEmit_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onCountryChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div")(4, "lib-municipality", 5);
    i0.ɵɵlistener("selectedMunicipality", function LocationComponent_div_1_Template_lib_municipality_selectedMunicipality_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onMunicipalityChange($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_4_0;
    let tmp_5_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.nationality ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selectedCountry", (tmp_2_0 = ctx_r2.locationFormGroup.get("country")) == null ? null : tmp_2_0.value)("locationFormGroup", ctx_r2.locationFormGroup);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("display", ((tmp_4_0 = ctx_r2.locationFormGroup.get("country")) == null ? null : tmp_4_0.value) === "I" ? "block" : "none");
    i0.ɵɵadvance();
    i0.ɵɵproperty("selectedMunicipality", (tmp_5_0 = ctx_r2.locationFormGroup.get("municipality")) == null ? null : tmp_5_0.value);
  }
}
const _c7 = a0 => ({
  "is-invalid": a0
});
function CodiceFiscaleComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Il campo \xE8 obbligatorio.");
    i0.ɵɵelementEnd();
  }
}
function CodiceFiscaleComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.control.getError("invalidFiscalCode"), " ");
  }
}
const ENVIRONMENT = new InjectionToken('env');
class PolifunzioneLibService {
  constructor(http, env) {
    this.http = http;
    this.env = env;
  }
  getMicroservices(token) {
    const headers = new HttpHeaders({
      Authorization: token
    });
    return this.http.get(this.env.beUrl + 'portale-scanner/areas', {
      headers: headers,
      observe: 'response'
    });
  }
  getMacroAreas(token) {
    const headers = new HttpHeaders({
      Authorization: token
    });
    return this.http.get(this.env.beUrl + 'portale-scanner/macro-areas', {
      headers: headers,
      observe: 'response'
    });
  }
  callAlert(type, text) {}
  static {
    this.ɵfac = function PolifunzioneLibService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PolifunzioneLibService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ENVIRONMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PolifunzioneLibService,
      factory: PolifunzioneLibService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PolifunzioneLibService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }], null);
})();
class PolifunzioneLibComponent {
  constructor() {}
  ngOnInit() {}
  static {
    this.ɵfac = function PolifunzioneLibComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PolifunzioneLibComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PolifunzioneLibComponent,
      selectors: [["lib-polifunzione-lib"]],
      decls: 0,
      vars: 0,
      template: function PolifunzioneLibComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PolifunzioneLibComponent, [{
    type: Component,
    args: [{
      selector: 'lib-polifunzione-lib',
      template: ``
    }]
  }], () => [], null);
})();
class Location {
  constructor(nationality, municipality, country) {
    this.nationality = nationality;
    this.municipality = municipality;
    this.country = country;
  }
}
class Microservice {
  constructor(name, description, minAuth, link, macroArea, tag, version) {
    this.name = name;
    this.description = description;
    this.minAuth = minAuth;
    this.link = link;
    this.macroArea = macroArea;
    if (tag) {
      this.tag = tag;
    }
    if (version) {
      this.version = version;
    } else {
      this.version = '';
    }
  }
}

// import { Submodule } from './submodule.model';
class Module {
  constructor(name, url, minAuth, subModulesList) {
    this.name = name;
    this.url = url;
    this.minAuth = minAuth;
    this.subModulesList = subModulesList;
  }
}
class Role {
  constructor(name, description) {
    this.name = name;
    this.description = description;
  }
}
class ReturnedRole {
  constructor(name, description) {
    this.name = name;
    this.description = description;
  }
}
function provideDynamicTranslateLoader() {
  return (itPrefix, itSuffix) => ({
    provide: TranslateLoader,
    useFactory: http => new MultiTranslateHttpLoader(http, [{
      prefix: itPrefix,
      suffix: itSuffix
    }, {
      prefix: `${document.baseURI}assets/i18n/`,
      suffix: itSuffix
    }]),
    deps: [HttpBackend]
  });
}
function fiscalCodeValidator() {
  return control => {
    const fiscalCode = control.value?.toUpperCase().trim();
    const form = control.parent;
    const normalizedFiscalCode = normalizeOmocodia(fiscalCode);
    if (!normalizedFiscalCode) return null;
    if (normalizedFiscalCode.length !== 16) {
      return {
        invalidFiscalCode: 'Il codice fiscale deve essere lungo 16 caratteri'
      };
    }
    const validFormat = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;
    if (!validFormat.test(normalizedFiscalCode)) {
      return {
        invalidFiscalCode: 'Formato del codice fiscale non valido'
      };
    }
    if (form) {
      const firstName = form.get('name')?.value?.toUpperCase().replace(/[^A-Z]/g, '');
      const lastName = form.get('surname')?.value?.toUpperCase().replace(/[^A-Z]/g, '');
      if (firstName && lastName) {
        const expectedLastNameCode = extractConsonantCode(lastName);
        const expectedFirstNameCode = extractFirstNameCode(firstName);
        if (fiscalCode.substring(0, 3) !== expectedLastNameCode) {
          return {
            invalidFiscalCode: 'Il cognome nel codice fiscale non corrisponde'
          };
        }
        if (fiscalCode.substring(3, 6) !== expectedFirstNameCode) {
          return {
            invalidFiscalCode: 'Il nome nel codice fiscale non corrisponde'
          };
        }
      }
    }
    return null;
  };
}
function extractConsonantCode(name) {
  const consonants = name.replace(/[AEIOU]/g, '');
  return (consonants + 'XXX').substring(0, 3);
}
function extractFirstNameCode(name) {
  const consonants = name.replace(/[AEIOU]/g, '');
  if (consonants.length >= 4) {
    return consonants[0] + consonants[2] + consonants[3];
  }
  return (consonants + 'XXX').substring(0, 3);
}
const omocodiaMap = {
  L: '0',
  M: '1',
  N: '2',
  P: '3',
  Q: '4',
  R: '5',
  S: '6',
  T: '7',
  U: '8',
  V: '9'
};
const omocodiaIndexes = [6, 7, 9, 10, 12, 13, 14];
function normalizeOmocodia(cf) {
  return cf.split('').map((char, index) => {
    if (omocodiaIndexes.includes(index) && omocodiaMap[char]) {
      return omocodiaMap[char];
    }
    return char;
  }).join('');
}
class Municipality {
  constructor(id, municipalityCode, municipalityName, postalCode, cadastralCode, province, regionCode, healthUnitCode, validityStartDate, validityEndDate, euCountryFlag, foreignCountryFlag, districtCode, district, mmgScopeCode, mmgScope, plsScopeCode, plsScope) {
    this.id = id;
    this.municipalityCode = municipalityCode;
    this.municipalityName = municipalityName;
    this.postalCode = postalCode;
    this.cadastralCode = cadastralCode;
    this.province = province;
    this.regionCode = regionCode;
    this.healthUnitCode = healthUnitCode;
    this.validityStartDate = validityStartDate;
    this.validityEndDate = validityEndDate;
    this.euCountryFlag = euCountryFlag;
    this.foreignCountryFlag = foreignCountryFlag;
    this.districtCode = districtCode;
    this.district = district;
    this.mmgScopeCode = mmgScopeCode;
    this.mmgScope = mmgScope;
    this.plsScopeCode = plsScopeCode;
    this.plsScope = plsScope;
  }
}
class Country {
  constructor(id, municipalityCode, municipalityName, cadestralCode, foreignCountryFlag) {
    this.id = id;
    this.municipalityCode = municipalityCode;
    this.municipalityName = municipalityName;
    this.cadastralCode = cadestralCode;
    this.foreignCountryFlag = foreignCountryFlag;
  }
}
class Province {
  constructor(id, name, code) {
    this.id = id ?? '';
    this.name = name;
    this.code = code ?? '';
  }
}
class LocationService {
  constructor(http, env) {
    this.http = http;
    this.env = env;
  }
  getCountry() {
    return this.http.get(this.env.beUrl + 'commonutils/states', {
      observe: 'response'
    }).pipe(map(response => {
      console.debug('Countries Response:', response.body.data); // Logga la risposta
      return response.body.data.map(item => {
        return new Country(item.id, item.municipalityCode,
        // Questo probabilmente non è corretto per `Country`, verifica i dati
        item.municipalityName,
        // Verifica il campo giusto per il nome del paese
        item.cadastralCode, item.foreignCountryFlag);
      });
    }));
  }
  getMunicipality() {
    return this.http.get(this.env.beUrl + 'commonutils/municipalities', {
      observe: 'response'
    }).pipe(map(response => {
      console.debug('Municipalities Response:', response.body.data); // Logga la risposta
      return response.body.data.map(item => {
        return new Municipality(item.id, item.municipalityCode, item.municipalityName, item.postalCode, item.cadastralCode, item.province, item.regionCode, item.healthUnitCode, item.validityStartDate, item.validityEndDate, item.euCountryFlag, item.foreignCountryFlag, item.districtCode, item.district, item.mmgScopeCode, item.mmgScope, item.plsScopeCode, item.plsScope);
      });
    }));
  }
  getProvinces() {
    return this.http.get(this.env.beUrl + 'commonutils/provinces', {
      observe: 'response'
    }).pipe(map(response => {
      console.debug('Countries Response:', response.body.data); // Logga la risposta
      return response.body.data.map(item => {
        return new Province(item.id, item.name,
        // Questo probabilmente non è corretto per `Country`, verifica i dati
        item.code);
      });
    }));
  }
  getProvinceById(provinceId) {
    const params = new HttpParams().set('provinceId', provinceId);
    return this.http.get(this.env.beUrl + 'commonutils/provinces/provinceById', {
      params: params,
      observe: 'response'
    }).pipe(map(response => {
      console.debug('Countries Response:', response.body.data); // Logga la risposta
      return new Province(response.body.data.id, response.body.data.name, response.body.data.code);
    }));
  }
  getMunicipalityByLetters(letters) {
    const params = new HttpParams().set('name', letters);
    return this.http.get(this.env.beUrl + 'commonutils/municipalities/name', {
      params: params,
      observe: 'response',
      headers: {
        'X-Skip-Notification': 'true'
      }
    }).pipe(map(response => {
      console.debug('Municipalities Response:', response.body.data); // Logga la risposta
      return response.body.data.map(item => {
        return new Municipality(item.id, item.municipalityCode, item.municipalityName, item.postalCode, item.cadastralCode, item.province, item.regionCode, item.healthUnitCode, item.validityStartDate, item.validityEndDate, item.euCountryFlag, item.foreignCountryFlag, item.districtCode, item.district, item.mmgScopeCode, item.mmgScope, item.plsScopeCode, item.plsScope);
      });
    }));
  }
  getMunicipalityByMunicipalityCode(municipalityCode) {
    const params = new HttpParams().set('municipalityCode', municipalityCode);
    return this.http.get(this.env.beUrl + 'commonutils/municipalities/municipalityCode', {
      params: params,
      observe: 'response'
    }).pipe(map(response => {
      console.debug('Municipalities Response:', response.body.data); // Logga la risposta
      return response.body.data.map(item => {
        return new Municipality(item.id, item.municipalityCode, item.municipalityName, item.postalCode, item.cadastralCode, item.province, item.regionCode, item.healthUnitCode, item.validityStartDate, item.validityEndDate, item.euCountryFlag, item.foreignCountryFlag, item.districtCode, item.district, item.mmgScopeCode, item.mmgScope, item.plsScopeCode, item.plsScope);
      });
    }));
  }
  getMunicipalityByProvince(provinceTag) {
    const params = new HttpParams().set('province', provinceTag);
    return this.http.get(this.env.beUrl + 'commonutils/municipalities/province', {
      params: params,
      observe: 'response'
    }).pipe(map(response => {
      console.debug('Municipalities Response:', response.body.data); // Logga la risposta
      return response.body.data.map(item => {
        return new Municipality(item.id, item.municipalityCode, item.municipalityName, item.postalCode, item.cadastralCode, item.province, item.regionCode, item.healthUnitCode, item.validityStartDate, item.validityEndDate, item.euCountryFlag, item.foreignCountryFlag, item.districtCode, item.district, item.mmgScopeCode, item.mmgScope, item.plsScopeCode, item.plsScope);
      });
    }));
  }
  static {
    this.ɵfac = function LocationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LocationService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ENVIRONMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LocationService,
      factory: LocationService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }], null);
})();
class MunicipalityValidatorService {
  constructor(locationService) {
    this.locationService = locationService;
  }
  validateMunicipality() {
    return control => {
      const municipality = control.value;
      // Controlla se il valore è vuoto o nullo
      if (!municipality || municipality.trim() === '') {
        console.debug('valore municipality vuoto, ritorno errore');
        return of({
          invalidMunicipality: 'Seleziona un comune dalla lista'
        });
      }
      // Chiama il servizio per verificare il comune
      return this.locationService.getMunicipalityByMunicipalityCode(municipality).pipe(map(response => {
        // Nessun errore se il codice del comune è valido
        return response.status === 200 ? null : {
          invalidMunicipality: 'Seleziona un comune dalla lista'
        };
      }), catchError(() => of({
        invalidMunicipality: 'Seleziona un comune dalla lista'
      })));
    };
  }
  static {
    this.ɵfac = function MunicipalityValidatorService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MunicipalityValidatorService)(i0.ɵɵinject(LocationService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MunicipalityValidatorService,
      factory: MunicipalityValidatorService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MunicipalityValidatorService, [{
    type: Injectable,
    args: [{
      providedIn: 'root' // Assicura che il servizio sia disponibile in tutto il modulo root
    }]
  }], () => [{
    type: LocationService
  }], null);
})();
const TOKEN_KEY = 'token';
const REFRESHTOKEN_KEY = 'refresh_token';
class TokenStorageService {
  constructor(http, env) {
    this.http = http;
    this.env = env;
  }
  signOut() {
    sessionStorage.clear();
  }
  saveToken(token) {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.setItem(TOKEN_KEY, token);
  }
  getToken() {
    return sessionStorage.getItem(TOKEN_KEY);
  }
  saveRefreshToken(token) {
    sessionStorage.removeItem(REFRESHTOKEN_KEY);
    sessionStorage.setItem(REFRESHTOKEN_KEY, token);
  }
  getRefreshToken() {
    return sessionStorage.getItem(REFRESHTOKEN_KEY);
  }
  refreshToken() {
    return this.http.get(this.env.beUrl + 'session-manager/refresh-token', {
      observe: 'response'
    });
  }
  static {
    this.ɵfac = function TokenStorageService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TokenStorageService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ENVIRONMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TokenStorageService,
      factory: TokenStorageService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TokenStorageService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }], null);
})();
class ModuleService {
  constructor(http, tokenStorageService, env) {
    this.http = http;
    this.tokenStorageService = tokenStorageService;
    this.env = env;
  }
  getModules(role) {
    const fiscalCode = sessionStorage.getItem('fiscalCode');
    return this.http.get(this.env.administrationUrl + 'users/modules/' + role + '/' + fiscalCode, {
      observe: 'response'
    });
  }
  static {
    this.ɵfac = function ModuleService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModuleService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(TokenStorageService), i0.ɵɵinject(ENVIRONMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ModuleService,
      factory: ModuleService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModuleService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: TokenStorageService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }], null);
})();
class RoleService {
  constructor(env, http, tokenStorageService) {
    this.env = env;
    this.http = http;
    this.tokenStorageService = tokenStorageService;
  }
  getPermissionForApi() {
    const moduleName = this.env.acronym ?? "";
    const fiscalCode = sessionStorage.getItem('fiscalCode');
    const permissionTemp = localStorage.getItem('selectedRole/' + fiscalCode) ?? '{"name": "", "description": ""}';
    const permission = JSON.parse(permissionTemp);
    return moduleName + '_' + permission.name;
  }
  getSelectedRole() {
    const fiscalCode = this.getFiscalCode();
    const selectedRoleStr = localStorage.getItem('selectedRole/' + fiscalCode);
    if (selectedRoleStr && selectedRoleStr !== '') {
      if (this.isLite()) {
        return new ReturnedRole('UtenteEsterno', null);
      }
      return JSON.parse(selectedRoleStr);
    } else return new ReturnedRole(null, null);
  }
  getUserRolesList() {
    if (localStorage.getItem('selectedRole/' + this.getFiscalCode())) {
      return JSON.parse(localStorage.getItem('selectedRole/' + this.getFiscalCode()) ?? '');
    } else {
      return null;
    }
  }
  getFiscalCode() {
    const fiscalCode = sessionStorage.getItem('fiscalCode');
    return fiscalCode ?? null;
  }
  getUserToken() {
    return sessionStorage.getItem('token') ?? null;
  }
  isLite() {
    const isLite = sessionStorage.getItem('isLite');
    if (isLite && isLite == 'true') {
      return true;
    } else {
      return false;
    }
  }
  getUserRoles() {
    const fiscalCode = sessionStorage.getItem('fiscalCode');
    return this.http.get(this.env.administrationUrl + 'users/roles/' + fiscalCode, {
      observe: 'response'
    });
  }
  static {
    this.ɵfac = function RoleService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RoleService)(i0.ɵɵinject(ENVIRONMENT), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(TokenStorageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RoleService,
      factory: RoleService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RoleService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }, {
    type: i1.HttpClient
  }, {
    type: TokenStorageService
  }], null);
})();
class ModulesSubjectService {
  constructor() {
    this.modulesSubject = new BehaviorSubject(null);
    this.modules$ = this.modulesSubject.asObservable();
  }
  setModules(modules) {
    console.debug('country: ' + modules);
    this.modulesSubject.next(modules);
  }
  static {
    this.ɵfac = function ModulesSubjectService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModulesSubjectService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ModulesSubjectService,
      factory: ModulesSubjectService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModulesSubjectService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class AuthGuard {
  constructor(router, env) {
    this.router = router;
    this.env = env;
  }
  canActivate() {
    const token = sessionStorage.getItem('token');
    if (token) {
      return true;
    } else {
      if (!this.env.isLocal) {
        // Salva il percorso nel localStorage
        const currentPath = window.location.pathname + window.location.search + window.location.hash;
        localStorage.setItem('lastPathDirect', currentPath);
        // Reindirizza all'URL base
        window.location.replace(this.env.baseUrl);
        return false; // Impedisce l'accesso alla route
      } else {
        return true;
      }
    }
  }
  static {
    this.ɵfac = function AuthGuard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AuthGuard)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(ENVIRONMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AuthGuard,
      factory: AuthGuard.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthGuard, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.Router
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }], null);
})();
class UserService {
  constructor(http, env) {
    this.http = http;
    this.env = env;
    this.users = [];
  }
  getAllUsers(getUserDto) {
    const httpOption = {
      observe: 'response',
      headers: {
        'X-Skip-Notification': 'true'
      }
    };
    return this.http.post(`${this.env.administrationUrl}users/find`, getUserDto, httpOption);
  }
  getAll(numPagina, numRighe, ricercaCognome, ricercaCodiceFiscale, ordinamentoCognome, ordinamentoCodiceFiscale) {
    let params = new HttpParams();
    params = params.append('numPage', numPagina.toString());
    params = params.append('numRows', numRighe.toString());
    params = params.append('searchSurname', ricercaCognome);
    params = params.append('searchFiscalCode', ricercaCodiceFiscale);
    if (ordinamentoCognome) {
      params = params.append('orderSurname', ordinamentoCognome);
    }
    if (ordinamentoCodiceFiscale) {
      params = params.append('orderFiscalCode', ordinamentoCodiceFiscale);
    }
    this.http.get(this.env.administrationUrl + 'users', {
      observe: 'response',
      params: params
    }).subscribe({
      next: response => {
        if (response.body && response.body.data) {
          this.users = response.body.data.map(user => ({
            id: user.id,
            name: user.name,
            surname: user.surname,
            fiscalCode: user.fiscalCode,
            apssId: user.apssId,
            serialNumber: user.serialNumber,
            profileAgid: user.profileAgid,
            gender: user.gender,
            birthDate: user.birthDate,
            email: user.email,
            serviceStatus: user.serviceStatus,
            permissionList: user.permissionList,
            isLite: user.isLite,
            authority: user.authority
          }));
        }
      },
      error: err => {
        console.error('Error fetching users:', err);
      }
    });
  }
  getUserRoles() {
    const fiscalCode = sessionStorage.getItem('fiscalCode');
    return this.http.get(this.env.administrationUrl + 'users/roles/' + fiscalCode, {
      observe: 'response'
    });
  }
  getRolesForModuleAndSubmodule(module, submodule) {
    let params = new HttpParams();
    params = params.append('subModuleUrl', submodule ?? '');
    return this.http.get(this.env.administrationUrl + 'roles/' + module + '/submoduleUrl', {
      observe: 'response',
      params: params
    });
  }
  static {
    this.ɵfac = function UserService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UserService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ENVIRONMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UserService,
      factory: UserService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }], null);
})();
class PermissionGuard {
  constructor(router, env, roleService, userService, moduleService, modulesSubjectService) {
    this.router = router;
    this.env = env;
    this.roleService = roleService;
    this.userService = userService;
    this.moduleService = moduleService;
    this.modulesSubjectService = modulesSubjectService;
    this.denied = false;
    this.rolesSubject = new BehaviorSubject([]);
    this.roles$ = this.rolesSubject.asObservable();
    this.modulesSubject = new BehaviorSubject([]);
    this.modules$ = this.modulesSubject.asObservable();
    this.selectedRole = null;
  }
  canActivate() {
    const currentPath = window.location.pathname + window.location.search + window.location.hash;
    const relativePath = currentPath.startsWith(this.env.baseUrl) ? currentPath.replace(this.env.baseUrl, '') : currentPath;
    // Splitta il percorso in segmenti
    const pathSegments = relativePath.split('/').filter(segment => segment);
    // Salva i segmenti in variabili (baseUrl e secondPath)
    const baseUrl = pathSegments[0] || ''; // Primo segmento
    const secondPath = pathSegments[1] || ''; // Secondo segmento
    const selectedRole = this.roleService.getSelectedRole();
    const rolesList = this.roleService.getUserRolesList();
    this.userService.getRolesForModuleAndSubmodule(baseUrl, secondPath).subscribe({
      next: async rolesResponse => {
        console.debug(rolesResponse);
        const permittedRoles = rolesResponse.body.data;
        if (selectedRole && this.findPerfectMatching(permittedRoles, selectedRole)) {
          return true;
        } else {
          if (rolesList) {
            const matchingRole = this.findMatchingRole(permittedRoles, rolesList);
            if (matchingRole) {
              return true;
            } else {
              this.denied = true;
              this.getNewRoleAndRedirect(rolesList);
              return false;
            }
          } else {
            this.denied = true;
            console.debug('manca lista ruoli utente');
            return false;
          }
        }
      },
      error: err => {
        console.debug('Errore nella chiamata per il controllo path');
        return true;
      }
    });
    return true;
  }
  findMatchingRole(permittedRoles, userRoles) {
    // Cerca un ruolo corrispondente tra permittedRoles e userRoles
    return permittedRoles.find(permittedRole => userRoles.some(userRole => userRole.name === permittedRole.name));
  }
  findPerfectMatching(permittedRoles, userRole) {
    // Cerca un ruolo corrispondente tra permittedRoles e userRoles
    return permittedRoles.find(permittedRole => permittedRole.name === userRole.name);
  }
  getNewRoleAndRedirect(roles) {
    this.rolesSubject.next(roles);
    this.roles$.pipe(first()).subscribe({
      next: roles => {
        if (roles && roles.length > 0) {
          // Chiama la funzione selectRole passando il primo elemento di roles
          this.selectRole(roles[0]);
        }
      },
      error: err => {
        console.error('Errore nella ricezione di roles:', err);
      }
    });
  }
  async selectRole(role) {
    this.selectedRole = role;
    const fiscalCode = sessionStorage.getItem('fiscalCode');
    localStorage.setItem('selectedRole/' + fiscalCode, JSON.stringify(role));
    try {
      // Aspetta che la chiamata per ottenere i moduli sia completata prima di proseguire
      await this.getModules(role);
      this.modulesSubjectService.modules$.pipe(take(1)).subscribe(modules => {
        // Assegna i moduli all'observable del componente
        if (modules) {
          this.modulesSubject.next(modules); // Aggiorna il BehaviorSubject locale con i moduli ricevuti
        }
      });
    } catch (error) {
      console.error('Errore ricezione moduli', error);
    }
    if (this.env.isLocal) {
      window.location.reload();
    } else {
      // Aspetta che i moduli siano effettivamente disponibili prima di chiamare goTo()
      this.modules$.pipe(take(1)).subscribe(modules => {
        if (modules && modules.length > 0) {
          this.goTo(modules[0]); // Passa il primo modulo dall'osservabile
        }
      });
    }
  }
  getModules(role) {
    return lastValueFrom(this.moduleService.getModules(role.name ?? '').pipe(take(1),
    // Prendi solo la prima emissione per evitare esecuzioni ripetute
    map(response => {
      const modules = response.body.data;
      localStorage.setItem('modules', JSON.stringify(modules));
      this.modulesSubjectService.setModules(modules);
    }), catchError(err => {
      console.error('Errore nella ricezione dei moduli', err);
      return of(null); // Ritorna un observable per completare correttamente lo stream
    })));
  }
  goTo(modulo, sottomodulo) {
    if (sottomodulo) {
      if (this.denied) {
        window.location.replace(this.env.baseUrl + modulo.url + '/' + sottomodulo.url + '/access-denied');
      } else {
        window.location.replace(this.env.baseUrl + modulo.url + '/' + sottomodulo.url);
      }
    } else {
      if (this.denied) {
        window.location.replace(this.env.baseUrl + modulo.url + '/access-denied');
      } else {
        window.location.replace(this.env.baseUrl + modulo.url);
      }
    }
  }
  static {
    this.ɵfac = function PermissionGuard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PermissionGuard)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(ENVIRONMENT), i0.ɵɵinject(RoleService), i0.ɵɵinject(UserService), i0.ɵɵinject(ModuleService), i0.ɵɵinject(ModulesSubjectService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PermissionGuard,
      factory: PermissionGuard.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PermissionGuard, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.Router
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }, {
    type: RoleService
  }, {
    type: UserService
  }, {
    type: ModuleService
  }, {
    type: ModulesSubjectService
  }], null);
})();
class ButtonComponent {
  constructor() {
    this.colore = 'primary';
    this.outlined = 'false';
    this.disabled = 'false';
    this.size = 'small';
    this.type = 'button';
  }
  static {
    this.ɵfac = function ButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ButtonComponent,
      selectors: [["app-button"]],
      inputs: {
        colore: "colore",
        outlined: "outlined",
        disabled: "disabled",
        size: "size",
        type: "type"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c0,
      decls: 2,
      vars: 15,
      consts: [[1, "d-flex", "align-items-center", 3, "ngClass", "type"]],
      template: function ButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunctionV(2, _c1, [ctx.colore === "primary" && ctx.outlined === "false", ctx.colore === "secondary" && ctx.outlined === "false", ctx.colore === "danger" && ctx.outlined === "false", ctx.colore === "success" && ctx.outlined === "false", ctx.colore === "primary" && ctx.outlined === "true", ctx.colore === "secondary" && ctx.outlined === "true", ctx.colore === "danger" && ctx.outlined === "true", ctx.colore === "success" && ctx.outlined === "true", ctx.size === "large", ctx.size === "small", ctx.size === "mini", ctx.disabled === "true"]))("type", ctx.type);
        }
      },
      dependencies: [NgClass],
      styles: [".basic-button[_ngcontent-%COMP%], .primary[_ngcontent-%COMP%], .primary-outlined[_ngcontent-%COMP%], .disabled[_ngcontent-%COMP%], .danger[_ngcontent-%COMP%], .danger-outlined[_ngcontent-%COMP%], .secondary[_ngcontent-%COMP%], .secondary-outlined[_ngcontent-%COMP%], .success[_ngcontent-%COMP%], .success-outlined[_ngcontent-%COMP%]{border-radius:4px;text-align:center;vertical-align:middle}.primary[_ngcontent-%COMP%]{background-color:#06c;color:#fff;border:none}.primary[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:hover{background-color:#1d5286!important}.primary-outlined[_ngcontent-%COMP%]{background-color:#fff;color:#06c;border:2px solid #0066CC}.disabled[_ngcontent-%COMP%]{color:#768594;background-color:#d9dadb;border:none}.danger[_ngcontent-%COMP%]{background-color:#cc334d;color:#fff;border:none}.danger-outlined[_ngcontent-%COMP%]{background-color:#fff;color:#cc334d;border:2px solid #CC334D}.secondary[_ngcontent-%COMP%]{background-color:#404040;color:#fff;border:none}.secondary-outlined[_ngcontent-%COMP%]{background-color:#fff;color:#404040;border:2px solid #404040}.success[_ngcontent-%COMP%]{background-color:#008055;color:#fff;border:none}.success-outlined[_ngcontent-%COMP%]{background-color:#fff;color:#008055;border:2px solid #008055}.mini[_ngcontent-%COMP%]{padding:12px 16px;font-size:14px;line-height:16px;font-weight:600}.small[_ngcontent-%COMP%]{padding:12px 24px;font-size:16px;line-height:24px;font-weight:600}.large[_ngcontent-%COMP%]{padding:16px 32px;font-size:18px;line-height:28px;font-weight:600}button[_ngcontent-%COMP%]{display:flex}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonComponent, [{
    type: Component,
    args: [{
      selector: 'app-button',
      imports: [NgClass],
      standalone: true,
      template: "<button\n  [ngClass]=\"{\n    primary: colore === 'primary' && outlined === 'false',\n    secondary: colore === 'secondary' && outlined === 'false',\n    danger: colore === 'danger' && outlined === 'false',\n    success: colore === 'success' && outlined === 'false',\n    'primary-outlined': colore === 'primary' && outlined === 'true',\n    'secondary-outlined': colore === 'secondary' && outlined === 'true',\n    'danger-outlined': colore === 'danger' && outlined === 'true',\n    'success-outlined': colore === 'success' && outlined === 'true',\n    large: size === 'large',\n    small: size === 'small',\n    mini: size === 'mini',\n    disabled: disabled === 'true'\n  }\"\n  [type]=\"type\"\n  class=\"d-flex align-items-center\"\n>\n  <ng-content></ng-content>\n</button>\n",
      styles: [".basic-button,.primary,.primary-outlined,.disabled,.danger,.danger-outlined,.secondary,.secondary-outlined,.success,.success-outlined{border-radius:4px;text-align:center;vertical-align:middle}.primary{background-color:#06c;color:#fff;border:none}.primary :hover{background-color:#1d5286!important}.primary-outlined{background-color:#fff;color:#06c;border:2px solid #0066CC}.disabled{color:#768594;background-color:#d9dadb;border:none}.danger{background-color:#cc334d;color:#fff;border:none}.danger-outlined{background-color:#fff;color:#cc334d;border:2px solid #CC334D}.secondary{background-color:#404040;color:#fff;border:none}.secondary-outlined{background-color:#fff;color:#404040;border:2px solid #404040}.success{background-color:#008055;color:#fff;border:none}.success-outlined{background-color:#fff;color:#008055;border:2px solid #008055}.mini{padding:12px 16px;font-size:14px;line-height:16px;font-weight:600}.small{padding:12px 24px;font-size:16px;line-height:24px;font-weight:600}.large{padding:16px 32px;font-size:18px;line-height:28px;font-weight:600}button{display:flex}\n"]
    }]
  }], null, {
    colore: [{
      type: Input
    }],
    outlined: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    type: [{
      type: Input
    }]
  });
})();
class DeniedAccesPageComponent {
  static {
    this.ɵfac = function DeniedAccesPageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DeniedAccesPageComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DeniedAccesPageComponent,
      selectors: [["lib-denied-acces-page"]],
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 7,
      vars: 1,
      consts: [[1, "d-flex", "flex-column", "justify-content-center", "align-items-center", "index"], [2, "font-size", "42px"], [1, "text-center", "ms-fs-medium", "pb-3"], ["color", "primary", 3, "routerLink"]],
      template: function DeniedAccesPageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "h1", 1);
          i0.ɵɵtext(2, "Accesso Negato");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "p", 2);
          i0.ɵɵtext(4, " Sembra che tu stia cercando di accedere ad una pagina per cui non hai i permessi. ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "app-button", 3);
          i0.ɵɵtext(6, "Torna alla Home");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("routerLink", "/");
        }
      },
      dependencies: [ButtonComponent, RouterLink],
      styles: [".index[_ngcontent-%COMP%]{height:calc(100vh - 120px);width:100%!important}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeniedAccesPageComponent, [{
    type: Component,
    args: [{
      selector: 'lib-denied-acces-page',
      standalone: true,
      imports: [ButtonComponent, RouterLink],
      template: "<div class=\"d-flex flex-column justify-content-center align-items-center index\">\n    <h1 style=\"font-size: 42px;\">Accesso Negato</h1>\n    <p class=\"text-center ms-fs-medium pb-3\">\n        Sembra che tu stia cercando di accedere ad una pagina per cui non hai i permessi.\n    </p>\n    <app-button color=\"primary\" [routerLink]=\"'/'\"\n      >Torna alla Home</app-button\n    >\n</div> \n",
      styles: [".index{height:calc(100vh - 120px);width:100%!important}\n"]
    }]
  }], null, null);
})();
const routes = [{
  path: 'access-denied',
  component: DeniedAccesPageComponent
}];
class DeniedAccessRoutingModule {
  static {
    this.ɵfac = function DeniedAccessRoutingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DeniedAccessRoutingModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DeniedAccessRoutingModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [RouterModule.forChild(routes), RouterModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeniedAccessRoutingModule, [{
    type: NgModule,
    args: [{
      imports: [RouterModule.forChild(routes)],
      exports: [RouterModule]
    }]
  }], null, null);
})();
class DeniedAccessModule {
  static {
    this.ɵfac = function DeniedAccessModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DeniedAccessModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DeniedAccessModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, DeniedAccessRoutingModule // Include la rotta automaticamente
      ]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeniedAccessModule, [{
    type: NgModule,
    args: [{
      imports: [DeniedAccesPageComponent, CommonModule, DeniedAccessRoutingModule // Include la rotta automaticamente
      ],
      exports: [DeniedAccesPageComponent]
    }]
  }], null, null);
})();
class Page404Component {
  constructor(env, router) {
    this.env = env;
    this.router = router;
  }
  ngOnInit() {
    // if (!sessionStorage.getItem('token') && !this.env.isLocal) {
    //   window.location.replace(this.env.feUrl);
    // }
  }
  static {
    this.ɵfac = function Page404Component_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Page404Component)(i0.ɵɵdirectiveInject(ENVIRONMENT), i0.ɵɵdirectiveInject(i1$1.Router));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Page404Component,
      selectors: [["lib-page404"]],
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 9,
      vars: 1,
      consts: [[1, "d-flex", "flex-column", "justify-content-center", "align-items-center", "index"], [2, "font-size", "120px"], [1, "fw-semibold"], [1, "text-center"], ["color", "primary", 3, "routerLink"]],
      template: function Page404Component_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "h1", 1);
          i0.ɵɵtext(2, "404");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "h4", 2);
          i0.ɵɵtext(4, "Sembra che ti sia perso all'interno del sito.");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "p", 3);
          i0.ɵɵtext(6, " La pagina che stai cercando sembra non essere disponibile, potrebbe essere stata rimossa oppure essere temporaneamente non disponibile ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "app-button", 4);
          i0.ɵɵtext(8, "Torna alla Home");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(7);
          i0.ɵɵproperty("routerLink", "/");
        }
      },
      dependencies: [ButtonComponent, RouterLink],
      styles: [_c2]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Page404Component, [{
    type: Component,
    args: [{
      selector: 'lib-page404',
      imports: [ButtonComponent, RouterLink],
      standalone: true,
      template: "<div class=\"d-flex flex-column justify-content-center align-items-center index\">\n  <h1 style=\"font-size: 120px\">404</h1>\n  <h4 class=\"fw-semibold\">Sembra che ti sia perso all'interno del sito.</h4>\n  <p class=\"text-center\">\n    La pagina che stai cercando sembra non essere disponibile, potrebbe essere\n    stata rimossa oppure essere temporaneamente non disponibile\n  </p>\n  <app-button color=\"primary\" [routerLink]=\"'/'\"\n      >Torna alla Home</app-button\n    >\n</div>\n",
      styles: [".index{height:calc(100vh - 120px);width:100%!important}\n"]
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }, {
    type: i1$1.Router
  }], null);
})();
class Page404Module {
  static {
    this.ɵfac = function Page404Module_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Page404Module)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: Page404Module
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Page404Module, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, Page404Component],
      exports: [Page404Component]
    }]
  }], null, null);
})();
const Page404Routes = [{
  path: '**',
  component: Page404Component
}];
class ErrorMessagesService {
  constructor(http, translateService) {
    this.http = http;
    this.translateService = translateService;
    this.errorMessages = {};
    const basePath = document.getElementsByTagName('base')[0]?.getAttribute('href') || '/';
    this.errorsFilePath = `${basePath}assets/errors.json`;
  }
  async loadErrorMessages() {
    try {
      const data = await lastValueFrom(this.http.get(this.errorsFilePath));
      const currentLang = this.translateService.currentLang || this.translateService.defaultLang;
      this.translateService.setTranslation(currentLang, {
        ...this.translateService.translations[currentLang],
        ...data
      }, true);
      this.errorMessages = data || {};
    } catch (err) {
      this.errorMessages = {};
    }
  }
  static {
    this.ɵfac = function ErrorMessagesService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ErrorMessagesService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.TranslateService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ErrorMessagesService,
      factory: ErrorMessagesService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorMessagesService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: i2.TranslateService
  }], null);
})();
function initializeErrorMessages(errorMessagesService) {
  return () => errorMessagesService.loadErrorMessages();
}
const NO_NOTIFICATIONS = new HttpContextToken(() => false);
const errorHandlerInterceptor = (req, next) => {
  const ERROR_DURATION = 5000;
  const notificationService = inject(ItNotificationService);
  const translateService = inject(TranslateService);
  const errorMessagesService = inject(ErrorMessagesService);
  const skipNotifications = req.context.get(NO_NOTIFICATIONS);
  return next(req).pipe(tap({
    error: error => {
      if (error instanceof HttpErrorResponse && !skipNotifications) {
        const errorBody = typeof error.error === 'string' ? JSON.parse(error.error) : error.error;
        const errorCode = errorBody?.errorCode || '';
        const params = errorBody?.params || {};
        const fields = errorBody?.fields || [];
        let errorMessage;
        if (fields.length) {
          const translatedFields = fields.map(field => {
            const translatedField = translateService.instant(`field.${field}`);
            return translatedField === `field.${field}` ? field : translatedField;
          });
          params.fields = translatedFields.join(", ");
        }
        if (errorCode) {
          errorMessage = translateService.instant(errorCode, params);
          if (errorMessage === errorCode) {
            errorMessage = getFallbackError(error.status, translateService, errorMessagesService, params);
          }
        } else {
          errorMessage = getFallbackError(error.status, translateService, errorMessagesService, params);
        }
        notificationService.error(errorMessage, undefined, undefined, ERROR_DURATION);
      }
    }
  }));
};
function getFallbackError(status, translateService, errorMessagesService, params) {
  let errorKey;
  switch (status) {
    case 401:
      errorKey = 'errors.unauthorized';
      break;
    case 403:
      errorKey = 'errors.forbidden';
      break;
    case 404:
      errorKey = 'errors.not-found';
      break;
    case 500:
      errorKey = 'errors.server';
      break;
    default:
      errorKey = 'errors.generic';
  }
  return translateService.instant(errorKey, params);
}
class PermissionsService {
  constructor(http, env) {
    this.http = http;
    this.env = env;
  }
  getAllProfiles() {
    return this.http.get(this.env.beUrl + 'normal-authenticator/profiles', {
      observe: 'response'
    });
  }
  getAllModules() {
    return this.http.get(this.env.administrationUrl + 'modules', {
      observe: 'response'
    });
  }
  getAllRolesForModule(module) {
    let params = new HttpParams();
    params = params.append('moduleName', module);
    return this.http.get(this.env.administrationUrl + 'roles/module', {
      observe: 'response',
      params: params
    });
  }
  getAllStructures() {
    return this.http.get(this.env.beUrl + 'normal-authenticator/structures', {
      observe: 'response'
    });
  }
  getStructures(authority, workPlace, department) {
    return this.http.get(this.env.beUrl + 'normal-authenticator/structures/' + authority + '/' + workPlace + '/' + department, {
      observe: 'response'
    });
  }
  getAllEntity() {
    return this.http.get(this.env.beUrl + 'normal-authenticator/authorities', {
      observe: 'response'
    });
  }
  getAllSites(authorityId) {
    return this.http.get(this.env.beUrl + 'normal-authenticator/workplaces/' + authorityId, {
      observe: 'response'
    });
  }
  getAlldepartments() {
    return this.http.get(this.env.beUrl + 'normal-authenticator/departments', {
      observe: 'response'
    });
  }
  getDepartments(authority, workPlace) {
    return this.http.get(this.env.beUrl + 'normal-authenticator/departments/' + authority + '/' + workPlace, {
      observe: 'response'
    });
  }
  getAllDivisions() {
    return this.http.get(this.env.beUrl + 'normal-authenticator/divisions', {
      observe: 'response'
    });
  }
  getDivisions(authority, workPlace, department, structure) {
    return this.http.get(this.env.beUrl + 'normal-authenticator/divisions/' + authority + '/' + workPlace + '/' + department + '/' + structure, {
      observe: 'response'
    });
  }
  getAllSources() {
    return this.http.get(this.env.beUrl + 'normal-authenticator/sources', {
      observe: 'response'
    });
  }
  getAllJobs() {
    return this.http.get(this.env.beUrl + 'normal-authenticator/jobs', {
      observe: 'response'
    });
  }
  static {
    this.ɵfac = function PermissionsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PermissionsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ENVIRONMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PermissionsService,
      factory: PermissionsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PermissionsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }], null);
})();
class ApssDataService {
  constructor(permissionsService) {
    this.permissionsService = permissionsService;
  }
  getDepartments(authority, workPlace) {
    return new Promise((resolve, reject) => {
      let result = [];
      this.permissionsService.getDepartments(authority, workPlace).subscribe({
        next: response => {
          console.debug('succes department response');
          result = response.body.data;
          resolve(result);
        },
        error: err => {
          console.error('error department response' + err);
          result = [];
          reject(result);
        }
      });
    });
  }
  getStructures(authority, workPlace, department) {
    return new Promise((resolve, reject) => {
      let result = [];
      this.permissionsService.getStructures(authority, workPlace, department).subscribe({
        next: response => {
          result = response.body.data;
          resolve(result);
        },
        error: err => {
          console.debug(err);
          result = [];
          reject(result);
        }
      });
    });
  }
  getDivisions(authority, workPlace, department, structure) {
    return new Promise((resolve, reject) => {
      let result = [];
      this.permissionsService.getDivisions(authority, workPlace, department, structure).subscribe({
        next: response => {
          console.debug('success division Response');
          result = response.body.data;
          resolve(result);
        },
        error: err => {
          console.debug('error division Response: ' + err);
          result = [];
          reject(result);
        }
      });
    });
  }
  getAllSites() {
    return new Promise((resolve, reject) => {
      let result = [];
      this.permissionsService.getAllSites('1').subscribe({
        next: response => {
          result = response.body.data;
          console.debug('succes Sites response');
          resolve(result);
        },
        error: err => {
          console.debug('error Sites response: ' + err);
          result = [];
          reject(result);
        }
      });
    });
  }
  getAllProfiles() {
    return new Promise((resolve, reject) => {
      let result = [];
      this.permissionsService.getAllProfiles().subscribe({
        next: response => {
          console.debug(response);
          result = response.body.data;
          resolve(result);
        },
        error: err => {
          console.debug(err);
          result = [];
          reject(result);
        }
      });
    });
  }
  getAllJobs() {
    return new Promise((resolve, reject) => {
      let result = [];
      this.permissionsService.getAllJobs().subscribe({
        next: async response => {
          result = response.body.data;
          console.debug('resolve getApssData');
          resolve(result);
        },
        error: err => {
          console.debug(err);
          result = [];
          reject(result);
        }
      });
    });
  }
  getAllEntity() {
    return new Promise((resolve, reject) => {
      let result = [];
      this.permissionsService.getAllEntity().subscribe({
        next: response => {
          result = response.body.data;
          console.debug('success entity response');
          resolve(result);
        },
        error: err => {
          console.error('error entity response: ' + err);
          result = [];
          reject(result);
        }
      });
    });
  }
  static {
    this.ɵfac = function ApssDataService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ApssDataService)(i0.ɵɵinject(PermissionsService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ApssDataService,
      factory: ApssDataService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApssDataService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: PermissionsService
  }], null);
})();
class AsideComponent {
  constructor(moduleService, env) {
    this.moduleService = moduleService;
    this.env = env;
    this.loginLevel = 0;
    this.typeAlert = 'primary';
    this.alertText = '';
    this.alertCount = 0;
    this.activeRoute = '';
    this.moduliSubject = new BehaviorSubject([]);
    this.moduli$ = this.moduliSubject.asObservable();
    this.selectedRole = null;
    this.roles = '';
    this.rolesObj = null;
  }
  ngOnInit() {
    console.debug('(LIBRERIA-ASIDE)ngOnInit');
    if (sessionStorage.getItem('token')) {
      this.setLoginLevel();
      this.activeRoute = window.location.pathname;
      console.debug('activeRoute: ' + this.activeRoute);
      if (localStorage.getItem('roleList')) {
        this.roles = localStorage.getItem('roleList') ?? '';
        this.rolesObj = JSON.parse(this.roles);
      }
      const fiscalCode = sessionStorage.getItem('fiscalCode');
      if (localStorage.getItem('selectedRole/' + fiscalCode)) {
        const selectedRoleStr = localStorage.getItem('selectedRole/' + fiscalCode);
        this.selectedRole = JSON.parse(selectedRoleStr ? selectedRoleStr : '');
        if (this.selectedRole) this.getModules(this.selectedRole);
      }
    }
  }
  setLoginLevel() {
    if (sessionStorage.getItem('loginLevel') == 'entra') {
      this.loginLevel = 2;
    } else if (sessionStorage.getItem('loginLevel') == 'spid') {
      this.loginLevel = 3;
    } else if (sessionStorage.getItem('loginLevel') == 'normal') {
      this.loginLevel = 1;
    }
  }
  returnToHome() {
    window.location.replace(this.env.feUrl + 'home');
  }
  closeAside() {
    console.debug('(LIBRERIA-ASIDE) - CHIUSURA ASIDE');
    const aside = document.getElementById('aside');
    aside?.classList.remove('d-block');
    aside?.classList.remove('d-none');
  }
  goToHome() {
    console.debug('(LIBRERIA-ASIDE) - TORNA ALLA HOME');
    window.location.replace(this.env.feUrl + 'home');
  }
  goTo(modulo, sottomodulo) {
    if (sottomodulo) {
      window.location.replace(this.env.baseUrl + modulo.url + '/' + sottomodulo.url);
    } else {
      window.location.replace(this.env.baseUrl + modulo.url);
    }
  }
  getModules(role) {
    this.moduleService.getModules(role.name).pipe(map(response => {
      const modules = response.body.data;
      console.debug(response);
      localStorage.setItem('modules', JSON.stringify(modules));
      this.moduliSubject.next(modules); // Emmette i moduli tramite il Subject
    }), catchError(err => {
      console.error(err);
      this.moduliSubject.next([]); // Emmette un array vuoto in caso di errore
      return of([]); // Restituisce un array vuoto in caso di errore
    })).subscribe();
  }
  handleKeyDown(event, modulo) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Previene lo scrolling della pagina quando si preme la barra spaziatrice
      this.goTo(modulo);
    }
  }
  static {
    this.ɵfac = function AsideComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AsideComponent)(i0.ɵɵdirectiveInject(ModuleService), i0.ɵɵdirectiveInject(ENVIRONMENT));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AsideComponent,
      selectors: [["app-aside"]],
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 7,
      vars: 3,
      consts: [["id", "aside", 1, "d-none", "d-lg-flex", "flex-column", "bg-transparent", "position-fixed"], ["id", "asideBody", 1, "d-flex", "flex-column", "overflow-y-auto", "max-height-nav", "overflow-x-hidden", "rounded", "w-100", "h-100"], ["id", "aside-body-container"], [1, "m-0"], [4, "ngIf"], [1, "d-flex", "flex-column"], ["tabindex", "0", 1, "d-flex", "align-items-center", "p-1", "rounded", "bg-hover", "pb-2", 3, "click", "keydown"], [1, "material-symbols-outlined", "d-flex", "align-items-center", "text-black-ms", "fs-5"], [1, "px-2", "service-title"], ["tabindex", "1", 1, "d-flex", "align-items-center", "p-1", "rounded", "bg-hover", 3, "click", "keydown"], [1, "px-2", "px-mid"]],
      template: function AsideComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "h4", 3);
          i0.ɵɵtext(4, "Menu");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, AsideComponent_div_5_Template, 3, 0, "div", 4);
          i0.ɵɵpipe(6, "async");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 1, ctx.moduli$));
        }
      },
      dependencies: [CommonModule, i3.NgIf, i3.AsyncPipe],
      styles: ["#aside[_ngcontent-%COMP%]{padding:96px 16px 16px!important;width:260px;gap:0px;border-radius:8px 0 0;opacity:0px;height:100vh}#aside[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:16px}#aside[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{padding-bottom:22px}#asideBody[_ngcontent-%COMP%]{background-color:#f2f7fc}#asideBody[_ngcontent-%COMP%]   #aside-body-container[_ngcontent-%COMP%]{padding:18px 14px}.bg-hover[_ngcontent-%COMP%]:hover{cursor:pointer;background-color:#e6e6fa}.service-title[_ngcontent-%COMP%]{color:#1a1a1a;font-size:16px;line-height:18px;text-align:left;font-weight:600}.px-mid[_ngcontent-%COMP%]{padding-left:45px!important}.text-black-ms[_ngcontent-%COMP%]{color:#1a1a1a!important;font-weight:600!important}.px-mid[_ngcontent-%COMP%]{padding-left:29px!important}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsideComponent, [{
    type: Component,
    args: [{
      selector: 'app-aside',
      imports: [NgClass, CommonModule],
      standalone: true,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div\n  id=\"aside\"\n  class=\"d-none d-lg-flex flex-column bg-transparent position-fixed\"\n>\n      <div\n        id=\"asideBody\"\n        class=\"d-flex flex-column overflow-y-auto max-height-nav overflow-x-hidden rounded w-100 h-100\"\n      >\n        <div id=\"aside-body-container\">\n          <h4 class=\"m-0\">Menu</h4>\n          <div *ngIf=\"moduli$ | async as moduli\">\n            @for(modulo of moduli; track modulo){\n              <div class=\"d-flex flex-column\">\n                <div class=\"d-flex align-items-center p-1 rounded bg-hover pb-2\" (click)=\"goTo(modulo)\" (keydown)=\"handleKeyDown($event, modulo)\" tabindex=\"0\">\n                  <i class=\"material-symbols-outlined d-flex align-items-center text-black-ms fs-5\">inventory_2</i>\n                  <span class=\"px-2 service-title\">{{\n                    modulo.name\n                  }}</span>\n                </div>\n              </div>\n              @for (sottomodulo of modulo.subModulesList; track sottomodulo) {\n              @if(sottomodulo.url !== null && sottomodulo.url !== ''){\n              <div class=\"d-flex flex-column\">\n                <div class=\"d-flex align-items-center p-1 rounded bg-hover\" (click)=\"goTo(modulo, sottomodulo)\" (keydown)=\"handleKeyDown($event, modulo)\" tabindex=\"1\">\n                  <span class=\"px-2 px-mid\">{{\n                    sottomodulo.name\n                  }}</span>\n                </div>\n              </div>\n              } } }\n          </div>\n        </div>\n      </div>\n</div>\n\n",
      styles: ["#aside{padding:96px 16px 16px!important;width:260px;gap:0px;border-radius:8px 0 0;opacity:0px;height:100vh}#aside span{font-size:16px}#aside h4{padding-bottom:22px}#asideBody{background-color:#f2f7fc}#asideBody #aside-body-container{padding:18px 14px}.bg-hover:hover{cursor:pointer;background-color:#e6e6fa}.service-title{color:#1a1a1a;font-size:16px;line-height:18px;text-align:left;font-weight:600}.px-mid{padding-left:45px!important}.text-black-ms{color:#1a1a1a!important;font-weight:600!important}.px-mid{padding-left:29px!important}\n"]
    }]
  }], () => [{
    type: ModuleService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }], null);
})();
class LogoutService {
  constructor(env) {
    this.env = env;
  }
  logoutStatus() {
    if (sessionStorage.getItem('loginLevel') == 'spid') {
      sessionStorage.setItem('logout', 'true');
      window.location.replace(this.env.baseUrl + 'spid-authenticator/logout');
    } else if (sessionStorage.getItem('loginLevel') == 'entra') {
      localStorage.setItem('entra-status', 'logout');
      sessionStorage.clear();
      window.location.replace(this.env.baseUrl + 'entra-authenticator/logout');
    } else {
      sessionStorage.clear();
      sessionStorage.setItem('logout', 'true');
      window.location.replace(this.env.baseUrl);
    }
  }
  static {
    this.ɵfac = function LogoutService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogoutService)(i0.ɵɵinject(ENVIRONMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LogoutService,
      factory: LogoutService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogoutService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }], null);
})();
class HeaderComponent {
  constructor(env, logoutService, moduleService, roleService, modulesSubjectService, router) {
    this.env = env;
    this.logoutService = logoutService;
    this.moduleService = moduleService;
    this.roleService = roleService;
    this.modulesSubjectService = modulesSubjectService;
    this.router = router;
    this.loginInput = false;
    this.spidAuth = false;
    this.authenticatorHome = false;
    this.loginLevel = '';
    this.login = false;
    this.areaSelected = null;
    this.moduli = null;
    this.nameSurname = '';
    this.leftModal = null;
    this.selectedRole = null;
    this.email = '';
    this.isLite = false;
    this.rolesSubject = new BehaviorSubject([]);
    this.roles$ = this.rolesSubject.asObservable();
    this.modulesSubject = new BehaviorSubject([]);
    this.modules$ = this.modulesSubject.asObservable();
  }
  ngOnInit() {
    this.checkLiteMode();
    this.setNameSurnameAndLoginLevel();
    this.setEmail();
    this.checkLoginAndLoadRoles();
    this.handleSelectedRoleOrFallback();
  }
  checkLiteMode() {
    this.isLite = sessionStorage.getItem('isLite') === 'true';
  }
  setNameSurnameAndLoginLevel() {
    const name = sessionStorage.getItem('name');
    const surname = sessionStorage.getItem('surname');
    if (name && surname) {
      this.nameSurname = `${name} ${surname}`;
      const level = sessionStorage.getItem('loginLevel');
      this.loginLevel = level ?? '';
    }
  }
  setEmail() {
    const email = sessionStorage.getItem('email');
    if (email) {
      this.email = email;
    }
  }
  checkLoginAndLoadRoles() {
    if (sessionStorage.getItem('login')) {
      this.login = true;
      this.roleService.getUserRoles().subscribe({
        next: response => {
          const roles = response.body.data;
          this.rolesSubject.next(roles);
          localStorage.setItem('roleList', JSON.stringify(roles));
        },
        error: err => {
          console.debug(err);
        }
      });
    }
  }
  handleSelectedRoleOrFallback() {
    const fiscalCode = sessionStorage.getItem('fiscalCode');
    const selectedRoleKey = `selectedRole/${fiscalCode}`;
    const selectedRoleInSession = localStorage.getItem(selectedRoleKey);
    if (selectedRoleInSession) {
      this.selectedRole = this.roleService.getSelectedRole();
      if (this.selectedRole) {
        this.getModules(this.selectedRole);
      }
    } else {
      this.roles$.pipe(take(1)).subscribe(roles => {
        if (roles && roles.length > 0) {
          this.selectRole(roles[0]); // Passa il primo elemento dell'array 
        } else {
          console.error('Nessun ruolo disponibile');
        }
      });
    }
  }
  goToHome() {
    this.router.navigate(['/']);
  }
  async selectRole(role) {
    this.selectedRole = role;
    const fiscalCode = sessionStorage.getItem('fiscalCode');
    try {
      // Aspetta che la chiamata per ottenere i moduli sia completata prima di proseguire
      await this.getModules(role);
      localStorage.setItem('selectedRole/' + fiscalCode, JSON.stringify(role));
      this.modules$.pipe(take(1)).subscribe(modules => {
        // Assegna i moduli all'observable del componente
        if (modules) {
          this.modulesSubject.next(modules); // Aggiorna il BehaviorSubject locale con i moduli ricevuti
        }
      });
    } catch (error) {
      console.error('Errore ricezione moduli', error);
    }
    if (this.env.isLocal) {
      window.location.reload();
    } else {
      // Aspetta che i moduli siano effettivamente disponibili prima di chiamare goTo()
      this.modules$.pipe(take(1)).subscribe(modules => {
        if (modules && modules.length > 0) {
          console.debug('dentro all if HEADER - MODULI');
          this.goTo(modules[0]); // Passa il primo modulo dall'osservabile
        } else {
          console.debug('fuori dall if HEADER - MODULI');
        }
      });
    }
  }
  getInitials(name) {
    if (!name) return '';
    const names = name.split(' ');
    let initials = names[0].charAt(0).toUpperCase();
    if (names.length > 1) {
      initials += names[1].charAt(0).toUpperCase();
    }
    return initials;
  }
  goTo(modulo, sottomodulo) {
    if (sottomodulo) {
      window.location.replace(this.env.baseUrl + modulo.url + '/' + sottomodulo.url);
    } else {
      window.location.replace(this.env.baseUrl + modulo.url);
    }
  }
  getModules(role) {
    return lastValueFrom(this.moduleService.getModules(role.name ?? '').pipe(take(1),
    // Prendi solo la prima emissione per evitare esecuzioni ripetute
    map(response => {
      const modules = response.body.data;
      localStorage.setItem('modules', JSON.stringify(modules));
      this.modulesSubject.next(modules);
    }), catchError(err => {
      console.error('Errore nella ricezione dei moduli', err);
      return of(null); // Ritorna un observable per completare correttamente lo stream
    })));
  }
  static {
    this.ɵfac = function HeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HeaderComponent)(i0.ɵɵdirectiveInject(ENVIRONMENT), i0.ɵɵdirectiveInject(LogoutService), i0.ɵɵdirectiveInject(ModuleService), i0.ɵɵdirectiveInject(RoleService), i0.ɵɵdirectiveInject(ModulesSubjectService), i0.ɵɵdirectiveInject(i1$1.Router));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HeaderComponent,
      selectors: [["app-header"]],
      inputs: {
        loginInput: "loginInput",
        spidAuth: "spidAuth",
        authenticatorHome: "authenticatorHome"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 20,
      vars: 5,
      consts: [["leftModal", "itModal"], ["id", "headerDiv", 1, "d-flex", "justify-content-center", "align-items-center", "position-fixed", "top-0", "start-0", "end-0"], ["id", "col-microservizi", 1, "col", "d-flex"], ["id", "asideDiv", 1, "ps-3", "d-flex", "justify-content-center", "align-items-center"], [1, "ps-3"], [1, "d-flex", "align-items-center", 3, "click"], ["src", "assets/images/poliblend-aside-small.png", "alt", "logo Portale Operatori APSS - small", 1, "d-block"], [1, "text-white", "d-none", "d-lg-block", "fs-3", "ms-2", "text-nowrap"], ["id", "profile-menu", 1, "col", "d-flex", "justify-content-end", "align-items-center", "pe-4"], ["alignment", "left", "scrollable", "true", 1, "custom-modal"], ["modalTitle", ""], ["id", "asideBody", 1, "h-100", "d-flex", "flex-column", "justify-content-between", "pt-3"], [1, "h-100", "d-flex", "flex-column", "justify-content-between"], [1, "d-flex", "flex-column", "overflow-y-auto", "max-height-nav", "overflow-x-hidden"], [4, "ngIf"], ["id", "asideDiv", "class", "ps-3 d-flex justify-content-center align-items-center", 4, "ngIf"], ["type", "button", 1, "navbar-toggler", "d-block", "d-lg-none", 3, "click"], [1, "material-symbols-outlined", "fs-2", "text-white"], [1, "d-none", "d-md-flex", "align-items-center"], [1, "text-white", "fw-semibold", "d-none", "d-md-block"], [1, "profile-menu-button", "dropdown", "d-flex", "align-items-center"], ["type", "button", "id", "dropdownMenuButton", "data-bs-toggle", "dropdown", "aria-expanded", "false", 1, "btn", "btn-secondary", "dropdown-toggle", "bg-transparent", "d-flex", "align-items-center", "p-3"], [1, "d-flex", "align-items-center", "transparent-background", "transparent-border"], [1, "rounded-circle", "me-2", "p-2", "profile-image-border"], [1, "text-nowrap"], [1, "d-flex", "flex-column", "ms-2"], [1, "text-white", "font-weight-bold", "text-nowrap", "no-display-650"], [1, "d-flex"], [1, "text-white", "font-weight-normal", "small-font", "text-end", "pe-2"], [1, "material-symbols-outlined", "ms-2"], ["aria-labelledby", "dropdownMenuButton", 1, "dropdown-menu", "dropdown-menu-end"], [1, "text-sm", "fw-semibold", "dropdown-item"], [1, "text-sm", "fw-semibold", "top-border", "dropdown-item"], ["class", "roleList", 4, "ngIf"], [1, "top-border"], [1, "dropdown-item", "d-flex", "align-items-center", 3, "click"], [1, "material-symbols-outlined", "fs-24"], [1, "text-sm", "ps-ms-24"], [1, "roleList"], [1, "d-flex", "align-items-center", "dropdown-item"], [1, "d-flex", "align-items-center", 2, "height", "24px", "width", "24px"], [1, "material-symbols-outlined", "text-primary", "fs-24"], [1, "dropdown-item", "text-sm", "p-0", "ps-2", 3, "click", "ngClass"], [1, "d-flex", "flex-column", "pb-3"], [1, "d-flex", "align-items-center", "p-1", "rounded", "bg-hover", "pb-2"], [1, "material-symbols-outlined", "d-flex", "align-items-center", "text-primary", "text-black-ms"], [1, "px-2", "text-nowrap", "service-title", 3, "click"], [1, "d-flex", "align-items-center", "p-1", "rounded", "bg-hover"], [1, "px-2", "px-mid", 3, "click"]],
      template: function HeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "header", 1)(1, "div", 2);
          i0.ɵɵtemplate(2, HeaderComponent_Conditional_2_Template, 1, 1, "div", 3);
          i0.ɵɵelementStart(3, "div", 4)(4, "a", 5);
          i0.ɵɵlistener("click", function HeaderComponent_Template_a_click_4_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.goToHome());
          });
          i0.ɵɵelement(5, "img", 6);
          i0.ɵɵelementStart(6, "h3", 7);
          i0.ɵɵtext(7, " Portale Operatori Sanitari del Trentino ");
          i0.ɵɵelementEnd()()()();
          i0.ɵɵelementStart(8, "div", 8);
          i0.ɵɵtemplate(9, HeaderComponent_Conditional_9_Template, 30, 8);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(10, "it-modal", 9, 0);
          i0.ɵɵelementContainerStart(12, 10);
          i0.ɵɵtext(13, "Menu");
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementStart(14, "div")(15, "div", 11)(16, "div", 12)(17, "div", 13);
          i0.ɵɵtemplate(18, HeaderComponent_div_18_Template, 3, 0, "div", 14);
          i0.ɵɵpipe(19, "async");
          i0.ɵɵelementEnd()()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!ctx.isLite ? 2 : -1);
          i0.ɵɵadvance(7);
          i0.ɵɵconditional(ctx.login && !ctx.spidAuth && !ctx.isLite ? 9 : -1);
          i0.ɵɵadvance(9);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(19, 3, ctx.modules$));
        }
      },
      dependencies: [CommonModule, i3.NgClass, i3.NgIf, i3.AsyncPipe, FormsModule, ItModalComponent],
      styles: ["header[_ngcontent-%COMP%]{height:80px;background-color:#036;gap:0px;opacity:0px;z-index:1002}header[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:60px;cursor:pointer}header[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-weight:600!important;margin:0!important}header[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{vertical-align:.5em;color:#fff;margin-left:.7em}.svg-container[_ngcontent-%COMP%]{position:relative;width:200px;height:200px}.svg2[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%}.svg1[_ngcontent-%COMP%]{padding:32px;position:absolute;top:0;left:0;width:100%;height:100%}.btn-bg-hover[_ngcontent-%COMP%]:hover{background-color:#c8c8c8!important;font-weight:600}#profile-menu[_ngcontent-%COMP%]{background-color:transparent}.mdc-notched-outline[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{border-color:#fff}a[_ngcontent-%COMP%]{text-decoration:none;color:#fff}h3[_ngcontent-%COMP%]{letter-spacing:1.2px}a[_ngcontent-%COMP%]{display:flex;align-items:center;color:#fff;text-decoration:none}a[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin-right:8px}#portalTitle[_ngcontent-%COMP%]{letter-spacing:1px}.custom-button[_ngcontent-%COMP%]{display:flex;align-items:center}.text[_ngcontent-%COMP%]{order:1;padding-right:8px}.icon[_ngcontent-%COMP%]{order:2;color:#fff}.top-border[_ngcontent-%COMP%]{border-top:1px solid #c3c3c3}.profile-menu-button[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{right:0}.font-weight-normal[_ngcontent-%COMP%]{font-weight:400}.transparent-background[_ngcontent-%COMP%]{background-color:#fff0}.transparent-border[_ngcontent-%COMP%]{border:1px solid rgba(255,255,255,0)}.small-font[_ngcontent-%COMP%]{font-size:16px}.align-right[_ngcontent-%COMP%]{align-items:flex-end}.profile-image[_ngcontent-%COMP%]{width:40px;height:40px;object-fit:cover;cursor:pointer}.profile-image-border[_ngcontent-%COMP%]{border:2px solid white!important;width:50px;height:50px}  .custom-modal .modal-body{background-color:#f2f7fc!important}@media (max-width: 650px){.no-display-650[_ngcontent-%COMP%]{display:none}}.fs-24[_ngcontent-%COMP%]{font-size:24px}.ps-ms-24[_ngcontent-%COMP%]{padding-left:24px!important}.dropdown-item[_ngcontent-%COMP%]{padding:8px 32px}.roleList[_ngcontent-%COMP%]{max-height:400px;overflow:auto}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderComponent, [{
    type: Component,
    args: [{
      selector: 'app-header',
      imports: [CommonModule, FormsModule, ItModalComponent],
      standalone: true,
      template: "<header\n  id=\"headerDiv\"\n  class=\"d-flex justify-content-center align-items-center position-fixed top-0 start-0 end-0\"\n>\n  <div id=\"col-microservizi\" class=\"col d-flex\">\n    @if(!isLite){\n      <div\n        *ngIf=\"login\"\n        id=\"asideDiv\"\n        class=\"ps-3 d-flex justify-content-center align-items-center\"\n      >\n        <button\n          class=\"navbar-toggler d-block d-lg-none\"\n          type=\"button\"\n          (click)=\"leftModal?.toggle()\"\n        >\n          <i class=\"material-symbols-outlined fs-2 text-white\">menu</i>\n        </button>\n      </div>\n    }\n    <div class=\"ps-3\">\n      <a (click)=\"goToHome()\" class=\"d-flex align-items-center\">\n        <img\n          src=\"assets/images/poliblend-aside-small.png\"\n          alt=\"logo Portale Operatori APSS - small\"\n          class=\"d-block\"\n        />\n        <h3 class=\"text-white d-none d-lg-block fs-3 ms-2 text-nowrap\">\n          Portale Operatori Sanitari del Trentino\n        </h3>\n      </a>\n    </div>\n  </div>\n  <div id=\"profile-menu\" class=\"col d-flex justify-content-end align-items-center pe-4\">\n    @if(login && !spidAuth && !isLite){\n      <div class=\"d-none d-md-flex align-items-center\">\n        @if( selectedRole ){\n          <span class=\"text-white fw-semibold d-none d-md-block\">\n            {{ selectedRole.description !== null && selectedRole.description !== '' ? selectedRole.description : selectedRole.name }}\n          </span>\n        } \n      </div>\n      <div class=\"profile-menu-button dropdown d-flex align-items-center\">\n        <button\n          class=\"btn btn-secondary dropdown-toggle bg-transparent d-flex align-items-center p-3\"\n          type=\"button\"\n          id=\"dropdownMenuButton\"\n          data-bs-toggle=\"dropdown\"\n          aria-expanded=\"false\"\n        >\n          <div class=\"d-flex align-items-center transparent-background transparent-border\">\n            <div class=\"rounded-circle me-2 p-2 profile-image-border\">\n              <span class=\"text-nowrap\">{{ getInitials(nameSurname) }}</span>\n            </div>\n            <div class=\"d-flex flex-column ms-2\">\n              <span class=\"text-white font-weight-bold text-nowrap no-display-650\">{{ nameSurname }}</span>\n              <div class=\"d-flex\">\n                <span class=\"text-white font-weight-normal small-font text-end pe-2\">Opzioni</span>\n                <i class=\"material-symbols-outlined ms-2\">arrow_drop_down</i>\n              </div>\n            </div>\n          </div> \n        </button>\n        <ul class=\"dropdown-menu dropdown-menu-end\" aria-labelledby=\"dropdownMenuButton\">\n          <li class=\"text-sm fw-semibold dropdown-item\">{{ nameSurname }}</li>\n          @if(email && email !== ''){\n            <li class=\"text-sm fw-semibold dropdown-item\">{{ email }}</li>\n          }\n          <li class=\"text-sm fw-semibold top-border dropdown-item\">Cambia ruolo:</li>\n          <div *ngIf=\"roles$ | async as roles\" class=\"roleList\">\n            @for(role of roles; track role){\n              <li class=\"d-flex align-items-center dropdown-item\">\n                <div class=\"d-flex align-items-center\" style=\"height: 24px; width: 24px;\">\n                  @if(role.name == selectedRole?.name){\n                    <i class=\"material-symbols-outlined text-primary fs-24\">check_circle</i>\n                  }\n                </div>\n                <button class=\"dropdown-item text-sm p-0 ps-2\" (click)=\"selectRole(role)\" [ngClass]=\"{'text-primary fw-semibold': role.name == selectedRole?.name}\">\n                  {{ role.description !== null && role.description !== '' ? role.description : role.name }}\n                </button>\n              </li>\n            } \n          </div>\n          <li class=\"top-border\">\n            <button class=\"dropdown-item d-flex align-items-center\" (click)=\"logoutService.logoutStatus()\">\n              <i class=\"material-symbols-outlined fs-24\">logout</i>\n              <span class=\"text-sm ps-ms-24\">Esci</span>\n            </button>\n          </li>\n        </ul>\n      </div>\n    }\n  </div>\n</header>\n\n\n<it-modal #leftModal=\"itModal\" alignment=\"left\" scrollable=\"true\" class=\"custom-modal\">\n  <ng-container modalTitle>Menu</ng-container>\n  <div>\n    <div\n      id=\"asideBody\"\n      class=\"h-100 d-flex flex-column justify-content-between pt-3\"\n    >\n      <div class=\"h-100 d-flex flex-column justify-content-between\">\n        <div\n          class=\"d-flex flex-column overflow-y-auto max-height-nav overflow-x-hidden\"\n        >\n          <div *ngIf=\"modules$ | async as modules\">\n            @for(modulo of modules; track modulo){\n              <div class=\"d-flex flex-column pb-3\">\n                <div class=\"d-flex align-items-center p-1 rounded bg-hover pb-2\">\n                  <i class=\"material-symbols-outlined d-flex align-items-center text-primary text-black-ms\">inventory_2</i>\n                  <span class=\"px-2 text-nowrap service-title\" (click)=\"goTo(modulo)\">{{\n                    modulo.name\n                  }}</span>\n                </div>\n              </div>\n              @for (sottomodulo of modulo.subModulesList; track sottomodulo) {\n              @if(sottomodulo.url !== null && sottomodulo.url !== ''){\n              <div class=\"d-flex flex-column pb-3\">\n                <div class=\"d-flex align-items-center p-1 rounded bg-hover\">\n                  <span class=\"px-2 px-mid\" (click)=\"goTo(modulo, sottomodulo)\">{{\n                    sottomodulo.name\n                  }}</span>\n                </div>\n              </div>\n              } } }\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</it-modal>\n\n\n",
      styles: ["header{height:80px;background-color:#036;gap:0px;opacity:0px;z-index:1002}header img{height:60px;cursor:pointer}header h3{font-weight:600!important;margin:0!important}header .dropdown-toggle:after{vertical-align:.5em;color:#fff;margin-left:.7em}.svg-container{position:relative;width:200px;height:200px}.svg2{position:absolute;top:0;left:0;width:100%;height:100%}.svg1{padding:32px;position:absolute;top:0;left:0;width:100%;height:100%}.btn-bg-hover:hover{background-color:#c8c8c8!important;font-weight:600}#profile-menu{background-color:transparent}.mdc-notched-outline>div{border-color:#fff}a{text-decoration:none;color:#fff}h3{letter-spacing:1.2px}a{display:flex;align-items:center;color:#fff;text-decoration:none}a img{margin-right:8px}#portalTitle{letter-spacing:1px}.custom-button{display:flex;align-items:center}.text{order:1;padding-right:8px}.icon{order:2;color:#fff}.top-border{border-top:1px solid #c3c3c3}.profile-menu-button .dropdown-menu{right:0}.font-weight-normal{font-weight:400}.transparent-background{background-color:#fff0}.transparent-border{border:1px solid rgba(255,255,255,0)}.small-font{font-size:16px}.align-right{align-items:flex-end}.profile-image{width:40px;height:40px;object-fit:cover;cursor:pointer}.profile-image-border{border:2px solid white!important;width:50px;height:50px}::ng-deep .custom-modal .modal-body{background-color:#f2f7fc!important}@media (max-width: 650px){.no-display-650{display:none}}.fs-24{font-size:24px}.ps-ms-24{padding-left:24px!important}.dropdown-item{padding:8px 32px}.roleList{max-height:400px;overflow:auto}\n"]
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }, {
    type: LogoutService
  }, {
    type: ModuleService
  }, {
    type: RoleService
  }, {
    type: ModulesSubjectService
  }, {
    type: i1$1.Router
  }], {
    loginInput: [{
      type: Input
    }],
    spidAuth: [{
      type: Input
    }],
    authenticatorHome: [{
      type: Input
    }]
  });
})();
class Page404authenticatorComponent {
  constructor(logoutService) {
    this.logoutService = logoutService;
  }
  backToHome() {
    this.logoutService.logoutStatus();
  }
  static {
    this.ɵfac = function Page404authenticatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Page404authenticatorComponent)(i0.ɵɵdirectiveInject(LogoutService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Page404authenticatorComponent,
      selectors: [["lib-page404authenticator"]],
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 9,
      vars: 1,
      consts: [[3, "authenticatorHome"], [1, "d-flex", "flex-column", "justify-content-center", "align-items-center", 2, "height", "calc(100vh - 80px)", "margin-top", "80px"], [1, "text-center"], [1, "pt-3", "d-flex", "justify-content-center", "align-items-center"], ["color", "primary", 3, "click"]],
      template: function Page404authenticatorComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "app-header", 0);
          i0.ɵɵelementStart(1, "div", 1)(2, "h1", 2);
          i0.ɵɵtext(3, "Ops! Non hai i permessi per accedere a questa pagina.");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "p", 2);
          i0.ɵɵtext(5, "Sembra che tu non sia un utente del portale, se si tratta di un errore si prega di contattare un amministratore di sistema.");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 3)(7, "app-button", 4);
          i0.ɵɵlistener("click", function Page404authenticatorComponent_Template_app_button_click_7_listener() {
            return ctx.backToHome();
          });
          i0.ɵɵtext(8, "Effettua il logout");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("authenticatorHome", true);
        }
      },
      dependencies: [ButtonComponent, HeaderComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Page404authenticatorComponent, [{
    type: Component,
    args: [{
      selector: 'lib-page404authenticator',
      imports: [ButtonComponent, HeaderComponent],
      standalone: true,
      template: "<app-header [authenticatorHome]=\"true\"></app-header>\n<div\n  class=\"d-flex flex-column justify-content-center align-items-center\"\n  style=\"height: calc(100vh - 80px); margin-top: 80px;\"\n>\n  <h1 class=\"text-center\">Ops! Non hai i permessi per accedere a questa pagina.</h1>\n  <p class=\"text-center\">Sembra che tu non sia un utente del portale, se si tratta di un errore si prega di contattare un amministratore di sistema.</p>\n  <div class=\"pt-3 d-flex justify-content-center align-items-center\">\n    <app-button color=\"primary\" (click)=\"backToHome()\">Effettua il logout</app-button>\n  </div>\n</div>"
    }]
  }], () => [{
    type: LogoutService
  }], null);
})();
class BasePageComponent {
  static {
    this.ɵfac = function BasePageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BasePageComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BasePageComponent,
      selectors: [["lib-base-page"]],
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c0,
      decls: 3,
      vars: 0,
      consts: [[1, "ps-lg-0", "pt-2", "pb-3", "index-page"], [1, "bg-base", "rounded"]],
      template: function BasePageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "section", 0)(1, "div", 1);
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd()();
        }
      },
      styles: [".index-page[_ngcontent-%COMP%]{border-radius:15px;width:100%;min-height:calc(100vh - 80px);padding:96px 16px 16px!important}@media (min-width: 992px){.index-page[_ngcontent-%COMP%]{padding-left:260px!important}}.form-label[_ngcontent-%COMP%]{font-size:17px!important}.color-dark[_ngcontent-%COMP%]{color:#000!important;text-decoration:none}select[_ngcontent-%COMP%]{height:45px;max-width:300px}input[_ngcontent-%COMP%]{max-width:300px!important}.bg-base[_ngcontent-%COMP%]{background-color:#f2f7fc;overflow-y:auto;min-height:calc(100vh - 112px);padding:16px}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BasePageComponent, [{
    type: Component,
    args: [{
      selector: 'lib-base-page',
      standalone: true,
      imports: [],
      template: "<section class=\"ps-lg-0 pt-2 pb-3 index-page\">\n    <div class=\"bg-base rounded\">\n        <ng-content></ng-content>\n    </div>\n</section>\n",
      styles: [".index-page{border-radius:15px;width:100%;min-height:calc(100vh - 80px);padding:96px 16px 16px!important}@media (min-width: 992px){.index-page{padding-left:260px!important}}.form-label{font-size:17px!important}.color-dark{color:#000!important;text-decoration:none}select{height:45px;max-width:300px}input{max-width:300px!important}.bg-base{background-color:#f2f7fc;overflow-y:auto;min-height:calc(100vh - 112px);padding:16px}\n"]
    }]
  }], null, null);
})();
class Filtro {
  constructor(nome, id, valore, tipo) {
    this.nome = nome;
    this.id = id;
    this.tipo = tipo;
    this.valore = valore;
  }
}
class FilterModalComponent {
  constructor(fb) {
    this.fb = fb;
    this.filterList = [];
    this.filterSelections = new EventEmitter();
    this.filterForm = this.fb.group({});
  }
  ngOnInit() {
    this.filterForm = this.fb.group(this.createFormGroupConfig(this.filterList));
  }
  createFormGroupConfig(filterList) {
    return filterList.reduce((config, filtro) => {
      config[filtro.nome] = [filtro.valore];
      return config;
    }, {});
  }
  applyFilter() {
    console.debug('apply filter');
    let filterSelectionsTemp = [];
    console.debug('filterList');
    console.debug(this.filterList);
    this.filterList.forEach(element => {
      const filtroTemp = new Filtro(element.nome, element.id, this.filterForm.get(element.nome)?.value, element.tipo);
      filterSelectionsTemp.push(filtroTemp);
    });
    console.debug('stampa filter selectionTemp');
    console.debug(filterSelectionsTemp);
    this.closeModal();
    this.filterSelections.emit(filterSelectionsTemp);
  }
  deleteFilter() {
    this.filterList.forEach(element => {
      element.valore = '';
    });
    this.closeModal();
    this.filterSelections.emit(this.filterList);
  }
  closeModal() {
    const modalElement = document.getElementById('closeModal');
    if (modalElement) {
      const modalInstance = modalElement.modalInstance;
      if (modalInstance) {
        modalInstance.hide();
      }
      const backdropElements = document.querySelectorAll('.modal-backdrop');
      backdropElements.forEach(backdropElement => {
        backdropElement.remove();
      });
    }
    document.body.style.overflow = 'auto';
  }
  trackByFn(index, item) {
    return item.id;
  }
  static {
    this.ɵfac = function FilterModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FilterModalComponent)(i0.ɵɵdirectiveInject(i2$1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FilterModalComponent,
      selectors: [["lib-filter-modal"]],
      inputs: {
        filterList: "filterList"
      },
      outputs: {
        filterSelections: "filterSelections"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 17,
      vars: 1,
      consts: [["id", "closeModal", "size", "lg"], ["modalTitle", ""], [1, "modal-title-container"], [1, "bg-lightblue", 3, "formGroup"], [1, "p-3", "d-flex", "flex-wrap", "input-gap"], ["footer", ""], [1, "d-flex", "flex-row-reverse", "flex-wrap", "input-gap", "pt-3"], ["colore", "primary", "size", "small", 1, "mb-3", 3, "click"], ["colore", "primary", "outlined", "true", "size", "small", 1, "mb-3", 3, "click"], [1, "filter-container", "p-2", "mb-2"], [3, "formControlName", "placeholder", "label"]],
      template: function FilterModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "it-modal", 0);
          i0.ɵɵelementContainerStart(1, 1);
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵtext(3, " Filtri ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementStart(4, "div")(5, "form", 3)(6, "div", 4);
          i0.ɵɵrepeaterCreate(7, FilterModalComponent_For_8_Template, 2, 1, null, null, _forTrack0, true);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementContainerStart(9, 5);
          i0.ɵɵelementStart(10, "div", 6)(11, "app-button", 7);
          i0.ɵɵlistener("click", function FilterModalComponent_Template_app_button_click_11_listener() {
            return ctx.applyFilter();
          });
          i0.ɵɵelementStart(12, "span");
          i0.ɵɵtext(13, "Applica filtri");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(14, "app-button", 8);
          i0.ɵɵlistener("click", function FilterModalComponent_Template_app_button_click_14_listener() {
            return ctx.deleteFilter();
          });
          i0.ɵɵelementStart(15, "span");
          i0.ɵɵtext(16, "Elimina filtri");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("formGroup", ctx.filterForm);
          i0.ɵɵadvance(2);
          i0.ɵɵrepeater(ctx.filterList);
        }
      },
      dependencies: [ButtonComponent, ItModalComponent, ReactiveFormsModule, i2$1.ɵNgNoValidate, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, ItInputComponent],
      styles: ["it-modal .modal-body{background-color:#fff}it-input[_ngcontent-%COMP%]     .form-control{width:300px!important}it-input[_ngcontent-%COMP%]     .form-feedback{position:absolute}.modal-title-container[_ngcontent-%COMP%]{background-color:#fff;padding:1rem;font-size:1.25rem;font-weight:600;border-bottom:1px solid #ccc;outline:none;border:none}.modal-content-container[_ngcontent-%COMP%]{background-color:#fff;padding:1rem;border-top:1px solid #ccc}.input-gap[_ngcontent-%COMP%]   .filter-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-left:1rem}.input-gap[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}.pt-3[_ngcontent-%COMP%]{padding-top:1rem}.d-flex[_ngcontent-%COMP%]{display:flex}.flex-wrap[_ngcontent-%COMP%]{flex-wrap:wrap}.flex-row-reverse[_ngcontent-%COMP%]{flex-direction:row-reverse}.mb-3[_ngcontent-%COMP%]{margin-bottom:1rem}.bg-lightblue[_ngcontent-%COMP%]{background-color:#f2f7fc!important}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterModalComponent, [{
    type: Component,
    args: [{
      selector: 'lib-filter-modal',
      standalone: true,
      imports: [ButtonComponent, ItModalComponent, ReactiveFormsModule, ItInputComponent],
      template: "<it-modal id=\"closeModal\" size=\"lg\">\n    <ng-container modalTitle>\n        <div class=\"modal-title-container\">\n            Filtri\n        </div>\n    </ng-container>\n    <div> \n        <form [formGroup]=\"filterForm\" class=\"bg-lightblue\">\n            <div class=\"p-3 d-flex flex-wrap input-gap\">\n                @for(filtro of filterList; track trackByFn){\n                    @if(filtro.tipo == 'check'){\n                    } @else {\n                        <div class=\"filter-container p-2 mb-2\">\n                            <it-input [formControlName]=\"filtro.nome\" [placeholder]=\"filtro.nome\" [label]=\"filtro.nome\"></it-input>\n                        </div>\n                    }\n                }\n            </div>\n        </form>\n        <ng-container footer>\n            <div class=\"d-flex flex-row-reverse flex-wrap input-gap pt-3\">\n                <app-button class=\"mb-3\" colore=\"primary\" size=\"small\" (click)=\"applyFilter()\">\n                    <span>Applica filtri</span>\n                </app-button>\n                <app-button class=\"mb-3\" colore=\"primary\" outlined=\"true\" size=\"small\" (click)=\"deleteFilter()\">\n                    <span>Elimina filtri</span>\n                </app-button>\n            </div>\n        </ng-container>\n    </div>\n</it-modal>\n\n",
      styles: ["::ng-deep it-modal .modal-body{background-color:#fff}it-input ::ng-deep .form-control{width:300px!important}it-input ::ng-deep .form-feedback{position:absolute}.modal-title-container{background-color:#fff;padding:1rem;font-size:1.25rem;font-weight:600;border-bottom:1px solid #ccc;outline:none;border:none}.modal-content-container{background-color:#fff;padding:1rem;border-top:1px solid #ccc}.input-gap .filter-container{display:flex;flex-direction:column;padding-left:1rem}.input-gap{display:flex;flex-wrap:wrap}.pt-3{padding-top:1rem}.d-flex{display:flex}.flex-wrap{flex-wrap:wrap}.flex-row-reverse{flex-direction:row-reverse}.mb-3{margin-bottom:1rem}.bg-lightblue{background-color:#f2f7fc!important}\n"]
    }]
  }], () => [{
    type: i2$1.FormBuilder
  }], {
    filterList: [{
      type: Input
    }],
    filterSelections: [{
      type: Output
    }]
  });
})();
class getUsersDto {
  constructor(numPage, numRows, searchByName, searchBySurname, searchByFiscalCode, orderByName, orderBySurname, orderByFiscalCode) {
    this.numPage = numPage;
    this.numRows = numRows;
    this.searchByName = searchByName;
    this.searchBySurname = searchBySurname;
    this.searchByFiscalCode = searchByFiscalCode;
    this.orderByName = orderByName;
    this.orderBySurname = orderBySurname;
    this.orderByFiscalCode = orderByFiscalCode;
  }
}
class DelegationFiltersDto {
  constructor(numPage, numRows, searchBySurname, searchByFiscalCode, orderBySurname, orderByFiscalCode, orderByDateFrom, orderByDateTo) {
    this.numPage = numPage, this.numRows = numRows, this.searchBySurname = searchBySurname, this.searchByFiscalCode = searchByFiscalCode, this.orderBySurname = orderBySurname, this.orderByFiscalCode = orderByFiscalCode, this.orderByDateFrom = orderByDateFrom, this.orderByDateTo = orderByDateTo;
  }
}
class DelegheService {
  constructor(http, env) {
    this.http = http;
    this.env = env;
  }
  getDeleghe(numPagina, numRighe, ricercaCognome, ricercaCodiceFiscale, ordinamentoCognome, ordinamentoCodiceFiscale, ordinamentoDataDa, ordinamentoDataA) {
    const delegationFiltersDto = new DelegationFiltersDto(numPagina, numRighe, ricercaCognome, ricercaCodiceFiscale, ordinamentoCognome ?? '', ordinamentoCodiceFiscale ?? '', ordinamentoDataDa ?? '', ordinamentoDataA ?? '');
    const fiscalCodeUser = sessionStorage.getItem('fiscalCode');
    let params = new HttpParams().set('delegationFiltersDto', JSON.stringify(delegationFiltersDto));
    return this.http.post(this.env.beUrl + 'normal-authenticator/delegations/delegator/' + fiscalCodeUser, delegationFiltersDto, {
      params: params
    });
  }
  static {
    this.ɵfac = function DelegheService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DelegheService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ENVIRONMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DelegheService,
      factory: DelegheService.ɵfac,
      providedIn: "root"
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DelegheService, [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }], null);
})();
class RicettaBiancaService {
  constructor(http, env) {
    this.http = http;
    this.env = env;
  }
  getStrutture(token, fiscalCode) {
    console.debug(token);
    const headers = new HttpHeaders({
      Authorization: token
    });
    let params = new HttpParams();
    params = params.append('fiscalCode', fiscalCode);
    return this.http.get(this.env.beUrl + 'ricetta-bianca/users', {
      headers: headers,
      params: params,
      observe: 'response'
    });
  }
  static {
    this.ɵfac = function RicettaBiancaService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RicettaBiancaService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ENVIRONMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RicettaBiancaService,
      factory: RicettaBiancaService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RicettaBiancaService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [ENVIRONMENT]
    }]
  }], null);
})();
class ExportService {
  constructor(userService, delegheService, ricettaBiancaService) {
    this.userService = userService;
    this.delegheService = delegheService;
    this.ricettaBiancaService = ricettaBiancaService;
  }
  getUsers(dto) {
    return this.userService.getAllUsers(dto);
  }
  getDeleghe(numPagina, numElementi, ricercaCognome, ricercaCodiceFiscale, ordinamentoCognome, ordinamentoCodiceFiscale, ordinamentoCodiceDataDa, ordinamentoCodiceDataA) {
    return this.delegheService.getDeleghe(null, null, ricercaCognome, ricercaCodiceFiscale, ordinamentoCognome, ordinamentoCodiceFiscale, ordinamentoCodiceDataDa, ordinamentoCodiceDataA);
  }
  getStrutture(token, fiscalCode) {
    return this.ricettaBiancaService.getStrutture(token, fiscalCode);
  }
  generateCSV(data, fileName) {
    if (!data || data.length === 0) {
      console.error('Nessun dato da esportare.');
      return;
    }
    const csvRows = [];
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(','));
    for (const row of data) {
      const values = headers.map(header => `"${(row[header] || '').toString().replace(/"/g, '""')}"`);
      csvRows.push(values.join(','));
    }
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    console.debug('File CSV generato e scaricato:', fileName);
  }
  generateExcel(data, sheetName, fileName) {
    if (!data || data.length === 0) {
      console.error('Nessun dato da esportare.');
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = {
      Sheets: {
        [sheetName]: worksheet
      },
      SheetNames: [sheetName]
    };
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    const blob = new Blob([excelBuffer], {
      type: 'application/octet-stream'
    });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    console.debug('File Excel generato e scaricato:', fileName);
  }
  static {
    this.ɵfac = function ExportService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ExportService)(i0.ɵɵinject(UserService), i0.ɵɵinject(DelegheService), i0.ɵɵinject(RicettaBiancaService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ExportService,
      factory: ExportService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExportService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: UserService
  }, {
    type: DelegheService
  }, {
    type: RicettaBiancaService
  }], null);
})();
class TableComponent {
  constructor(exportService) {
    this.exportService = exportService;
    this.tableTitle = '';
    this.addFilter = false;
    this.addPage = '';
    this.addAction = '';
    this.currentPage = 0;
    this.rows = 10;
    this.elementNumber = 0;
    this.isExport = false;
    this.filterList = [];
    this.pageChange = new EventEmitter();
    this.filterListSelected = new EventEmitter();
    this.searchedName = '';
    this.searchedSurname = '';
    this.searchedFiscalCode = '';
    this.orderByName = '';
    this.orderBySurname = '';
    this.orderByFiscalCode = '';
    this.orderByDateFrom = '';
    this.orderByDateTo = '';
    this.showFilter = false;
    this.superAdmin = false;
    this.users = [];
    this.deleghe = [];
  }
  // Proprietà per memorizzare l'array di segmenti del percorso
  get addPageSegments() {
    return ['/', ...this.addPage.split('/')];
  }
  ngOnInit() {
    const rows = sessionStorage.getItem(this.tableTitle + 'Rows');
    this.rows = rows !== null && rows !== '' ? +rows : 10;
    const page = sessionStorage.getItem(this.tableTitle + 'Page');
    this.currentPage = page !== null && page !== '' ? +page : 0;
  }
  toggleFilterSection() {
    this.showFilter = !this.showFilter;
  }
  get totalPages() {
    return Math.ceil(this.elementNumber / this.rows);
  }
  get filterEmpty() {
    return this.filterList.every(element => element.valore === '');
  }
  onPageChange(page) {
    console.debug(page);
    this.currentPage = page;
    sessionStorage.setItem(this.tableTitle + 'Page', page.toString());
    this.pageChange.emit({
      first: this.currentPage * this.rows,
      rows: this.rows,
      page: this.currentPage
    });
  }
  changerEvent(rows) {
    console.debug(rows);
    this.currentPage = 0;
    this.rows = rows;
    sessionStorage.setItem(this.tableTitle + 'Page', this.currentPage.toString());
    sessionStorage.setItem(this.tableTitle + 'Rows', rows.toString());
    this.pageChange.emit({
      first: this.currentPage * this.rows,
      rows: this.rows,
      page: this.currentPage
    });
  }
  filterSelection(event) {
    console.debug('filterEmitter');
    console.debug(event);
    this.filterListSelected.emit(event);
  }
  filterRemove(filtroRemoved) {
    const index = this.filterList.findIndex(item => item.id === filtroRemoved.id);
    if (index !== -1) {
      this.filterList[index].valore = '';
      this.filterListSelected.emit(this.filterList);
    }
  }
  exportToCSV() {
    if (this.tableTitle === 'Elenco Operatori abilitati') {
      const dto = new getUsersDto(0, 1000, this.searchedName, this.searchedSurname, this.searchedFiscalCode, this.orderByName, this.orderBySurname, this.orderByFiscalCode);
      this.exportService.getUsers(dto).subscribe({
        next: response => {
          this.users = response.body.data;
          const csvData = this.users.map(users => ({
            Nome: users.name,
            Cognome: users.surname,
            Codice_Fiscale: users.fiscalCode,
            ProfiloAgid: users.profileAgid
          }));
          this.exportService.generateCSV(csvData, 'Lista_Operatori_Abilitati.csv');
        },
        error: err => {
          console.error('Errore nel caricamento degli utenti:', err);
        }
      });
    }
    if (this.tableTitle === 'Lista Deleghe') {
      this.exportService.getDeleghe(0, 1000, this.searchedSurname, this.searchedFiscalCode, this.orderBySurname, this.orderByFiscalCode, this.orderByDateFrom, this.orderByDateTo).subscribe({
        next: response => {
          this.deleghe = Array.isArray(response) ? response : response.data || [];
          if (Array.isArray(this.deleghe)) {
            const csvData = this.deleghe.map(deleghe => ({
              Nome: deleghe.nameSubstitute,
              Cognome: deleghe.surnameSubstitute,
              Codice_Fiscale: deleghe.fiscalCodeSubstitute,
              Data_Inizio: deleghe.dateFrom,
              Data_Fine: deleghe.dateTo,
              Stato: deleghe.status
            }));
            this.exportService.generateCSV(csvData, 'Lista_Deleghe.csv');
          } else {
            console.error('Il formato dei dati ricevuti non è valido:', response);
          }
        },
        error: err => {
          console.error('Errore nel caricamento delle deleghe:', err);
        }
      });
    }
    if (this.tableTitle === 'Lista Strutture') {
      this.token = sessionStorage.getItem('token');
      this.fiscalCode = sessionStorage.getItem('fiscalCode');
      this.exportService.getStrutture(this.token, this.fiscalCode).subscribe({
        next: response => {
          const strutture = response.body.data.map(user => user.strutture).flat();
          const csvData = strutture.map(struttura => ({
            Codice: struttura.codStruttura,
            Descrizione: struttura.desc,
            Email: struttura.email,
            Stato: struttura.stato
          }));
          this.exportService.generateCSV(csvData, 'Lista_Strutture.csv');
        },
        error: err => {
          console.error('Errore nel caricamento delle strutture:', err);
        }
      });
    }
  }
  exportToExcel() {
    if (this.tableTitle === 'Elenco Operatori abilitati') {
      const dto = new getUsersDto(0, 1000, this.searchedName, this.searchedSurname, this.searchedFiscalCode, this.orderByName, this.orderBySurname, this.orderByFiscalCode);
      this.exportService.getUsers(dto).subscribe({
        next: response => {
          this.users = response.body.data;
          const csvData = this.users.map(users => ({
            Nome: users.name,
            Cognome: users.surname,
            Codice_Fiscale: users.fiscalCode,
            ProfiloAgid: users.profileAgid
          }));
          this.exportService.generateExcel(csvData, 'Operatori', 'Lista_Operatori_Abilitati.xlsx');
        },
        error: err => {
          console.error('Errore nel caricamento degli utenti:', err);
        }
      });
    }
    if (this.tableTitle === 'Lista Deleghe') {
      this.exportService.getDeleghe(0, 1000, this.searchedSurname, this.searchedFiscalCode, this.orderBySurname, this.orderByFiscalCode, this.orderByDateFrom, this.orderByDateTo).subscribe({
        next: response => {
          this.deleghe = Array.isArray(response) ? response : response.data || [];
          if (Array.isArray(this.deleghe)) {
            const csvData = this.deleghe.map(deleghe => ({
              Nome: deleghe.nameSubstitute,
              Cognome: deleghe.surnameSubstitute,
              Codice_Fiscale: deleghe.fiscalCodeSubstitute,
              Data_Inizio: deleghe.dateFrom,
              Data_Fine: deleghe.dateTo,
              Stato: deleghe.status
            }));
            this.exportService.generateExcel(csvData, 'Deleghe', 'Lista_Deleghe.xlsx');
          } else {
            console.error('Il formato dei dati ricevuti non è valido:', response);
          }
        },
        error: err => {
          console.error('Errore nel caricamento delle deleghe:', err);
        }
      });
    }
    if (this.tableTitle === 'Lista Strutture') {
      this.token = sessionStorage.getItem('token');
      this.fiscalCode = sessionStorage.getItem('fiscalCode');
      this.exportService.getStrutture(this.token, this.fiscalCode).subscribe({
        next: response => {
          const strutture = response.body.data.map(user => user.strutture).flat();
          const excelData = strutture.map(struttura => ({
            Codice: struttura.codStruttura,
            Descrizione: struttura.desc,
            Email: struttura.email,
            Stato: struttura.stato
          }));
          this.exportService.generateExcel(excelData, 'Strutture', 'Lista_Strutture.xlsx');
        },
        error: err => {
          console.error('Errore nel caricamento delle strutture:', err);
        }
      });
    }
  }
  static {
    this.ɵfac = function TableComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableComponent)(i0.ɵɵdirectiveInject(ExportService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TableComponent,
      selectors: [["lib-table"]],
      inputs: {
        tableTitle: "tableTitle",
        addFilter: "addFilter",
        addPage: "addPage",
        addAction: "addAction",
        currentPage: "currentPage",
        rows: "rows",
        elementNumber: "elementNumber",
        isExport: "isExport",
        filterList: "filterList",
        searchedName: "searchedName",
        searchedSurname: "searchedSurname",
        searchedFiscalCode: "searchedFiscalCode",
        orderByName: "orderByName",
        orderBySurname: "orderBySurname",
        orderByFiscalCode: "orderByFiscalCode",
        orderByDateFrom: "orderByDateFrom",
        orderByDateTo: "orderByDateTo"
      },
      outputs: {
        pageChange: "pageChange",
        filterListSelected: "filterListSelected"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c0,
      decls: 12,
      vars: 10,
      consts: [["id", "tableContainer", 1, "d-flex", "flex-column"], ["id", "tableTitleFilter", 1, "d-flex", "justify-content-between", "align-items-center"], [1, "m-0", "text-nowrap", "table-title"], ["id", "actionSection", 1, "d-flex"], [1, "d-flex", "justify-content-center", "align-items-center", "rounded", "action-hover", 3, "routerLink"], [1, "dropdown", "rounded", "action-hover"], [1, "d-flex", "bg-white"], [3, "pageEvent", "changerEvent", "currentPage", "pageNumbers", "currentChanger", "changerValues"], [3, "filterSelections", "filterList"], [1, "material-symbols-outlined", "d-flex", "align-items-center", "fs-5"], [1, "d-none", "d-md-block", "ps-1", "pe-2", "text-nowrap", "fw-semibold"], ["data-bs-toggle", "dropdown", "aria-expanded", "false", 1, "d-flex", "justify-content-center", "align-items-center", "dropdown-toggle"], [1, "dropdown-menu"], [1, "dropdown-item", 3, "click"], ["data-bs-toggle", "modal", "data-bs-target", "#closeModal", 1, "p-3", "d-flex", "align-items-center", "filter-border", "action-hover"], [1, "d-flex", "justify-content-center", "align-items-center", "rounded", "bg-white"], [1, "ps-1", "text-nowrap", "fw-semibold"], [1, "d-flex", "flex-wrap", "p-3"], [1, "me-2", 3, "label", "showCloseButton"], [1, "me-2", 3, "closeEvent", "label", "showCloseButton"]],
      template: function TableComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "div", 3);
          i0.ɵɵtemplate(5, TableComponent_Conditional_5_Template, 5, 2, "div", 4)(6, TableComponent_Conditional_6_Template, 13, 0, "div", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(7, TableComponent_Conditional_7_Template, 10, 0, "div", 6);
          i0.ɵɵelementStart(8, "div");
          i0.ɵɵprojection(9);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "it-pagination", 7);
          i0.ɵɵlistener("pageEvent", function TableComponent_Template_it_pagination_pageEvent_10_listener($event) {
            return ctx.onPageChange($event);
          })("changerEvent", function TableComponent_Template_it_pagination_changerEvent_10_listener($event) {
            return ctx.changerEvent($event);
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(11, "lib-filter-modal", 8);
          i0.ɵɵlistener("filterSelections", function TableComponent_Template_lib_filter_modal_filterSelections_11_listener($event) {
            return ctx.filterSelection($event);
          });
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(ctx.tableTitle);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.addFilter ? 5 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isExport ? 6 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.addFilter ? 7 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("currentPage", ctx.currentPage)("pageNumbers", ctx.totalPages)("currentChanger", ctx.rows)("changerValues", i0.ɵɵpureFunction0(9, _c4));
          i0.ɵɵadvance();
          i0.ɵɵproperty("filterList", ctx.filterList);
        }
      },
      dependencies: [CommonModule, RouterLink, ItPaginationComponent, FilterModalComponent, ItChipComponent],
      styles: ["#tableContainer[_ngcontent-%COMP%]{border:1px solid #94C4F5;border-radius:8px!important;color:#036!important}#tableTitleFilter[_ngcontent-%COMP%]{height:60px;padding:12px 16px}#tableTitleFilter[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:8px 12px}#tableTitleFilter[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:20px!important;color:#036!important}#tableTitleFilter[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:16px!important;color:#06c!important}#tableTitleFilter[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#06c!important}.action-hover[_ngcontent-%COMP%]:hover{cursor:pointer;background-color:#e6e6fa!important}.action-hover[_ngcontent-%COMP%]:hover   div[_ngcontent-%COMP%]{background-color:#e6e6fa!important}[_ngcontent-%COMP%]::ng   deep[_ngcontent-%COMP%]   .icon-primary[_ngcontent-%COMP%]{fill:#036!important}  it-pagination .pagination{margin:auto;padding:10px}  it-pagination   it-dropdown{display:flex;align-items:center}  it-chip .chip{border:1px solid #003366!important;background-color:#fff;margin:0!important}  it-chip .icon{width:25px!important;height:25px!important;fill:#036!important}  it-chip .chip-label{color:#036!important;font-weight:700!important}.table-title[_ngcontent-%COMP%]{color:#036;font-size:20px;line-height:24px;text-align:left}.filter-border[_ngcontent-%COMP%]{border-right:1px solid #d9e4f7!important}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableComponent, [{
    type: Component,
    args: [{
      selector: 'lib-table',
      standalone: true,
      imports: [CommonModule, RouterLink, ItPaginationComponent, FilterModalComponent, ItChipComponent],
      schemas: [CUSTOM_ELEMENTS_SCHEMA],
      template: "<div id=\"tableContainer\" class=\"d-flex flex-column\">\n  <div id=\"tableTitleFilter\" class=\"d-flex justify-content-between align-items-center\">\n    <h3 class=\"m-0 text-nowrap table-title\">{{ tableTitle }}</h3>\n    <div id=\"actionSection\" class=\"d-flex\">\n      @if(addFilter) {\n        <div\n          class=\"d-flex justify-content-center align-items-center rounded action-hover\"\n          [routerLink]=\"addPageSegments\"\n        >\n          <i class=\"material-symbols-outlined d-flex align-items-center fs-5\">add</i>\n          <span class=\"d-none d-md-block ps-1 pe-2 text-nowrap fw-semibold\">{{ addAction }}</span>\n        </div>\n      }\n      @if(isExport) {\n        <div class=\"dropdown rounded action-hover\">\n          <div\n            class=\"d-flex justify-content-center align-items-center dropdown-toggle\"\n            data-bs-toggle=\"dropdown\" aria-expanded=\"false\"\n          >\n            <i class=\"material-symbols-outlined d-flex align-items-center fs-5\">file_download</i>\n            <span class=\"d-none d-md-block ps-1 pe-2 text-nowrap fw-semibold\">Esporta</span>\n          </div>\n          <ul class=\"dropdown-menu\">\n            <li>\n              <a class=\"dropdown-item\" (click)=\"exportToCSV()\">Esporta in .csv</a>\n            </li>\n            <li>\n              <a class=\"dropdown-item\" (click)=\"exportToExcel()\">Esporta in .xlsx</a>\n            </li>\n          </ul>\n        </div>\n      }\n    </div>\n  </div>\n  @if(addFilter) {\n    <div class=\"d-flex bg-white\">\n      <div class=\"p-3 d-flex align-items-center filter-border action-hover\" data-bs-toggle=\"modal\" data-bs-target=\"#closeModal\">\n        <div\n          class=\"d-flex justify-content-center align-items-center rounded bg-white\" \n        >\n          <i class=\"material-symbols-outlined d-flex align-items-center fs-5\">filter_alt</i>\n          <span class=\"ps-1 text-nowrap fw-semibold\">Filtra</span>\n        </div>\n      </div>\n      <div class=\"d-flex flex-wrap p-3\">\n        @for(filtro of filterList; track filtro) {\n          @if(filtro.valore !== '') {\n            <it-chip\n              [label]=\"filtro.nome + ': ' + filtro.valore\"\n              [showCloseButton]=\"true\"\n              (closeEvent)=\"filterRemove(filtro)\"\n              class=\"me-2\"\n            ></it-chip>\n          }\n        }\n      </div>\n    </div>\n  }\n  <div>\n    <ng-content></ng-content>\n  </div>\n  <it-pagination\n    [currentPage]=\"currentPage\"\n    [pageNumbers]=\"totalPages\"\n    [currentChanger]=\"rows\"\n    [changerValues]=\"[10, 20, 30]\"\n    (pageEvent)=\"onPageChange($event)\"\n    (changerEvent)=\"changerEvent($event)\"\n  >\n  </it-pagination>\n</div>\n\n<lib-filter-modal [filterList]=\"filterList\" (filterSelections)=\"filterSelection($event)\"></lib-filter-modal>\n",
      styles: ["#tableContainer{border:1px solid #94C4F5;border-radius:8px!important;color:#036!important}#tableTitleFilter{height:60px;padding:12px 16px}#tableTitleFilter div{padding:8px 12px}#tableTitleFilter h3{font-size:20px!important;color:#036!important}#tableTitleFilter span{font-size:16px!important;color:#06c!important}#tableTitleFilter i{color:#06c!important}.action-hover:hover{cursor:pointer;background-color:#e6e6fa!important}.action-hover:hover div{background-color:#e6e6fa!important}::ng deep .icon-primary{fill:#036!important}::ng-deep it-pagination .pagination{margin:auto;padding:10px}::ng-deep it-pagination ::ng-deep it-dropdown{display:flex;align-items:center}::ng-deep it-chip .chip{border:1px solid #003366!important;background-color:#fff;margin:0!important}::ng-deep it-chip .icon{width:25px!important;height:25px!important;fill:#036!important}::ng-deep it-chip .chip-label{color:#036!important;font-weight:700!important}.table-title{color:#036;font-size:20px;line-height:24px;text-align:left}.filter-border{border-right:1px solid #d9e4f7!important}\n"]
    }]
  }], () => [{
    type: ExportService
  }], {
    tableTitle: [{
      type: Input
    }],
    addFilter: [{
      type: Input
    }],
    addPage: [{
      type: Input
    }],
    addAction: [{
      type: Input
    }],
    currentPage: [{
      type: Input
    }],
    rows: [{
      type: Input
    }],
    elementNumber: [{
      type: Input
    }],
    isExport: [{
      type: Input
    }],
    filterList: [{
      type: Input
    }],
    pageChange: [{
      type: Output
    }],
    filterListSelected: [{
      type: Output
    }],
    searchedName: [{
      type: Input
    }],
    searchedSurname: [{
      type: Input
    }],
    searchedFiscalCode: [{
      type: Input
    }],
    orderByName: [{
      type: Input
    }],
    orderBySurname: [{
      type: Input
    }],
    orderByFiscalCode: [{
      type: Input
    }],
    orderByDateFrom: [{
      type: Input
    }],
    orderByDateTo: [{
      type: Input
    }]
  });
})();
class MultiButtonComponent {
  constructor() {
    this.saveClick = new EventEmitter();
    this.backClick = new EventEmitter();
    this.deleteClick = new EventEmitter();
    this.required = false;
    this.delete = false;
    this.homePage = '';
    this.deleteModal = '';
  }
  buttonDo(action) {
    switch (action) {
      case 'save':
        this.saveClick.emit(true);
        break;
      case 'back':
        this.backClick.emit(true);
        break;
      case 'delete':
        this.deleteClick.emit(true);
        break;
    }
  }
  static {
    this.ɵfac = function MultiButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MultiButtonComponent,
      selectors: [["lib-multi-button"]],
      inputs: {
        required: "required",
        delete: "delete",
        homePage: "homePage",
        deleteModal: "deleteModal"
      },
      outputs: {
        saveClick: "saveClick",
        backClick: "backClick",
        deleteClick: "deleteClick"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 9,
      vars: 4,
      consts: [[1, "pt-5", "px-2", "d-flex", "flex-row-reverse", "align-items-center", "justify-content-between", "col-12"], ["type", "submit", "colore", "primary", "size", "small"], ["size", "small", 3, "disabled"], ["colore", "danger", "data-bs-toggle", "modal", "size", "small", 1, "pe-3"], ["colore", "primary", "size", "small", "outlined", "true", 1, "pe-3", 3, "click", "routerLink"], [1, "pe-2"], ["size", "sm", "color", "primary", 1, "material-symbols-outlined", "fs-5"], ["type", "submit", "colore", "primary", "size", "small", 3, "click"], ["size", "sm", "color", "white", 1, "material-symbols-outlined", "fs-5", "text-white"], ["size", "sm", "color", "save", 1, "material-symbols-outlined", "fs-5", "text-white"], ["colore", "danger", "data-bs-toggle", "modal", "size", "small", 1, "pe-3", 3, "click"]],
      template: function MultiButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, MultiButtonComponent_Conditional_1_Template, 5, 0, "app-button", 1)(2, MultiButtonComponent_Conditional_2_Template, 5, 1, "app-button", 2)(3, MultiButtonComponent_Conditional_3_Template, 5, 1, "app-button", 3);
          i0.ɵɵelementStart(4, "app-button", 4);
          i0.ɵɵlistener("click", function MultiButtonComponent_Template_app_button_click_4_listener() {
            return ctx.buttonDo("back");
          });
          i0.ɵɵelementStart(5, "span", 5);
          i0.ɵɵtext(6, "Annulla");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "i", 6);
          i0.ɵɵtext(8, "close");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.required ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.required ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.delete ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("routerLink", ctx.homePage);
        }
      },
      dependencies: [ButtonComponent, RouterLink]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiButtonComponent, [{
    type: Component,
    args: [{
      selector: 'lib-multi-button',
      standalone: true,
      imports: [ButtonComponent, RouterLink],
      template: "<div class=\"pt-5 px-2 d-flex flex-row-reverse align-items-center justify-content-between col-12\">\n  @if(required){\n    <app-button type=\"submit\" colore=\"primary\" (click)=\"buttonDo('save')\" size=\"small\"><span class=\"pe-2\">Salva</span>\n      <i class=\"material-symbols-outlined fs-5 text-white\" size=\"sm\" color=\"white\" >save</i>\n    </app-button>\n  }\n  @if(!required){\n    <app-button [disabled]=\"'true'\" size=\"small\"><span class=\"pe-2\">Salva</span>\n      <i class=\"material-symbols-outlined fs-5 text-white\" size=\"sm\" color=\"save\">save</i>\n    </app-button>\n  }\n\n  @if(delete){\n    <app-button colore=\"danger\" data-bs-toggle=\"modal\" class=\"pe-3\" size=\"small\" \n    [attr.data-bs-target]=\"'#' + deleteModal\" (click)=\"buttonDo('delete')\">\n      <span class=\"pe-2\">Elimina</span>\n      <i class=\"material-symbols-outlined fs-5 text-white\" size=\"sm\" color=\"white\">delete</i>\n    </app-button>\n  }\n\n  <app-button\n  colore=\"primary\"\n  size=\"small\"\n  class=\"pe-3\"\n  outlined=\"true\"\n  [routerLink]=\"homePage\"\n  (click)=\"buttonDo('back')\">\n    <span class=\"pe-2\">Annulla</span>\n    <i class=\"material-symbols-outlined fs-5\" size=\"sm\" color=\"primary\">close</i>\n  </app-button>\n</div>\n"
    }]
  }], null, {
    saveClick: [{
      type: Output
    }],
    backClick: [{
      type: Output
    }],
    deleteClick: [{
      type: Output
    }],
    required: [{
      type: Input
    }],
    delete: [{
      type: Input
    }],
    homePage: [{
      type: Input
    }],
    deleteModal: [{
      type: Input
    }]
  });
})();
class BreadcrumbComponent {
  constructor(route) {
    this.route = route;
    this.breadcrumbs = [];
  }
  ngOnInit() {
    this.breadcrumbs = this.buildBreadcrumbs(this.route.root);
    console.debug('Breadcrumbs:', this.breadcrumbs);
  }
  buildBreadcrumbs(route, url = '', breadcrumbs = []) {
    const children = route.children;
    // Se non ci sono figli, restituisci i breadcrumbs
    if (children.length === 0) {
      return breadcrumbs;
    }
    for (const child of children) {
      const routeURL = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL) {
        url += `/${routeURL}`;
      }
      const label = child.snapshot.data['breadcrumb'];
      if (label) {
        breadcrumbs.push({
          label,
          url
        });
      }
      // Continua con i figli ricorsivamente (senza return)
      this.buildBreadcrumbs(child, url, breadcrumbs);
    }
    // Restituisci l'array di breadcrumb solo alla fine, dopo il ciclo for
    return breadcrumbs;
  }
  static {
    this.ɵfac = function BreadcrumbComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BreadcrumbComponent)(i0.ɵɵdirectiveInject(i1$1.ActivatedRoute));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BreadcrumbComponent,
      selectors: [["lib-breadcrumb"]],
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 1,
      consts: [[3, "href", "ariaCurrent", 4, "ngFor", "ngForOf"], [3, "href", "ariaCurrent"]],
      template: function BreadcrumbComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "it-breadcrumb");
          i0.ɵɵtemplate(1, BreadcrumbComponent_it_breadcrumb_item_1_Template, 2, 3, "it-breadcrumb-item", 0);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.breadcrumbs);
        }
      },
      dependencies: [ItBreadcrumbComponent, ItBreadcrumbItemComponent, CommonModule, i3.NgForOf],
      styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]     .breadcrumb{padding-top:0;margin-bottom:0}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbComponent, [{
    type: Component,
    args: [{
      selector: 'lib-breadcrumb',
      standalone: true,
      imports: [ItBreadcrumbComponent, ItBreadcrumbItemComponent, CommonModule],
      template: "<it-breadcrumb>\n  <it-breadcrumb-item *ngFor=\"let breadcrumb of breadcrumbs; let last = last\" \n                      [href]=\"breadcrumb.url\" \n                      [ariaCurrent]=\"last ? 'page' : null\">\n    {{ breadcrumb.label }}\n  </it-breadcrumb-item>\n</it-breadcrumb>\n",
      styles: [":host{display:block}:host ::ng-deep .breadcrumb{padding-top:0;margin-bottom:0}\n"]
    }]
  }], () => [{
    type: i1$1.ActivatedRoute
  }], null);
})();
class HeadingPageComponent {
  constructor() {
    this.title = '';
    this.subtitle = '';
  }
  static {
    this.ɵfac = function HeadingPageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HeadingPageComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HeadingPageComponent,
      selectors: [["lib-heading-page"]],
      inputs: {
        title: "title",
        subtitle: "subtitle"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 6,
      vars: 2,
      consts: [["id", "titleSection"], [1, "text-start"], [1, "ms-fs-medium", "pb-4"]],
      template: function HeadingPageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "section", 0);
          i0.ɵɵelement(1, "lib-breadcrumb");
          i0.ɵɵelementStart(2, "h1", 1);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "p", 2);
          i0.ɵɵtext(5);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(ctx.title);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.subtitle, " ");
        }
      },
      dependencies: [BreadcrumbComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeadingPageComponent, [{
    type: Component,
    args: [{
      selector: 'lib-heading-page',
      standalone: true,
      imports: [BreadcrumbComponent],
      template: "<section id=\"titleSection\">\n    <lib-breadcrumb></lib-breadcrumb>\n    <h1 class=\"text-start\">{{title}}</h1>\n    <p class=\"ms-fs-medium pb-4\">\n    {{subtitle}}\n    </p>\n</section>\n"
    }]
  }], null, {
    title: [{
      type: Input
    }],
    subtitle: [{
      type: Input
    }]
  });
})();
class ApssMainAppComponent {
  static {
    this.ɵfac = function ApssMainAppComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ApssMainAppComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ApssMainAppComponent,
      selectors: [["lib-apss-main-app"]],
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c0,
      decls: 6,
      vars: 0,
      consts: [[1, "d-flex"], [1, "flex-grow-1"]],
      template: function ApssMainAppComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelement(0, "app-header");
          i0.ɵɵelementStart(1, "div", 0);
          i0.ɵɵelement(2, "app-aside");
          i0.ɵɵelementStart(3, "div", 1)(4, "lib-base-page");
          i0.ɵɵprojection(5);
          i0.ɵɵelementEnd()()();
        }
      },
      dependencies: [HeaderComponent, AsideComponent, BasePageComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApssMainAppComponent, [{
    type: Component,
    args: [{
      selector: 'lib-apss-main-app',
      standalone: true,
      imports: [HeaderComponent, AsideComponent, BasePageComponent],
      template: "<app-header></app-header>\n<div class=\"d-flex\">\n  <app-aside></app-aside>\n  <div class=\"flex-grow-1\">\n    <lib-base-page>\n      <ng-content></ng-content>\n    </lib-base-page>\n  </div>\n</div>"
    }]
  }], null, null);
})();
const authInterceptor = (req, next) => {
  const tokenService = inject(TokenStorageService);
  const permissionService = inject(RoleService);
  const token = tokenService.getToken();
  const permission = permissionService.getPermissionForApi();
  console.debug("Token interceptor");
  if (token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: token,
        Permission: permission ?? ''
      }
    });
    console.debug("inserimento token e permission");
    return next(authReq);
  }
  return next(req);
};
class CustomNotificationService extends ItNotificationService {
  constructor() {
    super(...arguments);
    this.lastNotificationElement = null;
  }
  getLastNotificationElement() {
    // Supponiamo che tutte le notifiche abbiano una classe comune, ad esempio "notification"
    const notifications = document.querySelectorAll('.notification');
    return notifications.length > 0 ? notifications[notifications.length - 1] : null;
  }
  getLatestNotificationElement() {
    return this.lastNotificationElement;
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵCustomNotificationService_BaseFactory;
      return function CustomNotificationService_Factory(__ngFactoryType__) {
        return (ɵCustomNotificationService_BaseFactory || (ɵCustomNotificationService_BaseFactory = i0.ɵɵgetInheritedFactory(CustomNotificationService)))(__ngFactoryType__ || CustomNotificationService);
      };
    })();
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CustomNotificationService,
      factory: CustomNotificationService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomNotificationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
let sessionTimer = null; // Timer globale
const SESSION_TIMEOUT = 105 * 60 * 1000; // 1 ora e 45 minuti
const tokenInterceptor = (req, next) => {
  const tokenService = inject(TokenStorageService);
  const logoutService = inject(LogoutService);
  const notificationService = inject(ItNotificationService);
  const env = inject(ENVIRONMENT);
  const roleService = inject(RoleService);
  const notificationElement = inject(CustomNotificationService);
  // Funzione per resettare il timer
  const resetSessionTimer = () => {
    if (sessionTimer) {
      clearTimeout(sessionTimer);
      console.debug('Avvio Timer');
    } else {
      console.debug('Avvio Timer');
    }
    // Imposta un nuovo timer
    sessionTimer = setTimeout(() => {
      // Mostra la notifica
      notificationService.warning('La tua sessione sta per scadere.', '', false, 150000 // 15 minuti
      );
      const latestNotification = notificationElement.getLastNotificationElement();
      console.debug(latestNotification);
      console.debug('Notifica mostrata');
      // Trova l'elemento della notifica nel DOM
      const refreshElement = document.getElementById(latestNotification?.id ?? '');
      const refreshLink = refreshElement?.querySelector('h2');
      console.debug(refreshLink);
      if (refreshElement && refreshLink) {
        // Verifica se esiste già un link di aggiornamento
        let existingLink = refreshLink.querySelector('.refresh-link');
        if (!existingLink) {
          // Se il link non esiste, crealo
          const newLink = document.createElement('a');
          newLink.href = '#';
          newLink.classList.add('refresh-link');
          newLink.innerHTML = ' Clicca qui per aggiornare la sessione';
          // Aggiungi l'event listener al nuovo link
          newLink.addEventListener('click', event => {
            event.preventDefault();
            const headers = new HttpHeaders({
              Authorization: roleService.getUserToken() ?? ''
            });
            // Esegui la chiamata API per aggiornare il token
            const headersObject = {};
            headers.keys().forEach(key => {
              const value = headers.get(key);
              if (value) {
                headersObject[key] = value;
              }
            });
            // Esegui la chiamata API per aggiornare il token
            fetch(`${env.beUrl}/session-manager/refresh-token`, {
              headers: headersObject,
              method: 'GET'
            }).then(response => {
              if (!response.ok) {
                throw new Error('Errore nella risposta del server');
              }
              return response.text(); // Assumi che il token sia nel corpo come testo
            }).then(newToken => {
              if (newToken) {
                tokenService.saveToken(newToken);
                console.debug('Token aggiornato con successo.');
                const successMessage = 'Sessione aggiornata correttamente';
                const notificationElement = document.getElementById('warning-0-notification');
                if (notificationElement) {
                  notificationElement.remove(); // Rimuove l'elemento dal DOM
                }
                notificationService.success(successMessage);
                resetSessionTimer(); // Resetta il timer dopo il rinnovo
              } else {
                const notificationElement = document.getElementById('warning-0-notification');
                if (notificationElement) {
                  notificationElement.remove(); // Rimuove l'elemento dal DOM
                }
                notificationService.error('Errore durante il rinnovo del token');
                console.error('Errore durante il rinnovo del token.');
              }
            }).catch(error => {
              const notificationElement = document.getElementById('warning-0-notification');
              if (notificationElement) {
                notificationElement.remove(); // Rimuove l'elemento dal DOM
              }
              notificationService.error('Errore durante il rinnovo del token');
              console.error('Errore nella chiamata di aggiornamento del token:', error);
            });
          });
          const br = document.createElement('br');
          refreshLink.appendChild(br);
          // Aggiungi il link creato alla notifica
          refreshLink.appendChild(newLink);
        } else {
          // Se il link esiste già, aggiorna il testo
          existingLink.innerHTML = 'La tua sessione sta per scadere. Clicca qui per aggiornare la sessione';
        }
      }
    }, SESSION_TIMEOUT);
  };
  return next(req).pipe(tap({
    next: event => {
      if (event instanceof HttpResponse) {
        const newToken = event.headers.get('Authorization'); // Ottieni il token dall'header
        resetSessionTimer(); // Resetta il timer al salvataggio del nuovo token
        if (newToken && sessionStorage.getItem('token') !== newToken) {
          if (newToken === 'invalid') {
            sessionStorage.clear();
            logoutService.logoutStatus();
          } else {
            console.debug('Refresh token effettuato');
            tokenService.saveToken(newToken); // Salva il nuovo token
          }
        }
      }
    }
  }));
};
class ChipService {
  constructor() {
    this.primary = 'chip-primary';
    this.warning = 'chip-warning';
    this.danger = 'chip-danger';
    this.success = 'chip-success';
    this.default = 'default-chip';
  }
  getChipColor(stato) {
    switch (stato) {
      case 'in corso':
        return this.primary;
      case 'completa':
        return this.success;
      case 'pianificata':
        return this.warning;
      case 'incompleta':
        return this.danger;
      default:
        return this.default;
    }
  }
  static {
    this.ɵfac = function ChipService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChipService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ChipService,
      factory: ChipService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChipService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class ChipComponent {
  constructor(chipService) {
    this.chipService = chipService;
    this.status = '';
    this.size = '14px';
    this.label = '';
  }
  getChipColor() {
    return this.chipService.getChipColor(this.label);
  }
  static {
    this.ɵfac = function ChipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChipComponent)(i0.ɵɵdirectiveInject(ChipService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ChipComponent,
      selectors: [["app-chip"]],
      inputs: {
        status: "status",
        size: "size",
        label: "label"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 5,
      consts: [[1, "chip-container"], [1, "chip", 3, "ngClass", "ngStyle"]],
      template: function ChipComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.getChipColor())("ngStyle", i0.ɵɵpureFunction1(3, _c5, ctx.size));
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        }
      },
      dependencies: [NgClass, CommonModule, i3.NgStyle],
      styles: [".chip[_ngcontent-%COMP%]{display:inline-flex;justify-content:center;align-items:center;padding:4.8px 24px;min-width:110px;border-radius:16px;font-weight:600;color:#fff;font-family:Arial,sans-serif;text-align:center;line-height:1;border-width:2px;border-style:solid;transition:none}.chip-success[_ngcontent-%COMP%]{border-color:#258528;color:#258528}.chip-warning[_ngcontent-%COMP%]{border-color:#b0730b;color:#b0730b}.chip-primary[_ngcontent-%COMP%]{border-color:#0d4576;color:#0d4576}.chip-danger[_ngcontent-%COMP%]{border-color:#b10a0a;color:#b10a0a}.default-chip[_ngcontent-%COMP%]{border-color:#757575;color:#757575}.chip[_ngcontent-%COMP%]:hover{color:inherit;border-color:inherit;background-color:transparent}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChipComponent, [{
    type: Component,
    args: [{
      selector: 'app-chip',
      imports: [NgClass, CommonModule],
      standalone: true,
      template: " <div class=\"chip-container\">\n    <div class=\"chip\" [ngClass]=\"getChipColor()\" [ngStyle]=\"{'font-size': size}\">\n      {{ label }}\n    </div>\n  </div>",
      styles: [".chip{display:inline-flex;justify-content:center;align-items:center;padding:4.8px 24px;min-width:110px;border-radius:16px;font-weight:600;color:#fff;font-family:Arial,sans-serif;text-align:center;line-height:1;border-width:2px;border-style:solid;transition:none}.chip-success{border-color:#258528;color:#258528}.chip-warning{border-color:#b0730b;color:#b0730b}.chip-primary{border-color:#0d4576;color:#0d4576}.chip-danger{border-color:#b10a0a;color:#b10a0a}.default-chip{border-color:#757575;color:#757575}.chip:hover{color:inherit;border-color:inherit;background-color:transparent}\n"]
    }]
  }], () => [{
    type: ChipService
  }], {
    status: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    label: [{
      type: Input
    }]
  });
})();
class CardComponent {
  constructor(router) {
    this.router = router;
  }
  goTo() {
    this.router.navigate([this.path]);
  }
  static {
    this.ɵfac = function CardComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardComponent)(i0.ɵɵdirectiveInject(i1$1.Router));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardComponent,
      selectors: [["lib-card"]],
      inputs: {
        title: "title",
        text: "text",
        icon: "icon",
        path: "path"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 8,
      vars: 3,
      consts: [[1, "apss-card", 3, "click"], [1, "card-title"], [1, "material-symbols-outlined"]],
      template: function CardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("click", function CardComponent_Template_div_click_0_listener() {
            return ctx.goTo();
          });
          i0.ɵɵelementStart(1, "it-card")(2, "h4", 1)(3, "span", 2);
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd();
          i0.ɵɵtext(5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "p");
          i0.ɵɵtext(7);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(ctx.icon);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.title);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.text);
        }
      },
      dependencies: [ItCardComponent],
      styles: [".lead[_ngcontent-%COMP%]{font-size:1.25rem;line-height:1.5rem}.label[_ngcontent-%COMP%]{font-size:1rem;font-weight:700;line-height:1.125rem}.caption[_ngcontent-%COMP%]{font-size:.875rem;line-height:1rem}h1[_ngcontent-%COMP%]{min-height:3.5rem;font-size:2rem}h1[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:1.25rem;font-weight:600}h2[_ngcontent-%COMP%]{font-size:1.75rem;line-height:2.5rem;font-weight:700}h3[_ngcontent-%COMP%]{font-size:1.5rem;line-height:2rem;font-weight:700}h4[_ngcontent-%COMP%]{font-size:1.25rem;line-height:2rem}h5[_ngcontent-%COMP%]{font-size:1.125rem;line-height:1.5rem}h6[_ngcontent-%COMP%], .ms-fs-medium[_ngcontent-%COMP%]{font-size:1rem;line-height:1.5rem}.text-sm[_ngcontent-%COMP%]{font-size:1rem}.apss-card[_ngcontent-%COMP%]{display:block;overflow:hidden;width:22.75rem;height:12rem;border-radius:.25rem;box-shadow:0 .25rem .25rem #00000026;background-color:#fff;cursor:pointer}h4[_ngcontent-%COMP%]{display:flex;margin-bottom:1rem;color:#06c;font-size:1.5rem!important;font-weight:600;align-items:center}p[_ngcontent-%COMP%]{font-size:1rem;font-weight:400}span[_ngcontent-%COMP%]{color:#1a1a1a;font-size:1.9rem;margin-right:1rem}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardComponent, [{
    type: Component,
    args: [{
      selector: 'lib-card',
      standalone: true,
      imports: [ItCardComponent],
      template: "<div class=\"apss-card\" (click)=\"goTo()\">\n    <it-card>\n        <h4 class=\"card-title\"><span class=\"material-symbols-outlined\">{{icon}}</span>{{title}}</h4>\n        <p>{{text}}</p>\n    </it-card>\n</div>\n\n",
      styles: [".lead{font-size:1.25rem;line-height:1.5rem}.label{font-size:1rem;font-weight:700;line-height:1.125rem}.caption{font-size:.875rem;line-height:1rem}h1{min-height:3.5rem;font-size:2rem}h1 span{font-size:1.25rem;font-weight:600}h2{font-size:1.75rem;line-height:2.5rem;font-weight:700}h3{font-size:1.5rem;line-height:2rem;font-weight:700}h4{font-size:1.25rem;line-height:2rem}h5{font-size:1.125rem;line-height:1.5rem}h6,.ms-fs-medium{font-size:1rem;line-height:1.5rem}.text-sm{font-size:1rem}.apss-card{display:block;overflow:hidden;width:22.75rem;height:12rem;border-radius:.25rem;box-shadow:0 .25rem .25rem #00000026;background-color:#fff;cursor:pointer}h4{display:flex;margin-bottom:1rem;color:#06c;font-size:1.5rem!important;font-weight:600;align-items:center}p{font-size:1rem;font-weight:400}span{color:#1a1a1a;font-size:1.9rem;margin-right:1rem}\n"]
    }]
  }], () => [{
    type: i1$1.Router
  }], {
    title: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    text: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    icon: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    path: [{
      type: Input,
      args: [{
        required: true
      }]
    }]
  });
})();
class CountrySelectComponent {
  constructor(locationService, cdr) {
    this.locationService = locationService;
    this.cdr = cdr;
    this.label = 'Nazione';
    this.placeholder = 'Seleziona una nazione';
    // Observable per i paesi
    this.countriesSubject = new BehaviorSubject([]);
    this.countries$ = this.countriesSubject.asObservable();
    this.onChange = value => {};
    this.onTouched = () => {};
    this.isDisabled = false;
  }
  ngOnInit() {
    this.loadCountries();
  }
  async loadCountries() {
    try {
      const countries = await firstValueFrom(this.locationService.getCountry());
      this.countriesSubject.next(countries); // aggiorna l'observable con i paesi recuperati
      this.cdr.detectChanges(); // forza il rilevamento delle modifiche
    } catch (error) {
      console.error('Failed to fetch countries', error);
    }
  }
  writeValue(value) {
    this.selectedValue = value;
    this.cdr.detectChanges();
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.isDisabled = isDisabled;
    this.cdr.detectChanges();
  }
  onSelectChange(value) {
    this.selectedValue = value;
    this.onChange(value);
    if (this.formGroup && this.formControlName) {
      this.formGroup.get(this.formControlName)?.setValue(value, {
        emitEvent: true
      });
    }
    this.cdr.detectChanges();
  }
  static {
    this.ɵfac = function CountrySelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CountrySelectComponent)(i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CountrySelectComponent,
      selectors: [["apss-country-select"]],
      inputs: {
        formControlName: "formControlName",
        formGroup: "formGroup",
        label: "label",
        placeholder: "placeholder"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CountrySelectComponent),
        multi: true
      }]), i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 4,
      consts: [[3, "formGroup"], [4, "ngIf"], ["id", "country-select", 3, "ngModelChange", "label", "ngModel", "ngModelOptions", "disabled"], [3, "value"], [3, "value", "selected", 4, "ngFor", "ngForOf"], [3, "value", "selected"]],
      template: function CountrySelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, CountrySelectComponent_div_1_Template, 5, 8, "div", 1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx.countries$));
        }
      },
      dependencies: [ItSelectComponent, ReactiveFormsModule, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, CommonModule, i3.NgForOf, i3.NgIf, i3.AsyncPipe, FormsModule, i2$1.NgModel],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CountrySelectComponent, [{
    type: Component,
    args: [{
      selector: 'apss-country-select',
      standalone: true,
      imports: [ItSelectComponent, ReactiveFormsModule, CommonModule, FormsModule],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CountrySelectComponent),
        multi: true
      }],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div [formGroup]=\"formGroup\">\n  <div *ngIf=\"countries$ | async as countries\">\n    <it-select\n      id=\"country-select\"\n      [label]=\"label\"\n      [(ngModel)]=\"selectedValue\"\n      (ngModelChange)=\"onSelectChange($event)\"\n      [ngModelOptions]=\"{ standalone: true }\"\n      [disabled]=\"isDisabled\"\n    >\n      <option [value]=\"''\">{{ placeholder }}</option>\n      <option *ngFor=\"let country of countries\" [value]=\"country.municipalityCode\" [selected]=\"country.municipalityCode == selectedValue\">\n        {{ country.municipalityName }}\n      </option>\n    </it-select>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: LocationService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    formControlName: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    formGroup: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    label: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }]
  });
})();
class MunicipalitySelectComponent {
  set selectedProvince(value) {
    if (value !== this._selectedProvince) {
      this._selectedProvince = value;
      this.loadMunicipalities(); // Ricarica i comuni quando la provincia cambia
    }
  }
  get selectedProvince() {
    return this._selectedProvince;
  }
  constructor(locationService, cdr) {
    this.locationService = locationService;
    this.cdr = cdr;
    this.label = 'Seleziona Comune';
    this.placeholder = 'Seleziona un comune';
    this.disabled = false;
    // Observable per i dati dei comuni
    this.municipalitiesSubject = new BehaviorSubject([]);
    this.municipalities$ = this.municipalitiesSubject.asObservable();
    this.onChange = value => {};
    this.onTouched = () => {};
  }
  ngOnInit() {
    // Avvia il caricamento completo dei comuni in background
    this.loadMunicipalities();
  }
  async loadMunicipalities() {
    try {
      if (this.selectedProvince) {
        const province = await firstValueFrom(this.locationService.getProvinceById(this.selectedProvince));
        if (province.id == this.selectedProvince) {
          const municipalities = await firstValueFrom(this.locationService.getMunicipalityByProvince(province.code));
          this.municipalitiesSubject.next(municipalities); // aggiorna l'observable con i comuni recuperati
        } else {
          const municipalities = await firstValueFrom(this.locationService.getMunicipality());
          this.municipalitiesSubject.next(municipalities); // aggiorna l'observable con i comuni recuperati
        }
      } else {
        const municipalities = await firstValueFrom(this.locationService.getMunicipality());
        this.municipalitiesSubject.next(municipalities); // aggiorna l'observable con i comuni recuperati
      }
      this.cdr.detectChanges(); // forza il rilevamento delle modifiche
    } catch (error) {
      console.error('Failed to fetch municipalities', error);
    }
  }
  writeValue(value) {
    this.selectedValue = value;
    this.cdr.detectChanges();
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  onSelectChange(value) {
    this.selectedValue = value;
    this.onChange(value);
    if (this.formGroup && this.formControlName) {
      this.formGroup.get(this.formControlName)?.setValue(value, {
        emitEvent: true
      });
    }
    this.cdr.detectChanges();
  }
  async getMunicipalityByCode(municipalityCode) {
    const municipalities = await firstValueFrom(this.locationService.getMunicipalityByMunicipalityCode(municipalityCode));
    this.municipalitiesSubject.next(municipalities);
  }
  static {
    this.ɵfac = function MunicipalitySelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MunicipalitySelectComponent)(i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MunicipalitySelectComponent,
      selectors: [["apss-municipality-select"]],
      inputs: {
        formControlName: "formControlName",
        formGroup: "formGroup",
        label: "label",
        placeholder: "placeholder",
        disabled: "disabled",
        selectedProvince: "selectedProvince"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MunicipalitySelectComponent),
        multi: true
      }]), i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 4,
      consts: [[3, "formGroup"], [4, "ngIf"], ["id", "municipality-select", 3, "ngModelChange", "label", "ngModel", "ngModelOptions", "disabled"], [3, "value", "selected"], [3, "value", "selected", 4, "ngFor", "ngForOf"]],
      template: function MunicipalitySelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, MunicipalitySelectComponent_div_1_Template, 2, 1, "div", 1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx.municipalities$));
        }
      },
      dependencies: [ItSelectComponent, ReactiveFormsModule, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, CommonModule, i3.NgForOf, i3.NgIf, i3.AsyncPipe, FormsModule, i2$1.NgModel],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MunicipalitySelectComponent, [{
    type: Component,
    args: [{
      selector: 'apss-municipality-select',
      standalone: true,
      imports: [ItSelectComponent, ReactiveFormsModule, CommonModule, FormsModule, ReactiveFormsModule],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MunicipalitySelectComponent),
        multi: true
      }],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div [formGroup]=\"formGroup\">\n  <div *ngIf=\"municipalities$ | async as municipalities\">\n    <div *ngIf=\"municipalities.length > 0\">\n      <it-select\n        id=\"municipality-select\"\n        [label]=\"label\"\n        [(ngModel)]=\"selectedValue\"\n        (ngModelChange)=\"onSelectChange($event)\"\n        [ngModelOptions]=\"{ standalone: true }\"\n        disabled=\"{{disabled ? 'true': 'false'}}\"\n      >\n        <option [value]=\"''\" [selected]=\"!selectedValue || selectedValue === 'EE'\">{{ placeholder }}</option>\n        <option *ngFor=\"let municipality of municipalities\" [value]=\"municipality.municipalityCode\" [selected]=\"municipality.municipalityCode == selectedValue\">\n          {{ selectedProvince ? municipality.municipalityName : (municipality.municipalityName + \" (\" + municipality.province + \")\") }}\n        </option>\n      </it-select>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: LocationService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    formControlName: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    formGroup: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    label: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    selectedProvince: [{
      type: Input
    }]
  });
})();
class MunicipalityInputComponent {
  constructor(locationService) {
    this.locationService = locationService;
    this.label = 'Comune';
    this.placeholder = 'Inserisci il comune';
    this.municipalitiesSubject = new BehaviorSubject([]);
    this.municipalities$ = this.municipalitiesSubject.asObservable().pipe(tap$1(municipalities => {
      const formattedTerm = this.searchTerm;
      const matchedMunicipality = municipalities.find(municipality => `${municipality.municipalityName} (${municipality.province})`.toLowerCase() === formattedTerm.toLowerCase());
      this.showDropdown = !matchedMunicipality && formattedTerm.length >= 2;
    }));
    this.searchTerm = ''; // Testo di visualizzazione nell'input
    this.selectedMunicipalityCode = null; // Codice del comune selezionato
    this.showDropdown = false;
    this.showError = false;
    this.onChange = value => {};
    this.onTouched = () => {};
  }
  ngOnInit() {
    // Verifica che il controllo sia associato correttamente
    const control = this.formGroup.get(this.formControlName);
    if (!control) {
      throw new Error(`Control "${this.formControlName}" not found in formGroup.`);
    }
  }
  ngAfterViewInit() {
    // Forza un aggiornamento dello stato grafico del componente
    const control = this.formGroup.get(this.formControlName);
    if (control) {
      setTimeout(() => control.updateValueAndValidity(), 0);
    }
  }
  onSearchTermChange(term) {
    this.searchTerm = term;
    this.showDropdown = term.length >= 2;
    if (term.length >= 2) {
      this.getMunicipalityByLetters(term);
    } else {
      this.municipalitiesSubject.next([]);
      this.showDropdown = false;
    }
    // Controlla se il valore inserito corrisponde esattamente a un comune valido
    firstValueFrom(this.municipalities$).then(municipalities => {
      const matchedMunicipality = municipalities.find(municipality => `${municipality.municipalityName} (${municipality.province})`.toLowerCase() === term.toLowerCase());
      if (this.formGroup && this.formControlName) {
        const control = this.formGroup.get(this.formControlName);
        if (!matchedMunicipality) {
          this.showError = true;
          control?.setValue('', {
            emitEvent: true
          });
        } else {
          this.showError = false;
          this.selectedMunicipalityCode = matchedMunicipality.municipalityCode;
          control?.setValue(this.selectedMunicipalityCode, {
            emitEvent: true
          });
        }
        // Forza la propagazione dello stato di errore
        control?.updateValueAndValidity({
          emitEvent: true
        });
      }
    }).catch(error => {
      console.error("Errore durante il recupero dei comuni:", error);
    });
  }
  getMunicipalityByLetters(letters) {
    firstValueFrom(this.locationService.getMunicipalityByLetters(letters)).then(municipalities => {
      this.municipalitiesSubject.next(municipalities);
    }).catch(err => console.error(err));
  }
  // Metodo di selezione di un suggerimento dal dropdown
  selectMunicipality(municipality) {
    // Aggiorna il valore visualizzato nell'input
    const formattedValue = `${municipality.municipalityName} (${municipality.province})`;
    this.searchTerm = formattedValue;
    this.selectedMunicipalityCode = municipality.municipalityCode;
    // Aggiorna il FormControl con il codice del comune selezionato
    if (this.formGroup && this.formControlName) {
      const control = this.formGroup.get(this.formControlName);
      control?.setValue(this.selectedMunicipalityCode, {
        emitEvent: true
      });
      control?.updateValueAndValidity();
    }
    this.showDropdown = false;
    this.showError = false;
    this.onTouched();
  }
  // Implementazione di ControlValueAccessor
  writeValue(value) {
    this.selectedMunicipalityCode = value;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {}
  static {
    this.ɵfac = function MunicipalityInputComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MunicipalityInputComponent)(i0.ɵɵdirectiveInject(LocationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MunicipalityInputComponent,
      selectors: [["lib-municipality-input"]],
      inputs: {
        formControlName: "formControlName",
        formGroup: "formGroup",
        label: "label",
        placeholder: "placeholder"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MunicipalityInputComponent),
        multi: true
      }]), i0.ɵɵStandaloneFeature],
      decls: 7,
      vars: 13,
      consts: [[1, "position-relative", 3, "formGroup"], ["id", "autocompleteInput", 3, "ngModelChange", "placeholder", "label", "ngModel", "ngModelOptions"], ["error", ""], [4, "ngIf"], ["class", "suggestions-dropdown", 4, "ngIf"], [1, "suggestions-dropdown"], ["class", "dropdown-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "click"]],
      template: function MunicipalityInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "it-input", 1);
          i0.ɵɵlistener("ngModelChange", function MunicipalityInputComponent_Template_it_input_ngModelChange_1_listener($event) {
            return ctx.onSearchTermChange($event);
          });
          i0.ɵɵelementContainerStart(2, 2);
          i0.ɵɵtemplate(3, MunicipalityInputComponent_div_3_Template, 2, 0, "div", 3)(4, MunicipalityInputComponent_div_4_Template, 2, 1, "div", 3);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, MunicipalityInputComponent_div_5_Template, 2, 1, "div", 3);
          i0.ɵɵpipe(6, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_1_0;
          let tmp_6_0;
          let tmp_7_0;
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("is-invalid", ((tmp_1_0 = ctx.formGroup.get(ctx.formControlName)) == null ? null : tmp_1_0.invalid) && ((tmp_1_0 = ctx.formGroup.get(ctx.formControlName)) == null ? null : tmp_1_0.touched));
          i0.ɵɵproperty("placeholder", ctx.placeholder)("label", ctx.label)("ngModel", ctx.searchTerm)("ngModelOptions", i0.ɵɵpureFunction0(12, _c6));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", (tmp_6_0 = ctx.formGroup.get(ctx.formControlName)) == null ? null : tmp_6_0.hasError("required"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", (tmp_7_0 = ctx.formGroup.get(ctx.formControlName)) == null ? null : tmp_7_0.hasError("invalidMunicipality"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 10, ctx.municipalities$));
        }
      },
      dependencies: [CommonModule, i3.NgForOf, i3.NgIf, i3.AsyncPipe, FormsModule, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.NgModel, ReactiveFormsModule, i2$1.FormGroupDirective, ItInputComponent],
      styles: [".suggestions-dropdown[_ngcontent-%COMP%]{position:absolute;top:100%;left:0;width:100%;z-index:1000;background-color:#fff;border:1px solid #ced4da;border-top:none;max-height:300px;overflow-y:auto;box-shadow:0 4px 8px #0000001a}.dropdown-item[_ngcontent-%COMP%]{padding:10px}.municipality-div[_ngcontent-%COMP%]{margin-bottom:3rem}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MunicipalityInputComponent, [{
    type: Component,
    args: [{
      selector: 'lib-municipality-input',
      standalone: true,
      imports: [CommonModule, FormsModule, ReactiveFormsModule, ItInputComponent],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MunicipalityInputComponent),
        multi: true
      }],
      template: "<div class=\"position-relative\" [formGroup]=\"formGroup\">\n  <!-- Campo di input per il termine di ricerca -->\n  <it-input\n    id=\"autocompleteInput\"\n    [placeholder]=\"placeholder\"\n    [label]=\"label\"\n    [ngModel]=\"searchTerm\"\n    (ngModelChange)=\"onSearchTermChange($event)\"\n    [ngModelOptions]=\"{ standalone: true }\"\n    [class.is-invalid]=\"formGroup.get(formControlName)?.invalid && formGroup.get(formControlName)?.touched\"\n  >\n    <!-- Messaggi di errore -->\n    <ng-container error>\n      <div *ngIf=\"formGroup.get(formControlName)?.hasError('required')\">\n        Il campo \u00E8 obbligatorio.\n      </div>\n      <div *ngIf=\"formGroup.get(formControlName)?.hasError('invalidMunicipality')\">\n        {{ formGroup.get(formControlName)?.getError('invalidMunicipality') }}\n      </div>\n    </ng-container>\n  </it-input>\n\n  <!-- Dropdown per i suggerimenti filtrati -->\n  <div *ngIf=\"municipalities$ | async as filteredMunicipalities\">\n    <div *ngIf=\"(filteredMunicipalities.length > 0 && showDropdown)\" class=\"suggestions-dropdown\">\n      <!-- Lista dei suggerimenti -->\n      <button\n        class=\"dropdown-item\"\n        *ngFor=\"let municipality of filteredMunicipalities\"\n        (click)=\"selectMunicipality(municipality)\"\n      >\n        {{ municipality.municipalityName }} ({{ municipality.province }})\n      </button>\n    </div>\n  </div>\n</div>\n",
      styles: [".suggestions-dropdown{position:absolute;top:100%;left:0;width:100%;z-index:1000;background-color:#fff;border:1px solid #ced4da;border-top:none;max-height:300px;overflow-y:auto;box-shadow:0 4px 8px #0000001a}.dropdown-item{padding:10px}.municipality-div{margin-bottom:3rem}\n"]
    }]
  }], () => [{
    type: LocationService
  }], {
    formControlName: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    formGroup: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    label: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }]
  });
})();
class ProvinceSelectComponent {
  set disabled(value) {
    this.setDisabledState(value);
  }
  constructor(locationService, cdr) {
    this.locationService = locationService;
    this.cdr = cdr;
    this.label = 'Etichetta';
    this.placeholder = 'Seleziona una provincia';
    // Observable per i paesi
    this.provincesSubject = new BehaviorSubject([]);
    this.provinces$ = this.provincesSubject.asObservable();
    this.onChange = value => {};
    this.onTouched = () => {};
    this.isDisabled = false;
  }
  ngOnInit() {
    this.loadProvinces();
  }
  async loadProvinces() {
    try {
      const provinces = await firstValueFrom(this.locationService.getProvinces());
      this.provincesSubject.next(provinces); // aggiorna l'observable con i paesi recuperati
      this.cdr.detectChanges(); // forza il rilevamento delle modifiche
    } catch (error) {
      console.error('Failed to fetch provinces', error);
    }
  }
  writeValue(value) {
    this.selectedValue = value;
    this.cdr.detectChanges();
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.isDisabled = isDisabled;
    this.cdr.detectChanges(); // Aggiorna lo stato disabilitato
  }
  onSelectChange(value) {
    this.selectedValue = value;
    this.onChange(value);
    if (this.formGroup && this.formControlName) {
      this.formGroup.get(this.formControlName)?.setValue(value, {
        emitEvent: true
      });
    }
    this.cdr.detectChanges();
  }
  static {
    this.ɵfac = function ProvinceSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProvinceSelectComponent)(i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProvinceSelectComponent,
      selectors: [["apss-province-select"]],
      inputs: {
        formControlName: "formControlName",
        formGroup: "formGroup",
        label: "label",
        placeholder: "placeholder",
        disabled: "disabled"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ProvinceSelectComponent),
        multi: true
      }]), i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 4,
      consts: [[3, "formGroup"], [4, "ngIf"], ["id", "municipality-select", 3, "ngModelChange", "label", "ngModel", "ngModelOptions", "disabled"], [3, "value"], [3, "value", "selected", 4, "ngFor", "ngForOf"], [3, "value", "selected"]],
      template: function ProvinceSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, ProvinceSelectComponent_div_1_Template, 5, 8, "div", 1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx.provinces$));
        }
      },
      dependencies: [ItSelectComponent, ReactiveFormsModule, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, CommonModule, i3.NgForOf, i3.NgIf, i3.AsyncPipe, FormsModule, i2$1.NgModel],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProvinceSelectComponent, [{
    type: Component,
    args: [{
      selector: 'apss-province-select',
      standalone: true,
      imports: [ItSelectComponent, ReactiveFormsModule, CommonModule, FormsModule, ReactiveFormsModule],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ProvinceSelectComponent),
        multi: true
      }],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div [formGroup]=\"formGroup\">\n  <div *ngIf=\"provinces$ | async as provinces\">\n    <it-select\n      id=\"municipality-select\"\n      [label]=\"label\"\n      [ngModel]=\"selectedValue\"\n      (ngModelChange)=\"onSelectChange($event)\"\n      [ngModelOptions]=\"{ standalone: true }\"\n      [disabled]=\"isDisabled\" \n    >\n      <!-- Placeholder per il valore vuoto -->\n      <option [value]=\"''\">{{ placeholder }}</option>\n\n      <!-- Lista delle province -->\n      <option *ngFor=\"let province of provinces\" [value]=\"province.id\" [selected]=\"province.id == selectedValue\">\n        {{ province.name }}\n      </option>\n    </it-select>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: LocationService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    formControlName: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    formGroup: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    label: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }]
  });
})();
class PathStorageService {
  constructor(router) {
    this.router = router;
    this.lastPath = '';
    console.debug('Servizio lastPath partito');
    // Ottieni il BaseUrl dal tag <base> nell'HTML
    const baseUrl = this.getBaseHref();
    console.debug('BaseUrl iniziale:', baseUrl);
    // Verifica il BaseUrl e avvia il tracking solo se valido
    this.trackRouteChanges(baseUrl);
    this.trackManualUrlChanges(baseUrl);
    this.overrideHistoryMethods(baseUrl);
    this.savePath(baseUrl); // Salva solo il BaseUrl all'avvio
  }
  getBaseHref() {
    // Legge il valore del tag <base href="...">
    const baseElement = document.querySelector('base');
    return baseElement?.getAttribute('href')?.replace(/\/$/, '') || ''; // Rimuove lo slash finale
  }
  trackRouteChanges(baseUrl) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.savePath(baseUrl);
      }
    });
  }
  trackManualUrlChanges(baseUrl) {
    window.addEventListener('popstate', () => {
      this.savePath(baseUrl);
    });
  }
  overrideHistoryMethods(baseUrl) {
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    history.pushState = (...args) => {
      originalPushState.apply(history, args);
      this.savePath(baseUrl);
    };
    history.replaceState = (...args) => {
      originalReplaceState.apply(history, args);
      this.savePath(baseUrl);
    };
  }
  savePath(path) {
    console.debug('savePath chiamato con:', path);
    // Controlla se il path è valido prima di salvarlo
    if (!this.isValidBaseUrl(path)) {
      console.warn('Path escluso dal salvataggio:', path);
      return;
    }
    if (sessionStorage.getItem('isLite') == 'true') {
      return;
    }
    if (this.lastPath !== path) {
      this.lastPath = path;
      const fiscalCode = sessionStorage.getItem('fiscalCode');
      localStorage.setItem('lastPath/' + fiscalCode, path);
    }
  }
  isValidBaseUrl(baseUrl) {
    const excludedKeywords = ['authenticator', 'spid-authenticator', 'entra-authenticator', 'passaggio-contesto'];
    return !excludedKeywords.some(keyword => baseUrl.includes(keyword));
  }
  getLastPath() {
    const fiscalCode = sessionStorage.getItem('fiscalCode');
    return localStorage.getItem('lastPath/' + fiscalCode);
  }
  static {
    this.ɵfac = function PathStorageService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PathStorageService)(i0.ɵɵinject(i1$1.Router));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PathStorageService,
      factory: PathStorageService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PathStorageService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.Router
  }], null);
})();
function initializePathStorage(service) {
  return () => service; // Forza l'istanza del servizio
}
class PolifunzioneLibModule {
  static forRoot(environment) {
    return {
      ngModule: PolifunzioneLibModule,
      providers: [PolifunzioneLibService, {
        provide: APP_INITIALIZER,
        useFactory: initializePathStorage,
        deps: [PathStorageService],
        multi: true
      }, {
        provide: APP_INITIALIZER,
        useFactory: initializeErrorMessages,
        deps: [ErrorMessagesService],
        multi: true
      }, {
        provide: ENVIRONMENT,
        useValue: environment
      }, provideDesignAngularKit({
        translateLoader: provideDynamicTranslateLoader()
      }), provideHttpClient(withInterceptors([authInterceptor, tokenInterceptor]))]
    };
  }
  static {
    this.ɵfac = function PolifunzioneLibModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PolifunzioneLibModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PolifunzioneLibModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [AsideComponent, HeaderComponent, Page404authenticatorComponent, TableComponent, CommonModule, HeadingPageComponent, ApssMainAppComponent, ReactiveFormsModule, ChipComponent,
      // CodiceFiscaleComponent, 
      CardComponent, BreadcrumbComponent, CountrySelectComponent, MunicipalitySelectComponent, MunicipalityInputComponent, ProvinceSelectComponent, RouterModule, DeniedAccessRoutingModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PolifunzioneLibModule, [{
    type: NgModule,
    args: [{
      declarations: [PolifunzioneLibComponent],
      imports: [BasePageComponent, AsideComponent, HeaderComponent, ButtonComponent, Page404Component, Page404authenticatorComponent, TableComponent, CommonModule, MultiButtonComponent, HeadingPageComponent, ApssMainAppComponent, ReactiveFormsModule, ChipComponent,
      // CodiceFiscaleComponent, 
      CardComponent, BreadcrumbComponent, CountrySelectComponent, MunicipalitySelectComponent, MunicipalityInputComponent, ProvinceSelectComponent, DeniedAccesPageComponent, RouterModule, DeniedAccessRoutingModule],
      exports: [PolifunzioneLibComponent, BasePageComponent, HeaderComponent, MultiButtonComponent, AsideComponent, ButtonComponent, Page404Component, Page404authenticatorComponent, TableComponent, HeadingPageComponent, ApssMainAppComponent,
      // CodiceFiscaleComponent,
      ChipComponent, CardComponent, CountrySelectComponent, MunicipalitySelectComponent, ProvinceSelectComponent, MunicipalityInputComponent, DeniedAccesPageComponent]
    }]
  }], null, null);
})();
class SelectComponent {
  constructor() {
    this._options = of([]);
    this.disabled = false;
    this.label = '';
    this.placeholder = '';
    this.formControlName = '';
    this.onChange = () => {};
    this.onTouched = () => {};
  }
  set options(value) {
    this._options = value instanceof Observable ? value : of(value);
  }
  // Required for ControlValueAccessor
  writeValue(value) {
    this.selected = value;
  }
  registerOnChange(fn) {
    this.onChange = fn;
    console.debug('registerOnChange');
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
    console.debug('registerOnTouched');
  }
  setDisabledState(isDisabled) {
    console.debug('setDisabledState:', isDisabled);
    this.disabled = isDisabled;
  }
  onSelectChange(event) {
    console.debug('onSelectChange event:', event.target.value); // Log dell'evento per capire la struttura
    const value = event.target.value; // Utilizza direttamente l'evento come valore
    const extractedValue = value.split(':')[1];
    this.formGroup.get(this.formControlName)?.setValue(extractedValue);
    this.onChange(extractedValue);
    this.onTouched();
  }
  static {
    this.ɵfac = function SelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SelectComponent,
      selectors: [["apss-select"]],
      inputs: {
        disabled: "disabled",
        label: "label",
        placeholder: "placeholder",
        formControlName: "formControlName",
        formGroup: "formGroup",
        options: "options"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => SelectComponent),
        multi: true // This is required to register as a form control
      }]), i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 9,
      consts: [[3, "change", "ngModelChange", "label", "options", "defaultOption", "formControlName", "disabled", "ngModel", "formGroup"]],
      template: function SelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainerStart(0);
          i0.ɵɵelementStart(1, "it-select", 0);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵlistener("change", function SelectComponent_Template_it_select_change_1_listener($event) {
            return ctx.onSelectChange($event);
          });
          i0.ɵɵtwoWayListener("ngModelChange", function SelectComponent_Template_it_select_ngModelChange_1_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.selected, $event) || (ctx.selected = $event);
            return $event;
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementContainerEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("label", ctx.label)("options", i0.ɵɵpipeBind1(2, 7, ctx._options))("defaultOption", ctx.placeholder)("formControlName", ctx.formControlName)("disabled", ctx.disabled);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selected);
          i0.ɵɵproperty("formGroup", ctx.formGroup);
        }
      },
      dependencies: [ItSelectComponent, CommonModule, i3.AsyncPipe, ReactiveFormsModule, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectComponent, [{
    type: Component,
    args: [{
      selector: 'apss-select',
      standalone: true,
      imports: [ItSelectComponent, CommonModule, ReactiveFormsModule],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => SelectComponent),
        multi: true // This is required to register as a form control
      }],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<ng-container>\n  <it-select\n    [label]=\"label\"\n    [options]=\"(_options | async)!\"\n    [defaultOption]=\"placeholder\"\n    [formControlName]=\"formControlName\"\n    [disabled]=\"disabled\"\n    (change)=\"onSelectChange($event)\"\n    [(ngModel)]=\"selected\"\n    [formGroup]=\"formGroup\">\n  </it-select>\n</ng-container>\n"
    }]
  }], null, {
    disabled: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    formControlName: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    formGroup: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    options: [{
      type: Input
    }]
  });
})();
class EntitySelectComponent {
  constructor(apssDataService) {
    this.apssDataService = apssDataService;
    this.disabled = false;
    this.formControlName = '';
    this.entitiesSubject = new BehaviorSubject([]);
    this.entities$ = this.entitiesSubject.asObservable();
  }
  ngOnInit() {
    this.apssDataService.getAllEntity().then(entities => {
      this.entitiesSubject.next(entities);
    }).catch(error => {
      console.error('Failed to load entities', error);
    });
  }
  // Convert Entity[] into SelectControlOption[] for apss-select
  getEntityOptions(entities) {
    return entities.map(entity => ({
      text: entity.name,
      // The text that will be displayed
      value: entity.id // The value bound to the form control
    }));
  }
  static {
    this.ɵfac = function EntitySelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EntitySelectComponent)(i0.ɵɵdirectiveInject(ApssDataService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: EntitySelectComponent,
      selectors: [["lib-entity-select"]],
      inputs: {
        disabled: "disabled",
        label: "label",
        formGroup: "formGroup",
        formControlName: "formControlName"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 4,
      consts: [[1, "d-flex", "flex-column", "mb-2", 3, "formGroup"], [4, "ngIf"], ["label", "Ente", "placeholder", "Seleziona un ente", 3, "options", "formControlName", "disabled", "formGroup"]],
      template: function EntitySelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, EntitySelectComponent_div_1_Template, 2, 4, "div", 1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx.entities$));
        }
      },
      dependencies: [SelectComponent, CommonModule, i3.NgIf, i3.AsyncPipe, FormsModule, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, ReactiveFormsModule, i2$1.FormGroupDirective, i2$1.FormControlName]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EntitySelectComponent, [{
    type: Component,
    args: [{
      selector: 'lib-entity-select',
      standalone: true,
      imports: [SelectComponent, CommonModule, FormsModule, ReactiveFormsModule],
      template: "<div class=\"d-flex flex-column mb-2\" [formGroup]=\"formGroup\">\n    <div *ngIf=\"entities$ | async as entities\">\n      <apss-select\n        label=\"Ente\"\n        placeholder=\"Seleziona un ente\"\n        [options]=\"getEntityOptions(entities)\"\n        [formControlName]=\"formControlName\"\n        [disabled]=\"disabled\"\n        [formGroup]=\"formGroup\">\n      </apss-select>\n    </div>\n</div>\n\n"
    }]
  }], () => [{
    type: ApssDataService
  }], {
    disabled: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    formGroup: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    formControlName: [{
      type: Input,
      args: [{
        required: true
      }]
    }]
  });
})();
class JobsSelectComponent {
  constructor(apssDataService) {
    this.apssDataService = apssDataService;
    this.disabled = false;
    this.formControlName = '';
    this.jobsSubject = new BehaviorSubject([]);
    this.jobs$ = this.jobsSubject.asObservable();
  }
  ngOnInit() {
    this.apssDataService.getAllJobs().then(entities => {
      this.jobsSubject.next(entities);
    }).catch(error => {
      console.error('Failed to load jobs', error);
    });
  }
  // This method converts Job[] into SelectControlOption[]
  getJobOptions(jobs) {
    return jobs.map(job => ({
      text: job.name,
      // The text that will be displayed
      value: job.id // The value bound to the form control
    }));
  }
  static {
    this.ɵfac = function JobsSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JobsSelectComponent)(i0.ɵɵdirectiveInject(ApssDataService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: JobsSelectComponent,
      selectors: [["lib-jobs-select"]],
      inputs: {
        disabled: "disabled",
        label: "label",
        formGroup: "formGroup",
        formControlName: "formControlName"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 4,
      consts: [[1, "d-flex", "flex-column", "mb-2", 3, "formGroup"], [4, "ngIf"], ["label", "Mansione", "placeholder", "Seleziona una mansione", 3, "options", "formControlName", "disabled", "formGroup"]],
      template: function JobsSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, JobsSelectComponent_div_1_Template, 2, 4, "div", 1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx.jobs$));
        }
      },
      dependencies: [SelectComponent, CommonModule, i3.NgIf, i3.AsyncPipe, FormsModule, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, ReactiveFormsModule, i2$1.FormGroupDirective, i2$1.FormControlName],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobsSelectComponent, [{
    type: Component,
    args: [{
      selector: 'lib-jobs-select',
      standalone: true,
      imports: [SelectComponent, CommonModule, FormsModule, ReactiveFormsModule],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"d-flex flex-column mb-2\" [formGroup]=\"formGroup\">\n    <div *ngIf=\"jobs$ | async as jobs\">\n      <apss-select\n        label=\"Mansione\"\n        placeholder=\"Seleziona una mansione\"\n        [options]=\"getJobOptions(jobs)\"\n        [formControlName]=\"formControlName\"\n        [disabled]=\"disabled\"\n        [formGroup]=\"formGroup\">\n      </apss-select>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: ApssDataService
  }], {
    disabled: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    formGroup: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    formControlName: [{
      type: Input,
      args: [{
        required: true
      }]
    }]
  });
})();
class ProfileSelectComponent {
  constructor(apssDataService) {
    this.apssDataService = apssDataService;
    this.disabled = false;
    this.formControlName = '';
    this.profilesSubject = new BehaviorSubject([]);
    this.profiles$ = this.profilesSubject.asObservable();
  }
  ngOnInit() {
    this.apssDataService.getAllProfiles().then(profiles => {
      this.profilesSubject.next(profiles);
    }).catch(error => {
      console.error('Failed to load profiles', error);
    });
  }
  getProfileOptions(profiles) {
    return profiles.map(profile => ({
      value: profile.id,
      text: `${profile.name} - ${profile.description}`
    }));
  }
  static {
    this.ɵfac = function ProfileSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProfileSelectComponent)(i0.ɵɵdirectiveInject(ApssDataService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProfileSelectComponent,
      selectors: [["lib-profile-select"]],
      inputs: {
        disabled: "disabled",
        label: "label",
        formControlName: "formControlName",
        formGroup: "formGroup"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 4,
      consts: [[1, "d-flex", "flex-column", "mb-2", 3, "formGroup"], [4, "ngIf"], ["label", "Profilo Agid", "placeholder", "Seleziona un profilo", 3, "options", "formControlName", "disabled", "formGroup"]],
      template: function ProfileSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, ProfileSelectComponent_div_1_Template, 2, 4, "div", 1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx.profiles$));
        }
      },
      dependencies: [SelectComponent, CommonModule, i3.NgIf, i3.AsyncPipe, ReactiveFormsModule, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileSelectComponent, [{
    type: Component,
    args: [{
      selector: 'lib-profile-select',
      standalone: true,
      imports: [SelectComponent, CommonModule, ReactiveFormsModule],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"d-flex flex-column mb-2\" [formGroup]=\"formGroup\">\n    <div *ngIf=\"profiles$ | async as profiles\">\n      <apss-select\n        label=\"Profilo Agid\"\n        placeholder=\"Seleziona un profilo\"\n        [options]=\"getProfileOptions(profiles)\"  \n        [formControlName]=\"formControlName\"\n        [disabled]=\"disabled\"\n        [formGroup]=\"formGroup\">\n      </apss-select>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: ApssDataService
  }], {
    disabled: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    formControlName: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    formGroup: [{
      type: Input,
      args: [{
        required: true
      }]
    }]
  });
})();
class SitesSelectComponent {
  constructor(apssDataService) {
    this.apssDataService = apssDataService;
    this.disabled = false;
    this.formControlName = '';
    this.sitesSubject = new BehaviorSubject([]);
    this.sites$ = this.sitesSubject.asObservable();
  }
  ngOnInit() {
    this.apssDataService.getAllSites().then(entities => {
      this.sitesSubject.next(entities);
    }).catch(error => {
      console.error('Failed to load sites', error);
    });
  }
  // This method converts Site[] into SelectControlOption[]
  getSiteOptions(sites) {
    return sites.map(site => ({
      text: site.name,
      // The text that will be displayed
      value: site.id // The value bound to the form control
    }));
  }
  static {
    this.ɵfac = function SitesSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SitesSelectComponent)(i0.ɵɵdirectiveInject(ApssDataService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SitesSelectComponent,
      selectors: [["lib-sites-select"]],
      inputs: {
        disabled: "disabled",
        label: "label",
        formGroup: "formGroup",
        formControlName: "formControlName"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 4,
      consts: [[1, "d-flex", "flex-column", "mb-2", 3, "formGroup"], [4, "ngIf"], ["label", "Sede di Lavoro", "placeholder", "Seleziona una sede di lavoro", 3, "options", "formControlName", "disabled", "formGroup"]],
      template: function SitesSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, SitesSelectComponent_div_1_Template, 2, 4, "div", 1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx.sites$));
        }
      },
      dependencies: [SelectComponent, CommonModule, i3.NgIf, i3.AsyncPipe, FormsModule, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, ReactiveFormsModule, i2$1.FormGroupDirective, i2$1.FormControlName],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SitesSelectComponent, [{
    type: Component,
    args: [{
      selector: 'lib-sites-select',
      standalone: true,
      imports: [SelectComponent, CommonModule, FormsModule, ReactiveFormsModule],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"d-flex flex-column mb-2\" [formGroup]=\"formGroup\">\n    <div *ngIf=\"sites$ | async as sites\">\n      <apss-select\n        label=\"Sede di Lavoro\"\n        placeholder=\"Seleziona una sede di lavoro\"\n        [options]=\"getSiteOptions(sites)\"\n        [formControlName]=\"formControlName\"\n        [disabled]=\"disabled\"\n        [formGroup]=\"formGroup\">\n      </apss-select>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: ApssDataService
  }], {
    disabled: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    formGroup: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    formControlName: [{
      type: Input,
      args: [{
        required: true
      }]
    }]
  });
})();
const notificationInterceptor = (req, next) => {
  const notificationService = inject(ItNotificationService);
  const translateService = inject(TranslateService);
  const skipNotifications = req.context.get(NO_NOTIFICATIONS);
  return next(req).pipe(tap({
    next: event => {
      if (event instanceof HttpResponse && (req.method === 'PUT' || req.method === 'POST')) {
        if (event.status == 208) {
          console.debug('notificationInterceptor - 208');
          const errorMessage = translateService.instant('ui.notification.error.double');
          notificationService.warning(errorMessage);
        } else {
          if (skipNotifications) {
            console.debug('Context NO_NOTIFICATIONS rilevato, nessuna notifica mostrata.');
            return;
          }
          console.debug('notificationInterceptor - success');
          const successMessage = translateService.instant('ui.notification.success');
          notificationService.success(successMessage);
        }
      }
    },
    error: error => {
      console.debug(error);
    }
  }));
};
class CountryComponent {
  constructor(locationService) {
    this.locationService = locationService;
    this.countriesSubject = new BehaviorSubject([]);
    this.countries$ = this.countriesSubject.asObservable();
    // Funzioni per implementare ControlValueAccessor
    this.onChange = () => {};
    this.onTouched = () => {};
  }
  async ngOnInit() {
    await this.getCountry();
  }
  writeValue(value) {
    this.selectedCountry = value || '';
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    // Se necessario, gestisci lo stato disabilitato del controllo
  }
  // Funzione per recuperare la lista dei paesi
  getCountry() {
    return firstValueFrom(this.locationService.getCountry()).then(countries => {
      console.debug(countries);
      this.countriesSubject.next(countries);
    }).catch(err => {
      console.debug(err);
    });
  }
  // Quando l'utente seleziona un nuovo paese, aggiorna il valore del form
  onCountryChange(event) {
    this.selectedCountry = event;
    if (event !== 'I') {
      this.locationFormGroup.get('municipality')?.setValue('EE');
    } else {
      this.locationFormGroup.get('municipality')?.setValue('');
    }
    this.onChange(this.selectedCountry);
    this.onTouched();
  }
  static {
    this.ɵfac = function CountryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CountryComponent)(i0.ɵɵdirectiveInject(LocationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CountryComponent,
      selectors: [["lib-country"]],
      inputs: {
        selectedCountry: "selectedCountry",
        locationFormGroup: "locationFormGroup"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CountryComponent),
        multi: true
      }]), i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], ["id", "country-select", "label", "Nazione", 3, "ngModelChange", "ngModel", "ngModelOptions"], [3, "value"], [3, "value", "selected", 4, "ngFor", "ngForOf"], [3, "value", "selected"]],
      template: function CountryComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CountryComponent_div_0_Template, 5, 5, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.countries$));
        }
      },
      dependencies: [ItSelectComponent, FormsModule, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.NgControlStatus, i2$1.NgModel, CommonModule, i3.NgForOf, i3.NgIf, i3.AsyncPipe],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CountryComponent, [{
    type: Component,
    args: [{
      selector: 'lib-country',
      standalone: true,
      imports: [ItSelectComponent, FormsModule, CommonModule],
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CountryComponent),
        multi: true
      }],
      template: "<div *ngIf=\"countries$ | async as countries\">\n  <it-select\n    id=\"country-select\"\n    label=\"Nazione\"\n    [(ngModel)]=\"selectedCountry\"\n    (ngModelChange)=\"onCountryChange($event)\"\n    [ngModelOptions]=\"{standalone: true}\">\n    <option [value]=\"''\">Seleziona un paese</option>\n    <option *ngFor=\"let country of countries\" [value]=\"country.municipalityCode\" [selected]=\"country.municipalityCode == selectedCountry\">\n      {{ country.municipalityName }}\n    </option>\n  </it-select>\n</div>\n\n\n"
    }]
  }], () => [{
    type: LocationService
  }], {
    selectedCountry: [{
      type: Input
    }],
    locationFormGroup: [{
      type: Input
    }]
  });
})();
class MunicipalityComponent {
  constructor(locationService) {
    this.locationService = locationService;
    this.municipalitiesSubject = new BehaviorSubject([]);
    this.municipalities$ = this.municipalitiesSubject.asObservable();
    this.selectedPlace = '';
    this.selectedPlaceString = '';
    // Funzioni di ControlValueAccessor
    this.onChange = () => {};
    this.onTouched = () => {};
  }
  async ngOnInit() {
    await this.getMunicipality();
    console.debug('municipalityComponent: ' + this.selectedMunicipality);
  }
  async ngOnChanges(changes) {
    if (changes['selectedPlaceString'] && changes['selectedPlaceString'].currentValue) {
      const currentValue = changes['selectedPlaceString'].currentValue;
      // Verifica che currentValue sia una stringa e abbia più di 2 caratteri
      if (typeof currentValue === 'string' && currentValue.length > 2) {
        await this.getMunicipalityByLetters(currentValue);
      }
    }
  }
  // writeValue è chiamato quando Angular imposta il valore
  writeValue(value) {
    this.selectedPlace = value || '';
  }
  // registerOnChange viene chiamato da Angular per aggiornare il valore quando cambia
  registerOnChange(fn) {
    this.onChange = fn;
  }
  // registerOnTouched viene chiamato quando il controllo viene toccato
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    // Gestisci lo stato disabilitato, se necessario
  }
  // Quando l'utente cambia il comune selezionato, aggiorna il valore
  onMunicipalityChange(event) {
    this.selectedPlace = event;
    this.onChange(this.selectedPlace);
    this.onTouched();
  }
  // Metodo per ottenere la lista dei comuni e ordinarli per provincia
  getMunicipality() {
    return firstValueFrom(this.locationService.getMunicipality()).then(municipalities => {
      this.municipalitiesSubject.next(municipalities);
    }).catch(err => {
      console.debug(err);
    });
  }
  getMunicipalityByLetters(letters) {
    return firstValueFrom(this.locationService.getMunicipalityByLetters(letters)).then(municipalities => {
      this.municipalitiesSubject.next(municipalities);
    }).catch(err => {
      console.debug(err);
    });
  }
  static {
    this.ɵfac = function MunicipalityComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MunicipalityComponent)(i0.ɵɵdirectiveInject(LocationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MunicipalityComponent,
      selectors: [["lib-municipality"]],
      inputs: {
        selectedMunicipality: "selectedMunicipality",
        locationFormGroup: "locationFormGroup"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MunicipalityComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], ["id", "municipality-select", "label", "Comune", 3, "ngModelChange", "ngModel", "ngModelOptions"], [3, "value", "selected"], [3, "value", "selected", 4, "ngFor", "ngForOf"]],
      template: function MunicipalityComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MunicipalityComponent_div_0_Template, 2, 1, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.municipalities$));
        }
      },
      dependencies: [ItSelectComponent, FormsModule, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.NgControlStatus, i2$1.NgModel, CommonModule, i3.NgForOf, i3.NgIf, i3.AsyncPipe],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MunicipalityComponent, [{
    type: Component,
    args: [{
      selector: 'lib-municipality',
      standalone: true,
      imports: [ItSelectComponent, FormsModule, CommonModule],
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MunicipalityComponent),
        multi: true
      }],
      template: "<div *ngIf=\"municipalities$ | async as municipalities\">\n    <div *ngIf=\"municipalities.length > 0\">\n        <it-select\n            id=\"municipality-select\"\n            label=\"Comune\"\n            [(ngModel)]=\"selectedPlace\"\n            (ngModelChange)=\"onMunicipalityChange($event)\"\n            [ngModelOptions]=\"{standalone: true}\">\n            <option [value]=\"''\" [selected]=\"selectedPlace === '' || selectedPlace === 'EE'\">Seleziona un comune</option>\n            <option *ngFor=\"let municipality of municipalities\" [value]=\"municipality.municipalityCode\" [selected]=\"municipality.municipalityCode == selectedMunicipality\">\n            {{ municipality.municipalityName }} ({{ municipality.province }})\n            </option>\n        </it-select>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: LocationService
  }], {
    selectedMunicipality: [{
      type: Input
    }],
    locationFormGroup: [{
      type: Input
    }]
  });
})();
class NationalityComponent {
  constructor(locationService) {
    this.locationService = locationService;
    this.countriesSubject = new BehaviorSubject([]);
    this.countries$ = this.countriesSubject.asObservable();
    // Funzioni di ControlValueAccessor
    this.onChange = () => {};
    this.onTouched = () => {};
  }
  async ngOnInit() {
    await this.getCountry();
  }
  // writeValue viene chiamato quando Angular imposta il valore nel controllo
  writeValue(value) {
    this.selectedNationality = value || '';
  }
  // registerOnChange viene chiamato da Angular per aggiornare il valore quando cambia
  registerOnChange(fn) {
    this.onChange = fn;
  }
  // registerOnTouched viene chiamato quando il controllo viene toccato
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    // Se necessario, gestisci lo stato disabilitato del controllo
  }
  // Quando l'utente seleziona una nuova nazionalità, aggiorna il valore
  onCountryChange(event) {
    this.selectedNationality = event;
    this.locationFormGroup.get('nationality')?.setValue(event);
    this.onChange(this.selectedNationality);
    this.onTouched();
  }
  // Funzione per recuperare la lista delle nazionalità (paesi)
  getCountry() {
    return firstValueFrom(this.locationService.getCountry()).then(countries => {
      console.debug(countries);
      this.countriesSubject.next(countries);
    }).catch(err => {
      console.debug(err);
    });
  }
  static {
    this.ɵfac = function NationalityComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NationalityComponent)(i0.ɵɵdirectiveInject(LocationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NationalityComponent,
      selectors: [["lib-nationality"]],
      inputs: {
        selectedNationality: "selectedNationality",
        locationFormGroup: "locationFormGroup"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NationalityComponent),
        multi: true
      }]), i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], ["id", "nationality-select", "label", "Nazionalit\xE0", 3, "ngModelChange", "ngModel", "ngModelOptions"], [3, "value"], [3, "value", "selected", 4, "ngFor", "ngForOf"], [3, "value", "selected"]],
      template: function NationalityComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NationalityComponent_div_0_Template, 5, 5, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.countries$));
        }
      },
      dependencies: [ItSelectComponent, FormsModule, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.NgControlStatus, i2$1.NgModel, CommonModule, i3.NgForOf, i3.NgIf, i3.AsyncPipe],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NationalityComponent, [{
    type: Component,
    args: [{
      selector: 'lib-nationality',
      standalone: true,
      imports: [ItSelectComponent, FormsModule, CommonModule],
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NationalityComponent),
        multi: true
      }],
      template: "<div *ngIf=\"countries$ | async as countries\">\n    <it-select\n      id=\"nationality-select\"\n      label=\"Nazionalit\u00E0\"\n      [(ngModel)]=\"selectedNationality\"\n      (ngModelChange)=\"onCountryChange($event)\"\n      [ngModelOptions]=\"{standalone: true}\">\n      <option [value]=\"''\">Seleziona una nazionalit\u00E0</option>\n      <option *ngFor=\"let country of countries\" [value]=\"country.id\" [selected]=\"country.id == selectedNationality\">\n        {{ country.municipalityName }}\n      </option>\n    </it-select>\n</div>\n\n"
    }]
  }], () => [{
    type: LocationService
  }], {
    selectedNationality: [{
      type: Input
    }],
    locationFormGroup: [{
      type: Input
    }]
  });
})();
class LocationComponent {
  constructor(fb, cd) {
    this.fb = fb;
    this.cd = cd;
    this.nationality = false;
  }
  ngOnInit() {
    // Se il FormGroup non ha i controlli richiesti, li aggiunge
    if (this.nationality) {
      if (!this.locationFormGroup.get('nationality')) {
        this.locationFormGroup.addControl('nationality', this.fb.control(''));
      }
    }
    if (!this.locationFormGroup.get('country')) {
      this.locationFormGroup.addControl('country', this.fb.control(''));
    }
    if (!this.locationFormGroup.get('municipality')) {
      this.locationFormGroup.addControl('municipality', this.fb.control(''));
    }
    if (this.selectedMunicipality) {
      this.locationFormGroup.get('municipality')?.setValue(this.selectedMunicipality);
    }
    if (this.selectedNationality) {
      this.locationFormGroup.get('nationality')?.setValue(this.selectedNationality);
    }
    if (this.selectedCountry) {
      this.locationFormGroup.get('country')?.setValue(this.selectedCountry);
    }
    // Non c'è bisogno di EventEmitter, ogni cambiamento aggiornerà automaticamente il FormGroup
  }
  // I metodi seguenti aggiornano i campi del FormGroup senza EventEmitter
  onCountryChange(event) {
    this.locationFormGroup.get('country')?.setValue(event);
    this.selectedCountry = event;
  }
  onNationalityChange(event) {
    this.selectedNationality = event;
    this.locationFormGroup.get('nationality')?.setValue(event);
  }
  onMunicipalityChange(event) {
    this.locationFormGroup.get('municipality')?.setValue(event);
    this.selectedMunicipality = event;
  }
  static {
    this.ɵfac = function LocationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LocationComponent)(i0.ɵɵdirectiveInject(i2$1.FormBuilder), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LocationComponent,
      selectors: [["lib-location-component"]],
      inputs: {
        locationFormGroup: "locationFormGroup",
        selectedMunicipality: "selectedMunicipality",
        selectedCountry: "selectedCountry",
        selectedNationality: "selectedNationality",
        nationality: "nationality"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 2,
      consts: [[3, "formGroup"], ["class", "d-flex flex-wrap input-gap", 4, "ngIf"], [1, "d-flex", "flex-wrap", "input-gap"], ["formControlName", "nationality", 3, "selectedNationality", "locationFormGroup"], ["formControlName", "country", 3, "countriesEmit", "selectedCountry", "locationFormGroup"], ["formControlName", "municipality", 3, "selectedMunicipality"], ["formControlName", "nationality", 3, "nationalityEmit", "selectedNationality", "locationFormGroup"]],
      template: function LocationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, LocationComponent_div_1_Template, 5, 6, "div", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.locationFormGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.locationFormGroup);
        }
      },
      dependencies: [CountryComponent, MunicipalityComponent, NationalityComponent, ReactiveFormsModule, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, CommonModule, i3.NgIf],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocationComponent, [{
    type: Component,
    args: [{
      selector: 'lib-location-component',
      standalone: true,
      imports: [CountryComponent, MunicipalityComponent, NationalityComponent, ReactiveFormsModule, CommonModule],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div [formGroup]=\"locationFormGroup\">\n    <div *ngIf=\"locationFormGroup\" class=\"d-flex flex-wrap input-gap\">\n        @if(nationality){\n            <lib-nationality formControlName=\"nationality\" (nationalityEmit)=\"onNationalityChange($event)\" [selectedNationality]=\"this.locationFormGroup.get('nationality')?.value\" [locationFormGroup]=\"locationFormGroup\"></lib-nationality>\n        }\n        \n        <lib-country formControlName=\"country\" (countriesEmit)=\"onCountryChange($event)\" [selectedCountry]=\"this.locationFormGroup.get('country')?.value\" [locationFormGroup]=\"locationFormGroup\"></lib-country>\n    \n        <!-- Mostra il MunicipalityComponent solo quando il country \u00E8 \"1\" -->\n        <div [style.display]=\"locationFormGroup.get('country')?.value === 'I'? 'block' : 'none'\">\n            <lib-municipality formControlName=\"municipality\" (selectedMunicipality)=\"onMunicipalityChange($event)\" [selectedMunicipality]=\"this.locationFormGroup.get('municipality')?.value\"></lib-municipality>\n        </div>\n        <!-- <div [style.display]=\"locationFormGroup.get('country')?.value === '1'? 'block' : 'none'\">\n            <lib-municipality-input formControlName=\"municipality\" (selectedMunicipality)=\"onMunicipalityChange($event)\"></lib-municipality-input>\n        </div> -->\n    </div>\n</div>\n\n\n\n\n\n"
    }]
  }], () => [{
    type: i2$1.FormBuilder
  }, {
    type: i0.ChangeDetectorRef
  }], {
    locationFormGroup: [{
      type: Input
    }],
    selectedMunicipality: [{
      type: Input
    }],
    selectedCountry: [{
      type: Input
    }],
    selectedNationality: [{
      type: Input
    }],
    nationality: [{
      type: Input
    }]
  });
})();
class CodiceFiscaleComponent {
  constructor() {
    this.label = 'Codice Fiscale*';
    this.placeholder = 'Inserisci codice fiscale';
    this.onTouched = () => {};
    this.onChange = value => {};
  }
  get control() {
    return this.formGroup.controls[this.formControlName];
  }
  // Implementazione di ControlValueAccessor
  writeValue(value) {
    if (value) {
      this.control.setValue(value, {
        emitEvent: false
      });
    }
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }
  // Implementazione Validator
  validate(control) {
    return fiscalCodeValidator()(control);
  }
  static {
    this.ɵfac = function CodiceFiscaleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CodiceFiscaleComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CodiceFiscaleComponent,
      selectors: [["app-fiscal-code-input"]],
      inputs: {
        label: "label",
        placeholder: "placeholder",
        formGroup: "formGroup",
        formControlName: "formControlName"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CodiceFiscaleComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => CodiceFiscaleComponent),
        multi: true
      }]), i0.ɵɵStandaloneFeature],
      decls: 4,
      vars: 9,
      consts: [[3, "label", "placeholder", "type", "formControl", "ngClass"], ["error", ""], [4, "ngIf"]],
      template: function CodiceFiscaleComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "it-input", 0);
          i0.ɵɵelementContainerStart(1, 1);
          i0.ɵɵtemplate(2, CodiceFiscaleComponent_div_2_Template, 2, 0, "div", 2)(3, CodiceFiscaleComponent_div_3_Template, 2, 1, "div", 2);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("label", ctx.label)("placeholder", ctx.placeholder)("type", "text")("formControl", ctx.control)("ngClass", i0.ɵɵpureFunction1(7, _c7, ctx.control.invalid && (ctx.control.dirty || ctx.control.touched)));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.control.hasError("required"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.control.hasError("invalidFiscalCode"));
        }
      },
      dependencies: [ItInputComponent, CommonModule, i3.NgClass, i3.NgIf, ReactiveFormsModule, i2$1.NgControlStatus, i2$1.FormControlDirective, FormsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CodiceFiscaleComponent, [{
    type: Component,
    args: [{
      selector: 'app-fiscal-code-input',
      standalone: true,
      imports: [ItInputComponent, CommonModule, ReactiveFormsModule, FormsModule],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CodiceFiscaleComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => CodiceFiscaleComponent),
        multi: true
      }],
      template: "<it-input\n  [label]=\"label\"\n  [placeholder]=\"placeholder\"\n  [type]=\"'text'\"\n  [formControl]=\"control\"\n  [ngClass]=\"{ 'is-invalid': control.invalid && (control.dirty || control.touched) }\"\n>\n  <ng-container error>\n    <div *ngIf=\"control.hasError('required')\">Il campo \u00E8 obbligatorio.</div>\n    <div *ngIf=\"control.hasError('invalidFiscalCode')\">\n      {{ control.getError('invalidFiscalCode') }}\n    </div>\n  </ng-container>\n</it-input>\n"
    }]
  }], null, {
    label: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    formGroup: [{
      type: Input
    }],
    formControlName: [{
      type: Input
    }]
  });
})();
class HelpComponentComponent {
  static {
    this.ɵfac = function HelpComponentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HelpComponentComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HelpComponentComponent,
      selectors: [["lib-help-component"]],
      inputs: {
        helpText: "helpText"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c0,
      decls: 4,
      vars: 1,
      consts: [[1, "position-relative"], ["tooltipPlacement", "right", 1, "material-symbols-outlined", "position-absolute", "help-position", 3, "itTooltip"]],
      template: function HelpComponentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
          i0.ɵɵtext(2, "info");
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("itTooltip", ctx.helpText);
        }
      },
      dependencies: [ItTooltipDirective],
      styles: [".help-position[_ngcontent-%COMP%]{position:absolute;top:-1rem;right:0;transform:translateY(-50%);z-index:1;cursor:pointer;color:#6c757d}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpComponentComponent, [{
    type: Component,
    args: [{
      selector: 'lib-help-component',
      standalone: true,
      imports: [ItTooltipDirective],
      template: "<div class=\"position-relative\">\n    <span class=\"material-symbols-outlined position-absolute help-position\" [itTooltip]=\"helpText\" tooltipPlacement=\"right\">info</span>\n    <ng-content></ng-content>\n</div>\n",
      styles: [".help-position{position:absolute;top:-1rem;right:0;transform:translateY(-50%);z-index:1;cursor:pointer;color:#6c757d}\n"]
    }]
  }], null, {
    helpText: [{
      type: Input
    }]
  });
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ApssDataService, ApssMainAppComponent, AsideComponent, AuthGuard, BasePageComponent, BreadcrumbComponent, ButtonComponent, CardComponent, ChipComponent, CodiceFiscaleComponent, CountrySelectComponent, DeniedAccesPageComponent, DeniedAccessModule, EntitySelectComponent, ErrorMessagesService, HeaderComponent, HeadingPageComponent, HelpComponentComponent, JobsSelectComponent, Location, LocationComponent, LocationService, Microservice, Module, ModuleService, ModulesSubjectService, MultiButtonComponent, MunicipalityInputComponent, MunicipalitySelectComponent, MunicipalityValidatorService, NO_NOTIFICATIONS, Page404Component, Page404Module, Page404Routes, Page404authenticatorComponent, PermissionGuard, PolifunzioneLibComponent, PolifunzioneLibModule, PolifunzioneLibService, ProfileSelectComponent, ProvinceSelectComponent, ReturnedRole, Role, RoleService, SitesSelectComponent, TableComponent, TokenStorageService, errorHandlerInterceptor, fiscalCodeValidator, initializeErrorMessages, notificationInterceptor, provideDynamicTranslateLoader };
